import React , { useEffect } from "react";
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import { LinearProgress, Box, Fab, Tooltip, Modal, Fade, TextField, Backdrop, Typography, Breadcrumbs, Accordion, AccordionSummary, AccordionDetails, 
  Stepper, Step, StepLabel, List, ListItem, ListItemText, Divider, MenuItem} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Support from '../../components/support/Support';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AssistantIcon from '@mui/icons-material/Assistant';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import MultilineChartIcon from '@mui/icons-material/MultilineChart';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import SettingsApplicationIcon from '@mui/icons-material/SettingsApplications';
import CustomTabs from "../../components/CustomTabs/CustomTabs.jsx";
import Skeleton from "@mui/material/Skeleton"
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody";
import { useTheme } from "@mui/material/styles";
import Button from "../../components/CustomButtons/Button.jsx";
import {useSelector, useDispatch} from 'react-redux';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from 'draft-js';
import { mongoUrl } from '../../components/shared/mongoUrl.js';
import { baseUrl } from '../../components/shared/baseUrl';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {motion, useCycle, AnimatePresence} from 'framer-motion';
import { upCount, finCount } from "../../reducers/actionCreators";
import {
  successColor,
  whiteColor,
  grayColor,
  hexToRgb
} from "../../components/assets/jss/material-dashboard-react.js";





const styles = (theme) =>({
   cardTitle: {
        color: 'blue',
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
          color: grayColor[1],
          fontWeight: "400",
          lineHeight: "1"
        }
      },
     cardCategory: {
        color: grayColor[0],
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        paddingTop: "10px",
        marginBottom: "0"
      },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily:"'Oswald'",
    marginBottom: "3px",
    textDecoration: "none",
    textAlign:'center'
  },
  styleChatbutton: {
    color: "black",
    padding: "16px 20px",
    border: "none",
    cursor: "pointer",
    opacity: "0.8",
    position: "fixed",
    zIndex: "10 !important",
    bottom: "23px",
    right: "28px",
    fontWeight: "300",
  },
  chatClose: {
    position: "fixed",
    zIndex: "10 !important",
    bottom: "485px",
    right: "20px",
  },
  chatContainer: {
    zIndex: "10 !important",
    position: "fixed",
    bottom: "110px",
    right: "22px",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    fontFamily:"'Lucida Handwriting', 'Brush Script MT'"

  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    fontFamily:"'Lucida Console', 'monospace'"

  },
  fontCursive: {
    fontFamily:"'Lucida Handwriting', 'Cursive'"
  },
  fontBrush: {
    fontFamily:"'Brush Script MT', 'Cursive'"
  },
  fontGaramond: {
    fontFamily:"'Garamond', 'Serif'"
  },
  fontCourier:{
    fontFamily:"'Courier New', 'monospace'"
  },
  fontLucida:{
    fontFamily:"'Lucida Console', 'monospace'"
  },
  fontPapyrus:{
    fontFamily:"'Papyrus','Fantasy'"
  },
  fontMonaco:{
    fontFamily:"'Monaco','monospace'"
  },
  deco:{
    fontFamily:"'Papyrus','Fantasy'"
  },
  abs:{
    fontFamily:"'Monaco','monospace'"
  },
  algo: {
    fontFamily:"'Lucida Handwriting', 'Cursive'"
  },
  pat:{
    fontFamily:"'Courier New', 'monospace'"
  },
  ana:{
    fontFamily:"'Lucida Console', 'monospace'"
  },
  modal: {
    //display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position:'absolute',
    top:'20%',
    left:'10%',
    overflowY:'scroll',
    height:'100%',
    display:'block'
  },
  modal1:{
    position: 'relative',
    maxWidth: '1000px',
    margin : '0 auto',
    padding: '20px 20px 20px 20px',
    background: "rgba(0,0,0,0.5)",
    backgroundColor: 'white',
    borderRadius:'10 px',
    textAlign:'center',
    zIndex: 10

  },
  modal2:{
    position: 'relative',
    maxWidth: '700px',
    margin : '0 auto',
    padding: '10px 10px 10px 10px',
    background: "rgba(0,0,0,0.5)",
    backgroundColor: 'white',
    borderRadius:'10 px',
    textAlign:'center',
    zIndex: 10

  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: 1000,

  },
  messageArea: {
    height: '40vh',
    overflowY: 'auto'
  },
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: "rgba(0,0,0,0.5)",
    zIndex: 10
  }
});

var numberList = [
{ label: 'none', value: ''},{ label: 0, value: 0 },{ label: 1, value: 1 },{ label: 2, value: 2}, { label: 3, value: 3},   { label: 4, value: 4},  { label: 5, value: 5}, { label: 6, value: 6},
  { label: 7, value: 7}, { label: 8, value: 8}, { label: 9, value: 9}, { label: 10, value: 10}, { label: 11, value: 11}, { label: 12, value: 12}
  , { label: 13, value: 13}, { label: 14, value: 14}, { label: 15, value: 15}, { label: 16, value: 16}, { label: 17, value: 17}, { label: 18, value: 18}
  , { label: 19, value: 19}, { label: 20, value: 20}, { label: 21, value: 21}, { label: 22, value: 22}, { label: 23, value: 23}, { label: 24, value: 24}
  , { label: 25, value: 25}, { label: 26, value: 26}, { label: 27, value: 27}, { label: 28, value: 28}, { label: 29, value: 29}
  , { label: 30, value: 30}, { label: 31, value: 31}, { label: 32, value: 32}, { label: 33, value: 33}, { label: 34, value: 34}, { label: 35, value: 35}
  , { label: 36, value: 36}, { label: 37, value: 37}, { label: 38, value: 38}, { label: 39, value: 39}, { label: 40, value: 40}
  , { label: 41, value: 41}, { label: 42, value: 42}, { label: 43, value: 43}, { label: 44, value: 44}, { label: 45, value: 45}
  , { label: 46, value: 46}, { label: 47, value: 47}, { label: 48, value: 48}, { label: 49, value: 49}, { label: 50, value: 50}
  , { label: 51, value: 51}, { label: 52, value: 52}, { label: 53, value: 53}, { label: 54, value: 54}, { label: 55, value: 55}
  , { label: 56, value: 56}, { label: 57, value: 57}, { label: 58, value: 58}, { label: 59, value: 59}, { label: 60, value: 60}
  , { label: 61, value: 61}, { label: 62, value: 62}, { label: 63, value: 63}, { label: 64, value: 64}, { label: 65, value: 65}
  , { label: 66, value: 66}, { label: 67, value: 67}, { label: 68, value: 68}, { label: 69, value: 69}, { label: 70, value: 70}
  , { label: 71, value: 71}, { label: 72, value: 72}, { label: 73, value: 73}, { label: 74, value: 74}, { label: 75, value: 75}
  , { label: 76, value: 76}, { label: 77, value: 77}, { label: 78, value: 78}, { label: 79, value: 79}, { label: 80, value: 80}
  , { label: 81, value: 81}, { label: 82, value: 82}, { label: 83, value: 83}, { label: 84, value: 84}, { label: 85, value: 85}
  , { label: 86, value: 86}, { label: 87, value: 87}, { label: 88, value: 88}, { label: 89, value: 89}, { label: 90, value: 90}
  , { label: 91, value: 91}, { label: 92, value: 92}, { label: 93, value: 93}, { label: 94, value: 94}, { label: 95, value: 95}
  , { label: 96, value: 96}, { label: 97, value: 97}, { label: 98, value: 98}, { label: 99, value: 99}, { label: 100, value: 100}
  , { label: 101, value: 101}, { label: 102, value: 102}, { label: 103, value: 103}, { label: 104, value: 104}, { label: 105, value: 105}
  , { label: 106, value: 106}, { label: 107, value: 107}, { label: 108, value: 108}, { label: 109, value: 109}, { label: 110, value: 110}
  , { label: 111, value: 111}, { label: 112, value: 112}, { label: 113, value: 113}, { label: 114, value: 114}, { label: 115, value: 115}
  , { label: 116, value: 116}, { label: 117, value: 117}, { label: 118, value: 118}, { label: 119, value: 119}, { label: 120, value: 120}
  , { label: 121, value: 121}, { label: 122, value: 122}, { label: 123, value: 123}, { label: 124, value: 124}, { label: 125, value: 125}
  , { label: 126, value: 126}, { label: 127, value: 127}, { label: 128, value: 128}, { label: 129, value: 129}, { label: 130, value: 130}
  , { label: 131, value: 131}, { label: 132, value: 132}, { label: 133, value: 133}, { label: 134, value: 134}, { label: 135, value: 135}
  , { label: 136, value: 136}, { label: 137, value: 137}, { label: 138, value: 138}, { label: 139, value: 139}, { label: 140, value: 140}
  , { label: 141, value: 141}, { label: 142, value: 142}, { label: 143, value: 143}, { label: 144, value: 144}, { label: 145, value: 145}
  , { label: 146, value: 146}, { label: 147, value: 147}, { label: 148, value: 148}, { label: 149, value: 149}, { label: 150, value: 150}
  
];

var numberFiboList = [
    { label: 'none', value: ''},{ label: 'fibo1=1', value: 1 },{ label: 'fibo2=1', value: 1 },{ label: 'fibo3=2', value: 2}, { label: 'fibo4=3', value: 3}, { label: 'fibo5=5', value: 5}, { label: 'fibo6=8', value: 8}, { label: 'fibo7=13', value: 13},
    { label: 'fibo8=21', value: 21}, { label: 'fibo9=34', value: 34}, { label: 'fibo10=55', value: 55}, { label: 'fibo11=89', value: 89}, { label: 'fibo12=144', value: 144},
    { label: 1, value: 1 },{ label: 2, value: 2}, { label: 3, value: 3},   { label: 4, value: 4}, { label: 6, value: 6},
    { label: 7, value: 7}, { label: 9, value: 9}, { label: 10, value: 10}, { label: 11, value: 11}, { label: 12, value: 12}
    , { label: 14, value: 14}, { label: 15, value: 15}, { label: 16, value: 16}, { label: 17, value: 17}, { label: 18, value: 18}
    , { label: 19, value: 19}, { label: 20, value: 20}, { label: 22, value: 22}, { label: 23, value: 23}, { label: 24, value: 24}
    , { label: 25, value: 25}, { label: 26, value: 26}, { label: 27, value: 27}, { label: 28, value: 28}, { label: 29, value: 29}
    , { label: 30, value: 30}, { label: 31, value: 31}, { label: 32, value: 32}, { label: 33, value: 33}, { label: 35, value: 35}
    , { label: 36, value: 36}, { label: 37, value: 37}, { label: 38, value: 38}, { label: 39, value: 39}, { label: 40, value: 40}
    , { label: 41, value: 41}, { label: 42, value: 42}, { label: 43, value: 43}, { label: 44, value: 44}, { label: 45, value: 45}
    , { label: 46, value: 46}, { label: 47, value: 47}, { label: 48, value: 48}, { label: 49, value: 49}, { label: 50, value: 50}
    ];

    var cla = {
      "_id":"6006f33eef2c0d65ccbf6601",
      "title": "Class IX",
      "teacherId":"5fe192d970d8c633c005da24"
    }

var bracketList = [
  { label: '(', value: '(' },
  { label: ')', value: ')'}
];

var standard = [
  { label: 'increases', value: 'increases' },
  { label: 'decreases', value: 'decreases'},
  { label: 'noChange', value: 'noChange'}
];
var pairList = [
  { label: 'index1=12', value: 12 },
  { label: 'index2=17', value: 17 },
  { label: 'index3=24', value: 24 },
  { label: 'index4=27', value: 27 },
  { label: 'index5=33', value: 33 },
  { label: 'index6=37', value: 37}
];
var nVarList = [
  {label: 'n', value: 'n'},
  {label: 'none', value: ''}
]

var textAlgoList = [
  {label: 'input', value: 'input'},
  {label: 'output', value: 'output'},
  {label: 'define', value: 'define'},
  {label: 'set', value: 'set'},
  {label: 'to', value: 'to'},
  {label: 'output', value: 'output'}
]

var compareList = [
  { label: 'isequalTo(==)', value: '==' },
  { label: 'notEqualTo(!=)', value: '!=' },
  { label: 'greaterThan(>)', value: '>' },
  { label: 'lessThan(<)', value: '<' },
]


var operatorList = [
  { label: 'add(+)', value: '+' },
  { label: 'subtract(-)', value: '-'},
  { label: 'multiply(*)', value: '*'},
  { label: 'divide(/)', value: '/'},
  { label: 'remainder(%)', value: '%'},
  { label: 'none', value: ''}
];
var fibList = [
    { label: 'none', value: ''},{ label: 'Fib(n-2)', value:21 },
    { label: 'Fib(n-1)', value: 34},{ label: 'Fib(n)', value: 55},
    { label: 'Fib(n+1)', value: 89},{ label: 'Fib(n+2)', value: 144},
    { label: 1, value: 1 },{ label: 2, value: 2}, 
    { label: 3, value: 3},   { label: 4, value: 4}, { label: 6, value: 6},
    { label: 7, value: 7}, { label: 9, value: 9}, { label: 10, value: 10}
  ];

  var fibSumList = [
    { label: 'none', value: ''},{ label: 'Fib(n-2)', value: 'Fib(n-2)' },
    { label: 'Fib(n-1)', value: 'Fib(n-1)'},{ label: 'Fib(n)', value: 'Fib(n)'},
    { label: 'Fib(n+1)', value: 'Fib(n+1)'},{ label: 'Fib(n+2)', value: 'Fib(n+2)'},
    { label: 1, value: 1 },{ label: 2, value: 2}, 
    { label: 3, value: 3},   { label: 4, value: 4}, { label: 6, value: 6},
    { label: 7, value: 7}, { label: 9, value: 9}, { label: 10, value: 10}
  ];

  var fibNewList = [
    { label: 'none', value: ''},{ label: 'Fib(n-3)', value: 'Fib(n-3)' },{ label: 'Fib(n-2)', value: 'Fib(n-2)' },
    { label: 'Fib(n-1)', value: 'Fib(n-1)'},{ label: 'Fib(n-4)', value: 'Fib(n-4)'},{ label: 'Fib(n-5)', value: 'Fib(n-5)'},
    { label: 1, value: 1 },{ label: 2, value: 2},{ label: 3, value: 3},   { label: 4, value: 4},{ label: 5, value: 5}, 
    { label: 6, value: 6},{ label: 7, value: 7},{ label: 8, value: 8}, { label: 9, value: 9}, { label: 10, value: 10}
  ];

var termList = [
  { label: '... upto 60 terms', value: '... upto 60 terms' },
  { label: '... upto 30 terms', value: '... upto 30 terms'},
  { label: '... upto 20 terms', value: '... upto 20 terms'},
  { label: 'none', value: ''}
];

var alternateList = [
  { label: 'Individual addition', value: 'Individual addition' },
  { label: 'Pairwise addition', value: 'Pairwise addition'}
];

var task = ['Find a way to add pair of numbers among 12, 17, 24, 27, 33, 37 using the index of each number and their difference with 55', 'Identify index change and find a pair closest to 55',
 'Write a general method to calculate pairs closest to 55', 'Write an algorithm to find pair of numbers closest to n=55',
'Analyse the algorithm to count maximum number of operations(+,-,*,/,increment,decrement) used in algorithm and total extra variables defined in the algorithm', 'Write an algorithm to find pair of numbers closest to n=55 ', 'Compare the solutions (click to select a solution)']


function getSteps() {
  return ['Decomposition', 'Pattern Recognition', 'Abstraction', 'Algorithm design', 'Analysis of Algorithm', 'Solution', 'Comparison'];
}

const hintsActivity1 = [
  { step: 'Decomposition'},
  { step: 'Pattern recognition'},
  { step: 'Abstraction' },
  { step: 'Algorithm design'},
  { step: 'Analysis of Algorithm' },
  { step: 'Final solution'},
  { step: 'Comparison'}
]


const firstStep = () =>{

  return(
    <p> First step</p>
  );
};




export default function Fibonacci(props){
    const [module, setmodule] = React.useState('');
    var interval = null
    const [clas, setclas] = React.useState([]);
    const [loading, setloading] = React.useState(true);
    const [loadhint, setloadhint] = React.useState(false);
    const [myCount, setmyCount] = React.useState(10);
    const [isSubmit, setisSubmit] = React.useState(false);
    const [myDecoCount, setmyDecoCount] = React.useState(10);
    const [finalCount, setfinalCount] = React.useState(19);
    const [Num, setNum] = React.useState(1);
    const theme = useTheme()
    const classes =styles(theme);
    const [loadsupport, setloadsupport] = React.useState(false);
    const user = useSelector(state => state.user)
    const dispatch = useDispatch();
    const [editorState, seteditorState]= React.useState(EditorState.createEmpty())
    const [loadintro, setloadintro] = React.useState(true);
    const [error, seterror] = React.useState('');
    const [expanded, setExpanded] = React.useState(false);
    const [expanded1, setExpanded1] = React.useState(false); 
    const [addition, setaddition] = React.useState('Individual addition');
    const [termsum, settermsum] = React.useState('0');  
    const [num1, setnum1] = React.useState('0');
    const [num2, setnum2] = React.useState('0');
    const [num3, setnum3] = React.useState('0');
    const [num4, setnum4] = React.useState('0');
    const [num5, setnum5] = React.useState('0');
    const [num6, setnum6] = React.useState('0');
    const [num7, setnum7] = React.useState('0');
    const [num8, setnum8] = React.useState('0');
    const [num9, setnum9] = React.useState('0');
    const [num10, setnum10] = React.useState('0');
    const [num11, setnum11] = React.useState('0');
    const [num12, setnum12] = React.useState('0');
    const [mydata, setmydata] = React.useState('');
    const [totaldata, settotaldata] = React.useState('')
    const [mydeco, setmydeco] = React.useState('');
    const [patnum, setpatnum] = React.useState('');
    const [patnum1, setpatnum1] = React.useState('');
    const [patnum2, setpatnum2] = React.useState('');
    const [patnum3, setpatnum3] = React.useState('');
    const [patnum4, setpatnum4] = React.useState('');
    const [patnum5, setpatnum5] = React.useState('');
    const [patnum6, setpatnum6] = React.useState('');
    const [patnum7, setpatnum7] = React.useState('');
    const [patnum8, setpatnum8] = React.useState('');
    const [patnum9, setpatnum9] = React.useState('');
    const [mypattern, setmypattern] = React.useState('');
    const [myabstract, setmyabstract] = React.useState('');
    const [abs1, setabs1] = React.useState('');
    const [abs2, setabs2] = React.useState('');
    const [abs3, setabs3] = React.useState('');
    const [abs4, setabs4] = React.useState('');
    const [abs5, setabs5] = React.useState('');
    const [abs6, setabs6] = React.useState('');
    const [abs7, setabs7] = React.useState('');
    const [abs8, setabs8] = React.useState('');
    const [abs9, setabs9] = React.useState('');
    const [abs10, setabs10] = React.useState('');
    const [abs11, setabs11] = React.useState('');
    const [abs12, setabs12] = React.useState('');
    const [abs13, setabs13] = React.useState('');
    const [abs14, setabs14] = React.useState('');
    const [abs15, setabs15] = React.useState('');
    const [abs16, setabs16] = React.useState('');
    const [abs17, setabs17] = React.useState('');
    const [abs18, setabs18] = React.useState('');
    const [myabs1, setmyabs1] = React.useState('');
    const [myabs2, setmyabs2] = React.useState('');
    const [absNum, setabsNum] = React.useState(55);
    const [algo, setalgo] = React.useState('');
    const [algo1, setalgo1] = React.useState('');
    const [algo2, setalgo2] = React.useState('');
    const [algo3, setalgo3] = React.useState('');
    const [algo4, setalgo4] = React.useState('');
    const [algo5, setalgo5] = React.useState('');
    const [algo6, setalgo6] = React.useState('');
    const [algo7, setalgo7] = React.useState('');
    const [algo8, setalgo8] = React.useState('');
    const [algo9, setalgo9] = React.useState('');
    const [algo10, setalgo10] = React.useState('');
    const [algo11, setalgo11] = React.useState('');
    const [algo12, setalgo12] = React.useState('');
    const [algo13, setalgo13] = React.useState('');
    const [algo14, setalgo14] = React.useState('');
    const [algo15, setalgo15] = React.useState('');
    const [algo16, setalgo16] = React.useState('');
    const [algo17, setalgo17] = React.useState('');
    const [algo18, setalgo18] = React.useState('');
    const [algo19, setalgo19] = React.useState('');
    const [algo20, setalgo20] = React.useState('');
    const [algo21, setalgo21] = React.useState('');
    const [algo22, setalgo22] = React.useState('');
    const [algo23, setalgo23] = React.useState('');
    const [algo24, setalgo24] = React.useState('');
    const [algo25, setalgo25] = React.useState('');
    const [myalgo, setmyalgo] = React.useState('');
    const [myalgo1, setmyalgo1] = React.useState('n');
    const [myalgo2, setmyalgo2] = React.useState('');
    const [myalgo3, setmyalgo3] = React.useState('');
    const [myalgo4, setmyalgo4] = React.useState('');
    const [myalgo5, setmyalgo5] = React.useState('');
    const [myalgo6, setmyalgo6] = React.useState('');
    const [myalgo7, setmyalgo7] = React.useState('');
    const [myalgo8, setmyalgo8] = React.useState('');
    const [myalgo9, setmyalgo9] = React.useState('');

    const [myanalysis, setmyanalysis] = React.useState('');
    const [mytime, setmytime] = React.useState('');
    const [myspace, setmyspace] = React.useState('');
    const [mycomsol, setmycomsol] = React.useState('');
    const [mycomsol1, setmycomsol1] = React.useState('');
    const [mycomsol2, setmycomsol2] = React.useState('');
    const [mycomsol3, setmycomsol3] = React.useState('');
    const [sollist, setsollist] = React.useState([]);
    const [openBoard, setopenBoard] = React.useState(false);
    const [animation, cycleAnimation] = useCycle("animateOne", "animateTwo");
    const [myModal, setmyModal] = React.useState(true);
    const [myModalTwo, setmyModalTwo] = React.useState(true);
    const [myModalThree, setmyModalThree] = React.useState(false);
    const [ansType, setansType] = React.useState('');
    const [altHint, setaltHint] = React.useState('');
    const [mysum, setmysum] = React.useState('0');
    ///const classes = styles1(theme)
    const [arrStore, setarrStore]= React.useState([])
    const { classId, sesId } = useParams();





    

    useEffect(() => {



        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        const classid = classId;
        console.log(classId)
        const sessid = sesId;
        console.log(user)
        const loadData=()=>{
          const config = {
            headers: { Authorization: `Bearer ${user.token}` }
        };

        try{
          
          setclas(cla)
            
          axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
          .then((resp) =>{
            if(resp.data.activity4[0].problemStatement!==''){
              const activity = resp.data.activity4[0]

              console.log('already started activity')
                setmydata(activity)
                settotaldata(resp.data)
                if(activity.decomposition.length=='0'){
            
                }
                else{
                  if(activity.decomposition[0].userText!==""){
                      var newarr  = activity.decomposition[0].userText.split(':')
                      var arr1 = newarr[1].split(',')
                      var arr2 = newarr[2].split(',')
                      var arr3 = newarr[3].split(',')
                      var arr4 = newarr[4].split(',')
                      //console.log(arr.length)
  
                        setnum1(arr1[2])
                        setnum2(arr1[3])
                        setnum3(arr2[2])
                        setnum4(arr2[3])
                        setnum5(arr3[2])
                        setnum6(arr3[3])
                        setnum7(arr4[2])
                        setnum8(arr4[3])
                                                       
                  }
  
                }
                if(activity.analysis.length=='0'){
                  setmytime('')
                  setmyspace('')
                }
                else{
                  setmytime(activity.analysis[0].timeText)
                  setmyspace(activity.analysis[0].spaceText)
                }
              
              setloading(false)
            }
            else{
            var question='Given a set of logs that can be extracted from six trees {12, 17, 24, 27, 33, 37 } and a required log count of 55. Write an algorithm to select a pair of trees such that the total sum of logs are closest to 55 required logs. The sum may be more or less but should be closest to the  given number.'
            
            if(resp.data.activity4[0].problemStatement==''){
              resp.data.activity4[0].problemStatement=question
            }
            resp.data.currentActivity='activity4'
              
            console.log('updating profile')
            const data=
            {
              profile: resp.data
            }    
          
          axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
          .then((response) =>{
            //console.log(response.data)
            const activity = response.data.activity4[0]
            settotaldata(response.data)

            //console.log(activity)
              setmydata(activity)
           settotaldata(response.data)
              if(activity.decomposition.length=='0'){
            
              }
              else{
                if(activity.decomposition[0].userText!==""){
                    var newarr  = activity.decomposition[0].userText.split(':')
                    var arr1 = newarr[1].split(',')
                    var arr2 = newarr[2].split(',')
                    var arr3 = newarr[3].split(',')
                    var arr4 = newarr[4].split(',')
                    //console.log(arr.length)

                      setnum1(arr1[2])
                      setnum2(arr1[3])
                      setnum3(arr2[2])
                      setnum4(arr2[3])
                      setnum5(arr3[2])
                      setnum6(arr3[3])
                      setnum7(arr4[2])
                      setnum8(arr4[3])
                                                     
                }

              }
        
              if(activity.analysis.length=='0'){
                setmytime('')
                setmyspace('')
              }
              else{
                setmytime(activity.analysis[0].timeText)
                setmyspace(activity.analysis[0].spaceText)
              }
              
                // try{
                //         getData(sessid)
                //         interval = setInterval(() => {
                //             //console.log('Interval is working')
                //             getData(sessid);
                //             updateCount(user.count)
                //         }, 3000);
                
                   
                //   } catch (error) {
                //       if (axios.isCancel(error)) {
                //         console.log("cancelled");
                //       } else {
                //         throw error;
                //       }
                //     }
                
            setloading(false)
            

          })
          .catch((error)=>{
            console.log(error);
            });
          }
          })
          .catch((error)=>{
          console.log(error);
          });
        } catch (error) {
        if (axios.isCancel(error)) {
          console.log("cancelled");
        } else {
          throw error;
        }
      }

    };

    loadData();

   
    return() => {source.cancel();
    };


    }, []);

    useEffect(() => {  
      clearInterval(interval);
  
     })


  const LevenshteinDistance = (s1, s2) => {
    s1 = s1.toLowerCase();
    s2 = s2.toLowerCase();

    var costs = new Array(s2.length + 1);
    for (var i = 0; i <= s1.length; i++) {
        var lastValue = i;
        for (var j = 0; j <= s2.length; j++) {
            if (i == 0) {
                costs[j] = j;
            } else {
                if (j > 0) {
                    var newValue = costs[j - 1];
                    if (s1.charAt(i - 1) != s2.charAt(j - 1)) {
                        newValue = Math.min(Math.min(newValue, lastValue),
                                costs[j]) + 1;
                    }
                    costs[j - 1] = lastValue;
                    lastValue = newValue;
                }
            }
        }
        if (i > 0) {
            costs[s2.length] = lastValue;
        }
    }
    return costs[s2.length];
  }

  const similarity=(s1, s2) =>{
    var longer = s1;
    var shorter = s2;
    if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
    }
    var longerLength = longer.length;
    if (longerLength == 0) {
        return 1.0;
    }
    return (longerLength - LevenshteinDistance(longer, shorter)) / longerLength;
}

  
     const backdrop = {
      visible:{opacity: 1},
      hidden:{opacity: 0}
  }
  
  const modal = {
      hidden:{
        y:"-100vh",
        opacity: 1
      },
      visible:{
        y: "50px",
        opacity:1,
        transition:{ delay: 0.5 }
      },
      exit:{
        y:"500vh",
        opacity: 1,
        transition:{ delay: 1 }
  
      },
    }
     const imageVariants = {
      animateOne:{
          x: [0, 500],
          //y: [0, -30],
          transition: {
              x:{
                  repeat: finalCount,
                  duration:3,
                  ease:"easeOut"
              },
              // y:{
              //     yoyo: Infinity,
              //     duration:0.25,
              //     ease:"easeOut"
              // },
          }
      },
      animateTwo:{
        x: [0, 499],
        //y: [0, -30],
        transition: {
            x:{
                repeat: finalCount,
                duration:3,
                ease:"easeOut"
            },
            // y:{
            //     yoyo: Infinity,
            //     duration:0.25,
            //     ease:"easeOut"
            // },
        }
      }
    }

   

     const imgVariants = {
      hidden:{ opacity: 0},
      visible:{
        opacity: 1,  
          x: [0, 500],
          //y: [0, -30],
          transition: {
              x:{
                  yoyo: myCount,
                  duration:1,
                  ease:"easeOut"
              },
              // y:{
              //     yoyo: Infinity,
              //     duration:0.25,
              //     ease:"easeOut"
              // },
          }
      }
    }

    const Notification = (act) => {

      var query=totaldata.support.filter((ses)=> ses.activity == act)
      console.log(query)
      const length = query.length;
      //console.log(length)
      ///check for new queries
      var newQuery = false;    

      if(length>0 && typeof(query)!='undefined' && typeof(length)!='undefined'){
        const lastMsg = new Date(query[length-1].created)
        const lastVisit = new Date(totaldata.lastViewStudentSupport)
      
        if(lastVisit < lastMsg){
          newQuery = true
        }
      }
        console.log(newQuery)
        
          return newQuery

    }
    const handleCountChange = (event) =>{
      var count = event.target.value
      setmyCount(count)
      //console.log(event.target.value)
    }


  

    const getPatternText = () =>{
                
      var mytext = ''
      var newArr = mydata.pattern[0].userText.split(',')
      var i=0
      if(mydata.pattern[0].completed==false){
        while(newArr[i]!=='' && i<newArr.length){
            mytext=mytext+newArr[i]
            i=i+1
        }  
      }
      else{
        mytext =newArr[0]+newArr[1]+newArr[2]
      }
     /////console.log(mytext)          
       return(
             <>{mytext}</>
       );
     }
     const commaToText = (txt) =>{
      var mytext = ''
      if(txt!='' && typeof(txt)!=='undefined'){ 
      if(txt.includes(',')==true){
        var newArr = txt.split(',')
        var i=0
        while(newArr[i]!==''&& i<newArr.length && newArr[i]!=='undefined'){
              mytext=mytext+' '+newArr[i]
              i=i+1
          }  
        
         return mytext
      }
      else{
        return txt
      }
    }
    return txt
      
   }
   
     const abstractToText = (txt) =>{
        var mytext =''
        var tex = txt.split(':')

        if(tex[0]==='find specific pair'){
            var newArr = txt.split(',')
            var i=0
            while(typeof(newArr[i])!=='undefined'&& i<newArr.length){
                  mytext=mytext+newArr[i]
                  i=i+1
              }  
             return mytext
        }
        else{
            return txt
        }
    }

    const algoNewToText = (txt) =>{
      var tex = txt.split(';')
      var stex=[]
      if(tex.length==4){
        if(tex[2].includes('set')==true){
          stex = tex[2].split('set')
        }
      }
      else if(tex.length>4){
        if(tex[3].includes('set')==true){
          stex = tex[3].split('set')
        }
      }
      var text = []
      stex.map((val, index)=>{
        if(index>0){
          text[index]='set'+val
        }
        else{
          text[index]=val
        }
      })
      var texti=[]
      var k=0
      text.map((val,index)=>{
        var ifText = val.split('if')
        if(ifText.length>0){
          ifText.map((value,index1)=>{
            if(index1>0){
              texti[k++]= 'if'+value
            }
            else{
              texti[k++]= value
            }
          })
        }
        else{
          texti[k++]=val
        }
      })

      var textil=[]
      k=0
      texti.map((val,index)=>{
        var whileText = val.split('while')
        if(whileText.length>0){
          whileText.map((value,index1)=>{
            if(index1>0){
              textil[k++]= 'while'+value
            }
            else{
              textil[k++]= value
            }
          })
        }
        else{
          textil[k++]=val
        }
      })
      return (<div>
          {tex.length==4?
          <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                  <b>Input statement:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                   {commaToText(tex[0])}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
              <b>Define variable:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                   {commaToText(tex[1])} 
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
              <b>Set variable:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                {textil.map((val, index)=>{
                    return(
                    <div>{commaToText(val)}</div>
                    )
                })}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
              <b>Output:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                  {commaToText(tex[3])}
              </GridItem>
          </GridContainer>:
          <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <b>Input statement:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                  {commaToText(tex[0])}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <b>Define variable:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                  {commaToText(tex[1])} {commaToText(tex[2])}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <b>Set variable:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                {textil.map((val, index)=>{
                  return(
                    <div>{commaToText(val)}</div>
                    )
                })}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <b>Output:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                  {commaToText(tex[4])}
              </GridItem>
          </GridContainer>}
          </div>
      )
    }
  
      const algoToText = (txt) =>{
        var tex = txt.split(';')
        var stex=[]
        if(tex.length==4){
          stex = tex[2].split('set')
        }
        else{
          stex = tex[3].split('set')
        }
        return (<div>
            {tex.length==4?
            <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                    input statement:
                </GridItem>
                <GridItem xs={12} sm={12} md={9}>
                     {commaToText(tex[0])}
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    define variable:
                </GridItem>
                <GridItem xs={12} sm={12} md={9} >
                     {commaToText(tex[1])} 
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    set variable:
                </GridItem>
                <GridItem xs={12} sm={12} md={9} >
                  {stex.map((val, index)=>{
                    if(index>0){
                    return(
                      <div>{commaToText('set'+val)}</div>
                    )
                    }
                    else{
                      return(
                      <div>{commaToText(val)}</div>
                      )
                    }
                  })}
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    output statement:
                </GridItem>
                <GridItem xs={12} sm={12} md={9} >
                    {commaToText(tex[3])}
                </GridItem>
            </GridContainer>:
            <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                    input statement:
                </GridItem>
                <GridItem xs={12} sm={12} md={9}>
                    {commaToText(tex[0])}
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    define variable:
                </GridItem>
                <GridItem xs={12} sm={12} md={9} >
                    {commaToText(tex[1])} {commaToText(tex[2])}
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    set variable:
                </GridItem>
                <GridItem xs={12} sm={12} md={9} >
                    {stex.map((val, index)=>{
                      if(index>0){
                      return(
                        <div>{commaToText('set'+val)}</div>
                      )
                      }
                      else{
                        return(
                        <div>{commaToText(val)}</div>
                        )
                      }
                    })}
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    output statement:
                </GridItem>
                <GridItem xs={12} sm={12} md={9} >
                    {commaToText(tex[4])}
                </GridItem>
            </GridContainer>}
            </div>
        )
     }

     const solutionIndex = () =>{
       var len=0
      if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
        len=mydata.decomposition[0].alternateSolution.length
      }
      if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
        len=len+mydata.pattern[0].alternateSolution.length
      }
      if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
        len=len+mydata.abstraction[0].alternateSolution.length
      }
      if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
        len=len+mydata.algorithm[0].alternateSolution.length
      }
      return len;

     }


      var abstractionList = [
      { label: abs2, value: abs2 },
      { label: '', value: '' }
    ];


    

    var setList = [
      { label: algo3, value: algo3 },
      { label: '', value: '' }
    ];


    var VarList = [
      {label: 'PairwiseSum', value: 'PairwiseSum'}, {label: 'Pairs', value: 'Pairs'},{label: 'Difference', value: 'Difference'}, {label: 'sum', value: 'sum'}, 
      {label: 'area', value: 'area'}, {label: 'n', value: 'n'}, {label: 'count', value: 'count'}, {label: 'var1', value: 'var1'},
      {label: 'l', value: 'l'}, {label: 'k', value: 'k'}, {label: 'x', value: 'x'},
      {label: 'y', value: 'y'}]

      var setVarList = [ { label: abs1, value: abs1 },
        {label: 'n', value: 'n'}, {label: 'o', value: 'o'}, {label: 'p', value: 'p'}, {label: 'sum', value: 'sum'},
        {label: 'area', value: 'area'}, {label: 'count', value: 'count'}, {label: 'var1', value: 'var1'},
        {label: 'l', value: 'l'}, {label: 'k', value: 'k'}, {label: 'x', value: 'x'}, {label: 'y', value: 'y'} ]

    const handleAbsChange1 = (event) =>{
        setabs1(event.target.value)
        setmyabs1(event.target.value)
    }
    const handleAbsChange2 = (event) =>{
      setabs2(event.target.value)
    }
    const handleAbsChange3 = (event) =>{
      setabs3(event.target.value)
    }
    const handleAbsChange4 = (event) =>{
      setabs4(event.target.value)
    }
    const handleAbsChange5 = (event) =>{
      setabs5(event.target.value)
    }
    const handleAbsChange6 = (event) =>{
      setabs6(event.target.value)
    }
    const handleAbsChange7 = (event) =>{
      setabs7(event.target.value)
    }
    const handleAbsChange8 = (event) =>{
      setabs8(event.target.value)
    }
    const handleAbsChange9 = (event) =>{
      setabs9(event.target.value)
    }
    const handleAbsChange10 = (event) =>{
      setabs10(event.target.value)
    }
    const handleAbsChange11 = (event) =>{
      setabs11(event.target.value)
    }
    const handleAbsChange12 = (event) =>{
      setabs12(event.target.value)
    }
    const handleAbsChange13 = (event) =>{
      setabs13(event.target.value)
    }
    const handleAbsChange14 = (event) =>{
      setabs14(event.target.value)
    }
    const handleAbsChange15 = (event) =>{
      setabs15(event.target.value)
    }
    const handleAbsChange16 = (event) =>{
      setabs16(event.target.value)
    }
    const handleAbsChange17 = (event) =>{
      setabs17(event.target.value)
    }
    const handleAbsChange18 = (event) =>{
      setabs18(event.target.value)
    }
    const handleMyAbsChange1 = (event) =>{
        setmyabs1(event.target.value)
    }
    const handleMyAbsChange2 = (event) =>{
        setmyabs2(event.target.value)
    }
    const handleAbsChangeNum = (event) =>{
      setabsNum(event.target.value)
    }
    
    
    

    const submitCount = () => {
      //console.log(myCount)
      dispatch(
        upCount(0)
      )
      
      var count = 2*myCount-1
      dispatch(
        finCount(count)
      )
      setfinalCount(count)
      cycleAnimation()
      //clearInterval(interval);


    }

    const closeModal=()=>{
      setmyModal(!myModal)
    }
    const closeModalTwo=()=>{
      setmyModalTwo(!myModalTwo)
    }
    const closeModalYesThree=()=>{
      
      var answerCorrect=false
      
      setmyModalThree(!myModalThree)
    
      
      if(activeStep==0){


        var decompos=""
        var sum1=parseInt(num1)+parseInt(num2)+'difference='+Math.abs(parseInt(num1)+parseInt(num2)-55);
        var sum2=parseInt(num3)+parseInt(num4)+'difference='+Math.abs(parseInt(num3)+parseInt(num4)-55);
        var sum3=parseInt(num5)+parseInt(num6)+'difference='+Math.abs(parseInt(num5)+parseInt(num6)-55);
        var sum4=parseInt(num7)+parseInt(num8)+'difference='+Math.abs(parseInt(num7)+parseInt(num8)-55);
        decompos ='Pairs are-first,last:,(,'+num1+','+num2+',)='+sum1+',first,second last:,(,'+num3+','+num4+',)='+sum2+',second,last:,(,'+num5+','+num6+',)='+sum3+',second, second last:,(,'+num7+','+num8+',)='+sum4

        if(num1*1+num2*1==49){
          mydata.decomposition[0].userText1=''
        }
        else{
            mydata.decomposition[0].userText1='first Pair incorrect'
        }
        if(num3*1+num4*1==41){
          mydata.decomposition[0].userText2=''
        }
        else{
            mydata.decomposition[0].userText2='second Pair incorrect'
        }
        if(num5*1+num6*1==54){
          mydata.decomposition[0].userText3=''
        }
        else{
            mydata.decomposition[0].userText3='third Pair incorrect'
        }
        if(num7*1+num8*1==46){
          mydata.decomposition[0].userText4=''
        }
        else{
            mydata.decomposition[0].userText4='fourth Pair incorrect'
        }
               
        mydata.decomposition[0].userText=decompos
        mydata.decomposition[0].noOfattempts=mydata.decomposition[0].noOfattempts+1
        arrStore.map((val, index)=>{
          mydata.decomposition[0].enteredSolution.push(val)
        })
        const data=
        {
          act:'activity4',
          decomposition:mydata.decomposition,
          problem: 'sumlogsclosest' 
        }                     
        console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          //console.log(response.data)
          const activity = response.data.activity4[0]
          setmydata(activity)
           settotaldata(response.data)
          answerCorrect=activity.decomposition[0].completed
          
          var step = activity.altStep
          setarrStore([])
          if(step!==''){
            if(step=='decomposition'){
              var len = activity.decomposition[0].alternateSolution.length-1;
              var altcompleted = activity.decomposition[0].alternateSolution[len].algoCompleted
            }
            else if(step=='pattern'){
              var len = activity.pattern[0].alternateSolution.length-1;
              var altcompleted = activity.pattern[0].alternateSolution[len].algoCompleted
            }
            else if(step=='abstraction'){
              var len = activity.abstraction[0].alternateSolution.length-1;
              var altcompleted = activity.abstraction[0].alternateSolution[len].algoCompleted
            }
            console.log('Alternate solution'+len+' '+altcompleted)
          }
          
          
            if(activity.decomposition[0].proceed===true){
              console.log('Going to'+activeStep) 
              setansType("Correct Answer Bravo!! Let's move to next")
              if(answerCorrect===false){
                
                  setmypattern(mydata.pattern[0].userText)
                  setpatnum1('')
                  setpatnum2('')
                  setpatnum3('')
                  setpatnum4('')
                  setpatnum5('')
                  setpatnum6('')
                  setpatnum7('')
                  setpatnum8('')

                }
              else{
                console.log('Going to'+activeStep) 
                setmypattern(mydata.pattern[0].userText)
                setpatnum1('')
                setpatnum2('')
                setpatnum3('')
                setpatnum4('')
                setpatnum5('')
                setpatnum6('')
                setpatnum7('')
                setpatnum8('')
              }
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
            else{
              if(step===''){
                setansType('Incorrect Answer.')
              }
              else if(step!=='' && altcompleted==false){
                  if(activity.decomposition[0].noOfaltattempts<4){
                    setansType('Incorrect Answer. Try to connect your response to the previous step..')
                  }
                  else{
                    setaltHint(activity.decomposition[0].hints[0].alternate)
                  }
              }
              else if(step!=='' && altcompleted==true){
                setansType('Can you change your answer? Try following hint.')
              }
            }

            setisSubmit(false)
          setmyModalTwo(!myModalTwo)    ////code for hints modal
          seterror('')

      })
            

      }

      if(activeStep==1){

        var err=false
        if(patnum=='find all pair:'){
          if(patnum1===''|| patnum2==='' || patnum3==='' || patnum4==='' || patnum5==='' || patnum6==='' || patnum7==='' || num9===''){
            err=true
          }
        }
        if(patnum=='find specific pair:'){
          if(patnum8===''|| patnum9==='' || patnum1===''|| patnum2==='' || patnum3==='' || patnum4==='' || patnum5==='' || patnum6==='' || patnum7==='' || num9===''){
            err=true
          }
        }
        if(err===false){
          seterror('')
        if(mydata.decomposition[0].completed===false){
            if(patnum=='find specific pair:'){
              mydata.pattern[0].userText=patnum+'observe that if first index of pair remains same and second index decreases then Pairwise sum,'+patnum8+', and observe that if second index of pair remains same and first index increases then Pairwise sum,'+patnum9+':start from,firstNumPair=,'+patnum1+',secNumPair=,'+patnum2+',for specific Pair:find,'+num9+', of ,'+patnum3+','+patnum4+','+patnum5+':pairs that closest to 55:'+patnum6+','+patnum7+',diff='+Math.abs(parseInt(patnum6)*1+parseInt(patnum7)-55)
            }
            else{
              mydata.pattern[0].userText=patnum+'start from,firstNumPair=,'+patnum1+',secNumPair=,'+patnum2+',for each Pair:find,'+num9+', of ,'+patnum3+','+patnum4+','+patnum5+':pairs closest to 55:'+patnum6+','+patnum7+',diff='+Math.abs(parseInt(patnum6)*1+parseInt(patnum7)-55)
            }
        }
        else{
            if(patnum=='find specific pair:'){
              mydata.pattern[0].userText=patnum+'observe that if first index of pair remains same and second index decreases then Pairwise sum,'+patnum8+', and observe that if second index of pair remains same and first index increases then Pairwise sum,'+patnum9+':start from,firstNumPair=,'+patnum1+',secNumPair=,'+patnum2+',for specific Pair:find,'+num9+', of ,'+patnum3+','+patnum4+','+patnum5+':pairs that closest to 55:'+patnum6+','+patnum7+',diff='+Math.abs(parseInt(patnum6)*1+parseInt(patnum7)-55)
            }
            else{
              mydata.pattern[0].userText=patnum+'start from,firstNumPair=,'+patnum1+',secNumPair=,'+patnum2+',for each Pair:find,'+num9+', of ,'+patnum3+','+patnum4+','+patnum5+':pairs closest to 55:'+patnum6+','+patnum7+',diff='+Math.abs(parseInt(patnum6)*1+parseInt(patnum7)-55)
            }
        }
        if(patnum=='find specific pair:'){
          if(patnum1===12){
            mydata.pattern[0].userText1=''
          }
          else{
            mydata.pattern[0].userText1='firstNumPair!=12'
          }
          if(patnum2===37){
            mydata.pattern[0].userText1=''
          }
          else{
            mydata.pattern[0].userText1='secNumPair!=37'
          }
          if(patnum8=='decreases'){
            mydata.pattern[0].userText5=''
          }
          else{
            mydata.pattern[0].userText5='decrease second number of pair: pairwise sum increase'
          }
          if(patnum9=='increases'){
            mydata.pattern[0].userText5=''
          }
          else{
            mydata.pattern[0].userText5='increase first number pair: pairwise sum decrease'
          }
          if(patnum3+patnum4+patnum5=='pairSum-55'){
            mydata.pattern[0].userText3=''
          }
          else{
            mydata.pattern[0].userText3='sum!=53'
          }
          if(parseInt(patnum6)*1+parseInt(patnum7)*1==54){
            mydata.pattern[0].userText4=''
          }
          else{
            mydata.pattern[0].userText4='incorrect pair'
          }
          if(num9=='minimum'){
            mydata.pattern[0].userText2=''
          }
          else{
            mydata.pattern[0].userText2='not minimum'
          }

        }


        mydata.pattern[0].noOfattempts=mydata.pattern[0].noOfattempts+1
        ///mydata.pattern[0].userText=mypattern
        //mydata.pattern[0].userText1=mypattern1
        if(mydata.altStep==='decomposition'){
          var len = mydata.decomposition[0].alternateSolution.length-1;
          if(mydata.decomposition[0].alternateSolution[len].algoCompleted!==true){
            mydata.pattern[0].noOfattempts=0
            mydata.pattern[0].noOfaltattempts=mydata.pattern[0].noOfaltattempts+1

          }
        }
        else if(mydata.altStep==='pattern'){
          var len = mydata.pattern[0].alternateSolution.length-1;
          if(mydata.pattern[0].alternateSolution[len].algoCompleted!==true){
            mydata.pattern[0].noOfattempts=0
            mydata.pattern[0].noOfaltattempts=mydata.pattern[0].noOfaltattempts+1
          }
        }
        arrStore.map((val, index)=>{
          mydata.pattern[0].enteredSolution.push(val)
        })
        const data=
        {
          act:'activity4',
          pattern: mydata.pattern,
          problem: 'sumlogsclosest' 
        }                     
        console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          console.log(response.data)
          const activity = response.data.activity4[0]
          var step = activity.altStep
          setarrStore([])
          if(step!==''){
            if(step=='decomposition'){
              var len = activity.decomposition[0].alternateSolution.length-1;
              var altcompleted = activity.decomposition[0].alternateSolution[len].algoCompleted
            }
            else if(step=='pattern'){
              var len = activity.pattern[0].alternateSolution.length-1;
              var altcompleted = activity.pattern[0].alternateSolution[len].algoCompleted
            }
            else if(step=='abstraction'){
              var len = activity.abstraction[0].alternateSolution.length-1;
              var altcompleted = activity.abstraction[0].alternateSolution[len].algoCompleted
            }
            console.log('Alternate solution'+len+' '+altcompleted)
          }
          setmydata(activity)
           settotaldata(response.data)
          
            if(activity.pattern[0].proceed===true){
              console.log('Going to'+activeStep) 
              setansType("Correct Answer Bravo!! Let's move to next")
              if(activity.pattern[0].completed===false){                
                var text = mydata.pattern[0].userText.split(':')
                    if(text[0]==='find specific pair'){
                        ///var pat = commaToText(text[1])
                        setabs2('')
                    }
                    else if(text[0]==='find all pair'){
                         
                        setabs2('')
                    }
              }
              else{
                console.log('Going to'+activeStep)
                if(mydata.abstraction[0].userText1!==''){
                  var newArr = mydata.abstraction[0].userText1.split(',')
                  setabs1(newArr[0])
                  setabs2(newArr[1])
                  setabs3(newArr[2])
                }
                setabs4(mydata.abstraction[0].userText2)
                if(mydata.abstraction[0].userText3!==''){
                  var newArr1 = mydata.abstraction[0].userText3.split(',')
                  setabs5(newArr1[0])
                  setabs6(newArr1[1])
                  setabs7(newArr1[2])
                }
                else{
                  setmyabstract(mydata.abstraction[0].userText)
                }
              }
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
            else{
              if(step===''){
                setansType('Incorrect Answer.')
              }
              else if(step!=='' && altcompleted==false){
                if(activity.pattern[0].noOfaltattempts<4){
                    setansType('Incorrect Answer. Try to connect your response to the previous step..')
                  }
                  else{
                    if(activity.altStep=='decomposition'){
                        setaltHint(activity.decomposition[0].hints[0].alternate)
                      }
                      else if(activity.altStep=='pattern'){
                        setaltHint(activity.pattern[0].hints[0].alternate)
                      }
                  }
              }
              else if(step!=='' && altcompleted==true){
                setansType('Can you change your answer? Try following hint.')
              }

            }
         
          
            setisSubmit(false)
            setmyModalTwo(!myModalTwo) ////code for hints modal
            seterror('')
  
        })
        }
        else{
          setisSubmit(false)
          seterror('Please enter text/number/operators in above space')
        }

      }

      if(activeStep==2){

        var err=''        
        if(mydata.pattern[0].completed===false){
          if(abs14==''&& abs15=='' && abs1===''&& abs2==''&& abs3==''&& abs4==''&& abs5==''&& abs6==''&& abs7==''&& myabs1==''&& myabs2==''){
            err='please enter text into the space above'
            seterror(err)
          }        
            mydata.abstraction[0].userText='find all pair:select firstNumPair=,'+abs1+',secNumPair=,'+abs2+',from 12-17-24-27-33-37,for each pair:Pairwise sum=,'+abs3+','+abs4+','+abs5+',Difference=Pairwise sum,'+abs14+','+abs15+',check if Difference,'+abs6+','+abs7+',then Pairs=,'+myabs1+','+myabs2+','+abs7+'=Difference'
        
        }
        else{
          if(abs13===''&& abs12==''&& abs11===''&& abs10==''&& abs8===''&& abs9==''&& abs1===''&& abs2==''&& abs3==''&& abs4==''&& abs5==''&& abs6==''&& abs7==''&& myabs1==''&& myabs2==''){
            err='please enter text into the space above'
            seterror(err)
          } 
          var inde3='index1'
          var inde4='index1'
          if(myabs1=='firstNumPair'){
            inde3='index1'
          }
          else{
            inde3='index2'
          } 
          if(myabs2=='firstNumPair'){
            inde4='index1'
          }
          else{
            inde4='index2'
          }
          code=`arr=[12, 17, 24, 27, 33, 37];minimum=9999;difference=0;calculatedSum=0;pairs='not found';found=false;index1=0;index2=5;while(arr[index1]!=arr[index2] && found==false){calculatedSum=arr[index1]+arr[index2];difference=Math.abs(calculatedSum-${absNum});if(difference<minimum){minimum=difference;pairs=arr[${inde3}]+','+arr[${inde4}];}else if(calculatedSum<${absNum}){index1++;}else if(calculatedSum>${absNum}){index2--;}}; return pairs`
          const F = new Function(code);          
          var out = F()
          console.log(out)
          mydata.abstraction[0].userText='find specific pair:select firstNumPair=,'+abs1+',secNumPair=,'+abs2+',from 12-17-24-27-33-37,for each pair:Pairwise sum=,'+abs3+','+abs4+','+abs5+',Difference=Pairwise sum,'+abs14+','+abs15+',check if Difference,'+abs6+','+abs7+',then Pairs=,'+myabs1+','+myabs2+','+abs7+',=Difference,check if Pairwise sum,'+abs8+','+abs9+','+abs10+',firstNumPair'+',check if Pairwise sum,'+abs11+','+abs12+','+abs13+',secNumPair'
          
          if(abs1==12){
            mydata.abstraction[0].userText2=''
          }
          else{
            mydata.abstraction[0].userText2='firstNumPair!=index1'
          }
          if(abs2==37){
            mydata.abstraction[0].userText2=''
          }
          else{
            mydata.abstraction[0].userText2='secNumPair!=index6'
          }
          if(abs10=='increase'){
            mydata.abstraction[0].userText4=''
          }
          else{
            mydata.abstraction[0].userText4='PairwiseSum<n,decrease'
          }
          if(abs13=='decrease'){
            mydata.abstraction[0].userText4=''
          }
          else{
            mydata.abstraction[0].userText4='PairwiseSum>n,increase'
          }
          if(out==PairSpecificCalculate()){
            mydata.abstraction[0].userText3=''
          }else{
            mydata.abstraction[0].userText3='incorrect answer'
          }
          mydata.abstraction[0].noOfattempts=mydata.abstraction[0].noOfattempts+1

        }

        if(err===''){
        if(mydata.altStep==='decomposition'){
          var len = mydata.decomposition[0].alternateSolution.length-1;
          if(mydata.decomposition[0].alternateSolution[len].algoCompleted!==true){
            mydata.abstraction[0].noOfattempts=0
            mydata.abstraction[0].noOfaltattempts=mydata.abstraction[0].noOfaltattempts+1
          }
        }
        else if(mydata.altStep==='pattern'){
          var len = mydata.pattern[0].alternateSolution.length-1;
          if(mydata.pattern[0].alternateSolution[len].algoCompleted!==true){
            mydata.abstraction[0].noOfattempts=0
            mydata.abstraction[0].noOfaltattempts=mydata.abstraction[0].noOfaltattempts+1
          }
        }
        arrStore.map((val, index)=>{
          mydata.abstraction[0].enteredSolution.push(val)
        })
        const data=
        {
          act:'activity4',
          abstraction: mydata.abstraction,
          problem: 'sumlogsclosest' 
        }                     
        //console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          //console.log(response.data)
          const activity = response.data.activity4[0]
          setmydata(activity)
           settotaldata(response.data)
          var step = activity.altStep
          setarrStore([])
          if(step!==''){
            if(step=='decomposition'){
              var len = activity.decomposition[0].alternateSolution.length-1;
              var altcompleted = activity.decomposition[0].alternateSolution[len].algoCompleted
            }
            else if(step=='pattern'){
              var len = activity.pattern[0].alternateSolution.length-1;
              var altcompleted = activity.pattern[0].alternateSolution[len].algoCompleted
            }
            else if(step=='abstraction'){
              var len = activity.abstraction[0].alternateSolution.length-1;
              var altcompleted = activity.abstraction[0].alternateSolution[len].algoCompleted
            }
            console.log('Alternate solution'+len+' '+altcompleted)
          }
          if(activity.abstraction[0].proceed===true){
            console.log('Going to'+activeStep)
            var setsum=mydata.abstraction[0].userText.split(':')
            setansType("Correct Answer Bravo!! Let's move to next")
            if(activity.abstraction[0].completed===false){
              if(activity.abstraction[0].userText.includes('find all pair')==true){
              }
              console.log('Not completed')
              
            }
            else{
              console.log('Going to'+activeStep)
              setmyalgo4('')     
              setmyalgo5('')     
            }
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
          }
          else{
            if(step===''){
              setansType('Incorrect Answer.')
            }
            else if(step!=='' && altcompleted==false){
                if(activity.abstraction[0].noOfaltattempts<4){
                    setansType('Incorrect Answer. Try to connect your response to the previous step..')
                  }
                  else{
                      if(activity.altStep=='decomposition'){
                        setaltHint(activity.decomposition[0].hints[0].alternate)
                      }
                      else if(activity.altStep=='pattern'){
                        setaltHint(activity.pattern[0].hints[0].alternate)
                      }
                  }            }
            else if(step!=='' && altcompleted==true){
              setansType('Can you change your answer? Try following hint.')
            }

          }
          setisSubmit(false)
          setmyModalTwo(!myModalTwo)
          seterror('')

        })

      }
      else{
        setisSubmit(false)
        seterror('Please enter text/number/operators in above space')
      }

    }

      if(activeStep==3){
        var code=''
        var err=''
        if(mydata.abstraction[0].completed===false){
           
              var inde3='index1'
              var inde4='index2'
              if(algo8=='firstNumPair'){
                inde3='index1'
              }
              else{
                inde3='index2'
              } 
              if(algo9=='firstNumPair'){
                inde4='index1'
              }
              else{
                inde4='index2'
              }
              code=`arr=[12, 17, 24, 27, 33, 37];Difference=0;minimum=9999;calculatedSum='';pairs='not found';index1=0;index2=0;for(index1=0;index1<6;index1++){for(index2=0;index2<6;index2++){calculatedSum=arr[index1]+arr[index2];Difference=Math.abs(calculatedSum-${absNum});if(Difference<minimum){minimum=Difference;pairs=arr[${inde3}]+','+arr[${inde4}];}}}; return pairs`
              const F = new Function(code);          
              var out = F()
                  mydata.algorithm[0].userText='input,'+myalgo1+';define,'+myalgo2+','+myalgo3+','+algo18+','+myalgo4+','+algo19+','+myalgo5+';set,'+myalgo6+',to,'+myalgo7+',set,'+myalgo8+',to,'+myalgo9+',for each firstNumPair and secNumPair set,'+algo1+',to,'+algo2+','+algo3+','+algo4+',set,'+algo20+',to,'+algo1+','+algo21+','+algo22+',check if,'+algo20+','+algo5+','+algo6+',set,'+algo6+',to,'+algo20+',then set,'+algo7+',to,'+algo8+','+algo9+';output,'+algo
                  mydata.algorithm[0].userText1='for each firstNumPair and secNumPair set PairwiseSum to '+algo2+','+algo3+','+algo4+',set Difference to PairwiseSum'+algo21+algo22+', check if Difference'+algo5+algo6+',then set Pairs to '+algo8+','+algo9
                  mydata.algorithm[0].noOfattempts=mydata.algorithm[0].noOfattempts+1
                  if(out!=AlgoPairCalculate()){
                    mydata.algorithm[0].userText1='incorrect answer'
                }
        }
        else{
              var inde3='index1'
              var inde4='index2'
              if(algo8=='firstNumPair'){
                inde3='index1'
              }
              else{
                inde3='index2'
              } 
              if(algo9=='firstNumPair'){
                inde4='index1'
              }
              else{
                inde4='index2'
              }
            code=`arr=[12, 17, 24, 27, 33, 37];k=0;found=false;Difference=0;minimum=9999;calculatedSum=0;pairs='not found';index1=0;index2=5;while(arr[index1]!=arr[index2] && found==false && index1<6 && index1>-1 && index2>-1 && index2<6){calculatedSum=arr[index1]+arr[index2];Difference=Math.abs(calculatedSum-${absNum});if(Difference<minimum){minimum=Difference;pairs=arr[${inde3}]+','+arr[${inde4}];} if(calculatedSum<${absNum}){index1++;}else if(calculatedSum>${absNum}){index2--;}if(k>30){found=true;}}; return pairs`
            const F = new Function(code);          
            var out = F()
            
            mydata.algorithm[0].userText='input,'+myalgo1+';define,'+myalgo2+','+myalgo3+','+algo18+','+myalgo4+','+algo19+','+myalgo5+';set,'+myalgo6+',to,'+myalgo7+',set,'+myalgo8+',to,'+myalgo9+',for each firstNumPair and secNumPair set,'+algo1+',to,'+algo2+','+algo3+','+algo4+',set,'+algo20+',to,'+algo1+','+algo21+','+algo22+',check if,'+algo20+','+algo5+','+algo6+',set,'+algo6+',to,'+algo20+',then set,'+algo7+',to,'+algo8+','+algo9+',check if,'+algo1+','+algo10+','+algo11+',then,'+algo12+','+algo13+',check if,'+algo1+','+algo14+','+algo15+',then,'+algo16+','+algo17+';output,'+algo
            mydata.algorithm[0].userText1='for each firstNumPair and secNumPair, set PairwiseSum to '+algo2+','+algo3+','+algo4+',set Difference to PairwiseSum'+algo21+algo22+',check if Difference'+algo5+algo6+',then set Pairs to '+algo8+','+algo9+',check if PairwiseSum'+algo10+algo11+',then set Pairs to '+algo12+','+algo13+',check if PairwiseSum'+algo14+algo15+',then set Pairs to '+algo16+','+algo17
            mydata.algorithm[0].noOfattempts=mydata.algorithm[0].noOfattempts+1
            console.log(out)
            if(out!=AlgoSpecificPairCalculate()){
                mydata.algorithm[0].userText1='incorrect answer'
            }
            if(myalgo2==='n'||myalgo3==='n'||myalgo4==='n'||myalgo5==='n'||algo19=='n'){
                mydata.algorithm[0].userText2='define n to 0'
            }
            else{
                mydata.algorithm[0].userText2=''
            }
            if(algo=='n'){
                mydata.algorithm[0].userText3='output n'
            }
            else{
                mydata.algorithm[0].userText3=''
            }
            if(myalgo7==12){
              mydata.algorithm[0].userText5=''
            }
            else{
              mydata.algorithm[0].userText5='firstNumPair!=index1'
            }
            if(myalgo9==37){
              mydata.algorithm[0].userText5=''
            }
            else{
              mydata.algorithm[0].userText5='secNumPair!=index6'
            }
            if(algo12=='increase'){
              mydata.algorithm[0].userText4=''
            }
            else{
              mydata.algorithm[0].userText4='PairwiseSum<n,decrease'
            }
            if(algo16=='decrease'){
              mydata.abstraction[0].userText4=''
            }
            else{
              mydata.algorithm[0].userText4='PairwiseSum>n,increase'
            }
            console.log(error)
        }
        err=error
        if(err===''){
          if(mydata.altStep==='decomposition'){
            var len = mydata.decomposition[0].alternateSolution.length-1;
            if(mydata.decomposition[0].alternateSolution[len].algoCompleted!==true){
              mydata.algorithm[0].noOfattempts=0
              mydata.algorithm[0].noOfaltattempts=mydata.algorithm[0].noOfaltattempts+1

            }
          }
          else if(mydata.altStep==='pattern'){
            var len = mydata.pattern[0].alternateSolution.length-1;
            if(mydata.pattern[0].alternateSolution[len].algoCompleted!==true){
              mydata.algorithm[0].noOfattempts=0
              mydata.algorithm[0].noOfaltattempts=mydata.algorithm[0].noOfaltattempts+1
            }
          }
          else if(mydata.altStep==='abstraction'){
            var len = mydata.abstraction[0].alternateSolution.length-1;
            if(mydata.abstraction[0].alternateSolution[len].algoCompleted!==true){
              mydata.algorithm[0].noOfattempts=0
              mydata.algorithm[0].noOfaltattempts=mydata.algorithm[0].noOfaltattempts+1
            }
          }
          arrStore.map((val, index)=>{
            mydata.algorithm[0].enteredSolution.push(val)
          })
        const data=
        {
          act:'activity4',
          algorithm: mydata.algorithm,
          problem: 'sumlogsclosest',
        }                     
        console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          console.log(response.data)
          const activity = response.data.activity4[0]
          setmydata(activity)
           settotaldata(response.data)
          var step = activity.altStep
          setarrStore([])
          if(step!==''){
            if(step=='decomposition'){
              var len = activity.decomposition[0].alternateSolution.length-1;
              var altcompleted = activity.decomposition[0].alternateSolution[len].algoCompleted
            }
            else if(step=='pattern'){
              var len = activity.pattern[0].alternateSolution.length-1;
              var altcompleted = activity.pattern[0].alternateSolution[len].algoCompleted
            }
            else if(step=='abstraction'){
              var len = activity.abstraction[0].alternateSolution.length-1;
              var altcompleted = activity.abstraction[0].alternateSolution[len].algoCompleted
            }
            console.log('Alternate solution'+len+' '+altcompleted)
          }
          if(activity.algorithm[0].proceed===true){
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            console.log('Going to'+activeStep)
            setansType("Correct Answer Bravo!! Let's move to next")
            if(activity.algorithm[0].completed===false){
              setmyspace(mydata.analysis[0].spaceText)
              setmytime(mydata.analysis[0].timeText) 
            }
            else{
              console.log('Going to'+activeStep)
              setmyspace(mydata.analysis[0].spaceText)
              setmytime(mydata.analysis[0].timeText) 
            }
          }
          else{
            if(step===''){
              setansType('Incorrect Answer.')
            }
            else if(step!=='' && altcompleted==false){
                if(activity.algorithm[0].noOfaltattempts<4){
                    setansType('Incorrect Answer. Try to connect your response to the previous step..')
                  }
                  else{
                    if(activity.altStep=='decomposition'){
                        setaltHint(activity.decomposition[0].hints[0].alternate)
                      }
                    else if(activity.altStep=='pattern'){
                        setaltHint(activity.pattern[0].hints[0].alternate)
                      }
                    else if(activity.altStep=='abstraction'){
                        setaltHint(activity.abstraction[0].hints[0].alternate)
                      }
                  }            
                }
            else if(step!=='' && altcompleted==true){
              setansType('Can you change your answer? Try following hint.')
            }

          }
          setisSubmit(false)
          setmyModalTwo(!myModalTwo)
          seterror('')          

      })
      }
      else{
        setisSubmit(false)
        setansType('see the error and change text/variable accordingly')
        setmyModalTwo(!myModalTwo)
      }
    }

      if(activeStep==4){

        setansType('')
        var err = ''
        if(myspace==''||myspace==' '){
          err='Please enter the no. of variables used'
        }
        else if(mytime==''||mytime==' '){
          err='Please enter the no. of operations used'
        }

        mydata.analysis[0].spaceText=myspace
        mydata.analysis[0].timeText=mytime
        mydata.analysis[0].noOfattempts=mydata.analysis[0].noOfattempts+1

        
        if(err===''){
          if(mydata.altStep==='decomposition'){
            var len = mydata.decomposition[0].alternateSolution.length-1;
            if(mydata.decomposition[0].alternateSolution[len].algoCompleted!==true){
              mydata.analysis[0].noOfattempts=0
              mydata.analysis[0].noOfaltattempts=mydata.analysis[0].noOfaltattempts+1
            }
          }
          else if(mydata.altStep==='pattern'){
            var len = mydata.pattern[0].alternateSolution.length-1;
            if(mydata.pattern[0].alternateSolution[len].algoCompleted!==true){
              mydata.analysis[0].noOfattempts=0
              mydata.analysis[0].noOfaltattempts=mydata.analysis[0].noOfaltattempts+1
            }
          }
          else if(mydata.altStep==='abstraction'){
            var len = mydata.abstraction[0].alternateSolution.length-1;
            if(mydata.abstraction[0].alternateSolution[len].algoCompleted!==true){
              mydata.analysis[0].noOfattempts=0
              mydata.analysis[0].noOfaltattempts=mydata.analysis[0].noOfaltattempts+1

            }
          }
          else if(mydata.altStep==='algorithm'){
            var len = mydata.algorithm[0].alternateSolution.length-1;
            if(mydata.algorithm[0].alternateSolution[len].algoCompleted!==true){
              mydata.analysis[0].noOfattempts=0
              mydata.analysis[0].noOfaltattempts=mydata.analysis[0].noOfaltattempts+1
            }
          }
          arrStore.map((val, index)=>{
            mydata.analysis[0].enteredSolution.push(val)
          })
        const data=
        {
          act:'activity4',
          analysis: mydata.analysis,
          problem: 'sumlogsclosest' 
        }                     
        //console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          console.log(response.data)
          const activity = response.data.activity4[0]
          setmydata(activity)
           settotaldata(response.data)
          var step = activity.altStep
          setarrStore([])
          if(step!==''){
            if(step=='decomposition'){
              var len = activity.decomposition[0].alternateSolution.length-1;
              var altcompleted = activity.decomposition[0].alternateSolution[len].algoCompleted
            }
            else if(step=='pattern'){
              var len = activity.pattern[0].alternateSolution.length-1;
              var altcompleted = activity.pattern[0].alternateSolution[len].algoCompleted
            }
            else if(step=='abstraction'){
              var len = activity.abstraction[0].alternateSolution.length-1;
              var altcompleted = activity.abstraction[0].alternateSolution[len].algoCompleted
            }
            else if(step=='algorithm'){
              var len = activity.algorithm[0].alternateSolution.length-1;
              var altcompleted = activity.algorithm[0].alternateSolution[len].algoCompleted
            }
          }
            if(activity.analysis[0].proceed===true){
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
              console.log('Going to'+activeStep)
              if(activity.analysis[0].completed==false){
                setansType(' Your answer is correct but not the best. Try going back and change your solution to improve your solution.')
              }
              else{
                setansType('Correct Answer Bravo!!! The solution takes minimum operations')
              }
              
            }
            else{              
              if(step===''){
                setansType('Incorrect Answer.')
              }
              else if(step!=='' && altcompleted==false){
                  if(activity.analysis[0].noOfaltattempts<4){
                      setansType('Incorrect Answer. Try to analyse the algorithm developed in the previous step..')
                    }
                    else{
                      if(activity.altStep=='decomposition'){
                          setaltHint(activity.decomposition[0].hints[0].alternate)
                        }
                      else if(activity.altStep=='pattern'){
                          setaltHint(activity.pattern[0].hints[0].alternate)
                        }
                      else if(activity.altStep=='abstraction'){
                          setaltHint(activity.abstraction[0].hints[0].alternate)
                        }
                      else if(activity.altStep=='algorithm'){
                          setaltHint(activity.algorithm[0].hints[0].alternate)
                        }
                    }            
                  }
              else if(step!=='' && altcompleted==true){
                setansType('Can you change your answer? Try following hint.')
              }
            }     
            setisSubmit(false)     
            setmyModalTwo(!myModalTwo)
            seterror('')
      })
    }
    else{
      setisSubmit(false)
      setansType(err)
      setmyModalTwo(!myModalTwo)

    }
  }
  if(activeStep==5){
    setansType('')
    const data=
        {
          act:'activity4',
          comparison: mydata.comparison,
          problem: 'sumlogsclosest' 
        }                     
        //console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          console.log(response.data)
          const activity = response.data.activity4[0]
          setmydata(activity)
           settotaldata(response.data)
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setmyModalTwo(!myModalTwo) ////code for hints modal 
          var len=0
          if(typeof(activity.decomposition[0].alternateSolution.length)!='undefined'){
            len=activity.decomposition[0].alternateSolution.length
          }
          if(typeof(activity.pattern[0].alternateSolution.length)!='undefined'){
            len=len+mydata.pattern[0].alternateSolution.length
          }
          if(typeof(activity.abstraction[0].alternateSolution.length)!='undefined'){
            len=len+activity.abstraction[0].alternateSolution.length
          }
          if(typeof(activity.algorithm[0].alternateSolution.length)!='undefined'){
            len=len+activity.algorithm[0].alternateSolution.length
          }
          if(typeof(activity.comparison[0].alternateSolution.length)!='undefined'){
            len=len+activity.comparison[0].alternateSolution.length
          }
          var list = new Array(len+1)
          for(let i=0; i<list.length;i++){
            var num=i+1
              list[i] = {
                'label':'solution'+num,
                'value':'solution'+num
              };
            }
            setsollist(list)
            setmycomsol(mydata.comparison[0].userText1) 
            setmycomsol1(mydata.comparison[0].userText2) 
            setmycomsol2(mydata.comparison[0].userText4) 
            setmycomsol3(mydata.comparison[0].userText5) 
            setisSubmit(false)
           setExpanded1('panel12')
           setmyModalTwo(!myModalTwo) ////code for hints modal
      })
    }
    if(activeStep==6){
      
      var empty = true;
      if(mycomsol !== '' && mycomsol2 !== '' && mycomsol1!=='' && mycomsol3!==''){
        empty=false
      }
       if(empty===true){
          setisSubmit(false)        
          seterror('Please enter text above')
        }
        else{
            seterror('')
            mydata.comparison[0].userText='Which of the solution do you think is better'
            mydata.comparison[0].userText1=mycomsol
            mydata.comparison[0].userText2=mycomsol1
            mydata.comparison[0].userText3='Your system can perform only maximum 15 operations. If you want to implement one of the solutions, which one do you think is better?'
            mydata.comparison[0].userText4=mycomsol2
            mydata.comparison[0].userText5=mycomsol3
            arrStore.map((val, index)=>{
              mydata.comparison[0].enteredSolution.push(val)
          })
            const data=
            {
              act:'activity4',
              comparison:mydata.comparison,
              submit:true
            }                     
            console.log(data)
      
          axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
          .then((response) => {
              console.log(response.data)
              const activity = response.data.activity4[0]
              setmydata(activity)
           settotaldata(response.data)
              setisSubmit(false)        
              movedat('activity4','activity5','correct')
              history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/analytics/4`)
 
        })
      }
    } 
          
}


 

    const closeModalNoThree=()=>{
      setmyModalThree(!myModalThree)
      setisSubmit(false)
    }

    


    function getStepContent(step) {
      switch (step) {
        case 0:
          return 'decomposition' ;
        case 1:
          return 'pattern';
        case 2:
          return 'abstraction';
        case 3:
          return 'algorithm';
        case 4:
          return 'analysis';
        case 5:
          return 'solution';
        case 6:
          return 'comparison';
        case 7:
          return 'activity5';
        default:
          return 'unknown';
      }
    }
    const updateCount = (count) =>{
      //console.log(count)
      
      setNum(count)

      if(count<=user.fcount)
      {
        count=count+1
        dispatch(
          upCount(count)
        )
      }
      
    }

    

  const getData = (sessid) =>{
      const config = {
        headers: { Authorization: `Bearer ${user.token}` }
    };
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      //var num = Num+1
      //setNum(num)
      axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
          .then((response) =>{
            //console.log(response.data)
            const activity = response.data.activity4[0]
            settotaldata(response.data)
            //console.log(activity)
            setmydata(activity)
           settotaldata(response.data)
           
  
      })
    
  }

  ////////////Code for Stepper////////////////////////////

  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  const handleNext = () => {
    var comp=false;

    if(activeStep==0 && mydata.decomposition[0].proceed===true){
      
      console.log('Going next Completed decomposition')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setansType('')
      setmyModalTwo(!myModalTwo) ////code for hints modal
      if(mydata.decomposition[0].completed===true){
        if(mydata.pattern.length!=='0'){ 
          if(mydata.pattern[0].userText!==''){
            var newarr = mydata.pattern[0].userText.split(':')
            if(newarr[0]==='find all pair'){
              var arr1 = newarr[1].split(',')
              var arr2 = newarr[2].split(',')
              var arr3 = newarr[4].split(',')
                setpatnum('find all pair:')
                setpatnum1(arr1[2])
                setpatnum2(arr1[4])
                setnum9(arr2[1])
                setpatnum3(arr2[3])
                setpatnum4(arr2[4])
                setpatnum5(arr2[5])
                setpatnum6(arr3[0])
                setpatnum7(arr3[1])
            }
            else{
                setpatnum('find specific pair:')
                var arr1 = newarr[1].split(',')
                var arr2 = newarr[2].split(',')
                var arr3 = newarr[3].split(',')
                var arr4 = newarr[5].split(',')
                  setpatnum8(arr1[1])
                  setpatnum9(arr1[3])
                  setpatnum1(arr2[2])
                  setpatnum2(arr2[4])
                  setnum9(arr3[1])
                  setpatnum3(arr3[3])
                  setpatnum4(arr3[4])
                  setpatnum5(arr3[5])
                  setpatnum6(arr4[0])
                  setpatnum7(arr4[1])
            }
           

          }
          else{
            setpatnum1('')
            setpatnum2('')
            setpatnum3('')
            setpatnum4('')
            setpatnum5('')
            setpatnum6('')
            setpatnum7('')
            setpatnum8('')
            setpatnum9('')
           
          }
          setmypattern(mydata.pattern[0].userText)
        }
    }
    else{

    }
      comp=true;
    }
    else if(activeStep==1 && mydata.pattern[0].proceed===true){
      console.log('Going next Completed pattern')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setansType('')
      setmyModalTwo(!myModalTwo) ////code for hints modal
      if(mydata.pattern[0].completed===true){
        var txt = mydata.abstraction[0].userText.split(':')

            if(txt[0]==='find specific pair'){
              var newarr = txt[1].split(',')
              var newarr1 = txt[2].split(',')
              setabs1(newarr[1])
              setabs2(newarr[3])
              setabs3(newarr1[1])
              setabs4(newarr1[2])
              setabs5(newarr1[3])
              setabs14(newarr1[5])
              setabs15(newarr1[6])
              setabs6(newarr1[8])
              setabs7(newarr1[9])
              setmyabs1(newarr1[11])
              setmyabs2(newarr1[12])
              setabs8(newarr1[16])
              setabs9(newarr1[17])
              setabs10(newarr1[18])
              setabs11(newarr1[21])
              setabs12(newarr1[22])
              setabs13(newarr1[23])

            }
            
      }
      else{
        var text = mydata.pattern[0].userText.split(':')
        if(mydata.abstraction[0].userText!==''){
            var txt = mydata.abstraction[0].userText.split(':')
            if(text[0]==='find specific pair'){
                var newarr = txt[1].split(',')
                console.log(newarr[0])
                setabs1(newarr[0])
                setmyabs1(newarr[0])
                setabs2(newarr[1])
                setabs3(newarr[2])
                setmyabs2(newarr[2])
                setabs4(newarr[3])
                setabs5(newarr[4])

            }
            else if(text[0]==='find all pair'){

                var newarr = txt[1].split(',')
                var newarr1 = txt[2].split(',')
                setabs1(newarr[1])
                setabs2(newarr[3])
                setabs3(newarr1[1])
                setabs4(newarr1[2])
                setabs5(newarr1[3])
                setabs14(newarr1[5])
                setabs15(newarr1[6])
                setabs6(newarr1[8])
                setabs7(newarr1[9])
                setmyabs1(newarr1[11])
                setmyabs2(newarr1[12])

            }

        }
        else{
            if(text[0]==='find specific pair'){
                ///var pat = commaToText(text[1])
                setabs2('')
            }
            else if(text[0]==='find all pair'){
                var pat = text[1]
                var newArr = pat.split('+')
                var mytext=newArr[0]+'+'+newArr[1]
                var i=2
                while(newArr[i]!==''&& i<newArr.length){
                    numberFiboList.map((text, index)=>{
                      if(text.value==newArr[i]){
                          newArr[i]=text.label
                      }
                  })
                  mytext=mytext+'+('+newArr[i]+')'
                  i=i+1
              }  
                setabs2(mytext)
                
            }
        }
        
     }

      comp=true;

    }
    else if(activeStep==2 && mydata.abstraction[0].proceed===true){
      console.log('Going next Completed abstraction')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setansType('') 
      var setsum= mydata.abstraction[0].userText.split(':')

      setmyModalTwo(!myModalTwo) ////code for hints modal
      if(mydata.abstraction[0].completed===true){
        
        if(mydata.algorithm[0].userText!==''){

            if(mydata.abstraction[0].userText.includes('find specific pair')==true){
              var newarr = mydata.algorithm[0].userText.split(';')
              var inparr = newarr[0].split(',')
              setmyalgo1(inparr[1])
              var defarr = newarr[1].split(',')
              setmyalgo2(defarr[1])
              setmyalgo3(defarr[2])
              setalgo18(defarr[3])
              setmyalgo4(defarr[4])
              setalgo19(defarr[5])
              setmyalgo5(defarr[6])
              var setarr = newarr[2].split(',')
              setmyalgo6(setarr[1])
              setmyalgo7(setarr[3])
              setmyalgo8(setarr[5])
              setmyalgo9(setarr[7])
              setalgo1(setarr[9])
              setalgo2(setarr[11])
              setalgo3(setarr[12])
              setalgo4(setarr[13])
              setalgo20(setarr[15])
              setalgo21(setarr[18])
              setalgo22(setarr[19])
              setalgo5(setarr[22])
              setalgo6(setarr[23])
              setalgo7(setarr[29])
              setalgo8(setarr[31])
              setalgo9(setarr[32])
              setalgo10(setarr[35])
              setalgo11(setarr[36])
              setalgo12(setarr[38])
              setalgo13(setarr[39])
              setalgo14(setarr[42])
              setalgo15(setarr[43])
              setalgo16(setarr[45])
              setalgo17(setarr[46])
              var outarr = newarr[3].split(',')
              setalgo(outarr[1])
            }
    
        }
      }
      else{
         if(mydata.abstraction[0].userText.includes('find all pair')==true){
            console.log('In find all pair')

            if(mydata.algorithm[0].userText!==''){
                var newarr = mydata.algorithm[0].userText.split(';')
                var inparr = newarr[0].split(',')
                setmyalgo1(inparr[1])
                var defarr = newarr[1].split(',')
                setmyalgo2(defarr[1])
                setmyalgo3(defarr[2])
                setalgo18(defarr[3])
                setmyalgo4(defarr[4])
                setalgo19(defarr[5])
                setmyalgo5(defarr[6])
                var setarr = newarr[2].split(',')
                setmyalgo6(setarr[1])
                setmyalgo7(setarr[3])
                setmyalgo8(setarr[5])
                setmyalgo9(setarr[7])
                setalgo1(setarr[9])
                setalgo2(setarr[11])
                setalgo3(setarr[12])
                setalgo4(setarr[13])
                setalgo20(setarr[15])
                setalgo21(setarr[18])
                setalgo22(setarr[19])
                setalgo5(setarr[22])
                setalgo6(setarr[23])
                setalgo7(setarr[29])
                setalgo8(setarr[31])
                setalgo9(setarr[32])
                var outarr = newarr[3].split(',')
                setalgo(outarr[1])
              }
                
            
        }
      }
    
      comp=true;

    }
    else if(activeStep==3 && mydata.algorithm[0].proceed===true){
      console.log('Going next Completed algorithm')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setansType('')
      setmyModalTwo(!myModalTwo) ////code for hints modal
      if(mydata.algorithm[0].completed===true){
        setmyspace(mydata.analysis[0].spaceText)
        setmytime(mydata.analysis[0].timeText)     
      }
      else{
        setmyspace(mydata.analysis[0].spaceText)
        setmytime(mydata.analysis[0].timeText)

      }
      
      comp=true;
    }
    else if(activeStep==4 && mydata.analysis[0].proceed===true){
      console.log('Going next Completed Analysis')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setmyModalTwo(!myModalTwo) ////code for hints modal
  
      if(mydata.analysis[0].completed===true){
        setansType('')
        // setmyspace(mydata.analysis[0].spaceText)
        // setmytime(mydata.analysis[0].timeText)     
      }
      
      comp=true;
    }
    else if(activeStep==5 && mydata.comparison[0].completed===true){
      setExpanded1('panel12')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setmyModalTwo(!myModalTwo) ////code for hints modal 
      var len=0
      if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
        len=mydata.decomposition[0].alternateSolution.length
      }
      if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
        len=len+mydata.pattern[0].alternateSolution.length
      }
      if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
        len=len+mydata.abstraction[0].alternateSolution.length
      }
      if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
        len=len+mydata.algorithm[0].alternateSolution.length
      }
      if(typeof(mydata.comparison[0].alternateSolution.length)!='undefined'){
        len=len+mydata.comparison[0].alternateSolution.length
      }
      var list = new Array(len+1)
      for(let i=0; i<list.length;i++){
        var num=i+1
          list[i] = {
            'label':'solution'+num,
            'value':'solution'+num
          };
        }
        setsollist(list)
        setmycomsol(mydata.comparison[0].userText1) 
        setmycomsol1(mydata.comparison[0].userText2) 
        setmycomsol2(mydata.comparison[0].userText4) 
        setmycomsol3(mydata.comparison[0].userText5) 
       
       setmyModalTwo(!myModalTwo) ////code for hints modal
       comp=true;
    }
    else if(activeStep==6 && mydata.completed===true){
      history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/analytics/4`)
      comp=true
      
    }
    
    console.log(activeStep)

   if(comp===false){
     console.log('Not completed step')
    setmyModalThree(!myModalThree)
   }
   else{
    movedat(getStepContent(activeStep),getStepContent(activeStep+1),'completed')
    setarrStore([])
  }  

  };

  const handleBack = () => {

    movedat(getStepContent(activeStep),getStepContent(activeStep-1),'completed')
    setarrStore([])
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    console.log('Going Back to '+activeStep)
    console.log(mydata)
////Code to update the text area when click back
    if(activeStep-1==0){
      if(mydata.decomposition.length=='0'){
        setmydeco('')
      }
      else{
        setmydeco(mydata.decomposition[0].userText)

      }
    }
    else if(activeStep-1==1){
      if(mydata.pattern.length=='0'){
        setmypattern('')
      }
      else{
        setmypattern(mydata.pattern[0].userText)
      }
    }
    else if(activeStep-1==2){
    
        setmyabstract(mydata.abstraction[0].userText)
      
    }
    else if(activeStep-1==3){
        // setmyalgo(mydata.algorithm[0].userText)
    }
    else if(activeStep-1==4){
        setmytime(mydata.analysis[0].timeText)
        setmyspace(mydata.analysis[0].spaceText) 
      
    }

  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleAltSolution = () => {
    setarrStore([])
    setaltHint('')
    setisSubmit(true)
    setansType('Change you current solution')
    seterror('')
    if(mydata.altStep==='decomposition'){
      mydata.decomposition[0].proceed=false
      const data=
      {
        act: 'activity4',
        decomposition: mydata.decomposition
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        movedat('solution','decomposition','altcompleted')
        setisSubmit(false)
        const activity = response.data.activity4[0]
        setmydata(activity)
           settotaldata(response.data)
        setActiveStep(0);
    })
    }
    else if(mydata.altStep==='pattern'){
      mydata.pattern[0].proceed=false
      const data=
      {
        act: 'activity4',
        pattern: mydata.pattern
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        movedat('solution','pattern','altcompleted')
        setisSubmit(false)
        const activity = response.data.activity4[0]
        setmydata(activity)
           settotaldata(response.data)
        setActiveStep(1);
    })
    }
    if(mydata.altStep==='abstraction'){
      mydata.abstraction[0].proceed=false
      const data=
      {
        act: 'activity4',
        abstraction: mydata.abstraction
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        movedat('solution','abstraction','altcompleted')
        setisSubmit(false)
        const activity = response.data.activity4[0]
        setmydata(activity)
        settotaldata(response.data)
        setActiveStep(2);
    })
    }
    if(mydata.altStep==='algorithm'){
      mydata.algorithm[0].proceed=false
      const data=
      {
        act: 'activity4',
        algorithm: mydata.algorithm
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        movedat('solution','algorithm','altcompleted')
        setisSubmit(false)
        const activity = response.data.activity4[0]
        setmydata(activity)
           settotaldata(response.data)
        setActiveStep(3);
    })
    }

  }

  /////////////////////////////////////////////////////


 

    const ToggleHint = () =>{
      if(loadhint==true){
      setloadhint(false)
      }
      else{
        setloadhint(true)
      }
    } 
    
    const Togglesupport = () =>{
      setloadsupport(!loadsupport)
      
    }



      const handleClosePreview= () => {
        setopenBoard(!openBoard)
      }

      const handleAccordionChange = (panel) => (event, isExpanded) => {
        setloadintro(false)
        if(panel==='panel8'){
          if(isExpanded===true){
            setmyModalTwo(!myModalTwo)
          }
        }
        setExpanded(isExpanded ? panel : false);
      };

      const handleAccordionChange1 = (panel) => (event, isExpanded) => {
        
        setExpanded1(isExpanded ? panel : false);
      };


      function MyCustomUploadAdapterPlugin(editor){
        editor.plugins.get( 'FileRepository' ).createUploadAdapter = (loader) => {
          return new MyUploadAdapter(loader)
        }
      }

      class MyUploadAdapter {
        constructor(props) {
            // CKEditor 5's FileLoader instance.
          this.loader = props;
          // URL where to send files.
          this.url = `${baseUrl}fileupload/files`;
        }
    
        // Starts the upload process.
        upload() {
          return this.loader.file
              .then( file => new Promise( ( resolve, reject ) => {
  
                  const toBase64 = file => new Promise((resolve, reject) => {
                      const reader = new FileReader();
                      reader.readAsDataURL(file);
                      reader.onload = () => resolve(reader.result);
                      reader.onerror = error => reject(error);
                  });
                  
                  return toBase64(file).then(cFile=>{
                    console.log(file)
                    const data=new FormData();
                    data.append('file', file)   
                    var filename = '';
                  axios.post(`${baseUrl}fileupload/files`, data)
                          .then((response) => {
                              console.log(response.data.file.filename)
                              filename = response.data.file.filename;
                              resolve({ 
                                default: `${baseUrl}fileupload/files/${filename}` 
                              })
                          })
                          .catch((error)=>{
                              reject(`Couldn't upload file: ${ file.name }.`)
                            console.log(error);
                            });
                          })
                  
              } ) );
      }
    
    }

    const handleTermChange =(event)=> {
      settermsum(event.target.value)
    }
    const handleNum1Change =(event)=> {
      setnum1(event.target.value)
    }
    const handleNum2Change =(event)=> {
      setnum2(event.target.value)
    }
    const handleNum3Change =(event)=> {
      setnum3(event.target.value)
    }
    const handleNum4Change =(event)=> {
      setnum4(event.target.value)
    }
    const handleNum5Change =(event)=> {
      setnum5(event.target.value)
    }
    const handleNum6Change =(event)=> {
      setnum6(event.target.value)
    }
    const handleNum7Change =(event)=> {
        setnum7(event.target.value)
      }
    const handleNum8Change =(event)=> {
        setnum8(event.target.value)
      }
    const handleNum9Change =(event)=> {
        setnum9(event.target.value)
    }
    const handleNum10Change =(event)=> {
        setnum10(event.target.value)
    }
    const handleNum11Change =(event)=> {
        setnum11(event.target.value)
    }
    const handleNum12Change =(event)=> {
        setnum12(event.target.value)
    }
    const handlePatnumChange =(event)=> {
        setpatnum(event.target.value)
      }
    const handlePatnum1Change =(event)=> {
      setpatnum1(event.target.value)
    }
    const handlePatnum2Change =(event)=> {
      setpatnum2(event.target.value)
    }
    const handlePatnum3Change =(event)=> {
      setpatnum3(event.target.value)
    }
    const handlePatnum4Change =(event)=> {
      setpatnum4(event.target.value)
    }
    const handlePatnum5Change =(event)=> {
      setpatnum5(event.target.value)
    }
    const handlePatnum6Change =(event)=> {
      setpatnum6(event.target.value)
    }
    const handlePatnum7Change =(event)=> {
      setpatnum7(event.target.value)
    }
    const handlePatnum8Change =(event)=> {
      setpatnum8(event.target.value)
    }
    const handlePatnum9Change =(event)=> {
        setpatnum9(event.target.value)
    }
   
  
    const PairCalculate=()=>{
      var code='return 1'
      var arr=[12, 17, 24, 27, 33, 37]
      var ind1=0
      var ind2=0
      arr.map((text, index)=>{
        if (text==abs1){
            ind1=index          
        }
        if(text==abs2){
          ind2=index
        }
      })
      if(abs15!=='' && typeof(abs15)!='undefined' && abs14!=='' && typeof(abs14)!='undefined' && myabs2!=='' && typeof(myabs2)!='undefined' && myabs1!=='' && typeof(myabs1)!='undefined' && abs7!=='' && typeof(abs7)!='undefined' && abs6!=='' && typeof(abs6)!='undefined' && abs4!=='' && typeof(abs4)!='undefined' && abs5!=='' && typeof(abs5)!='undefined' && abs1!=='' && typeof(abs1)!='undefined' && abs2!=='' && typeof(abs2)!='undefined' && abs3!=='' && typeof(abs3)!='undefined'){
        var inde1='index1'
        var inde2='index1'
        var inde3='index1'  
        var inde4='index1'    
        if(abs3=='firstNumPair'){
            inde1='index1'
          }
          else{
            inde1='index2'
          } 
          if(abs5=='firstNumPair'){
            inde2='index1'
          }
          else{
            inde2='index2'
          } 
          if(myabs1=='firstNumPair'){
            inde3='index1'
          }
          else{
            inde3='index2'
          } 
          if(myabs2=='firstNumPair'){
            inde4='index1'
          }
          else{
            inde4='index2'
          }
        code=`maximum=0;arr=[12, 17, 24, 27, 33, 37];n=${absNum};minimum=9999;Difference=0;calculatedSum='';pairs='not found';index1=0;index2=0;for(index1=${ind1};index1<6;index1++){for(index2=${ind2};index2<6;index2++){calculatedSum=arr[${inde1}]${abs4}arr[${inde2}];Difference=Math.abs(calculatedSum${abs14}${abs15});if(Difference${abs6}${abs7}){pairs=arr[${inde3}]+','+arr[${inde4}];${abs7}=Difference;}}}; return pairs`
      }
      console.log(code)
      const F = new Function(code);  
      var out = F()
      return out
  }

  const PairSpecificCalculate=()=>{
    var code='return 1'
    var arr=[12, 17, 24, 27, 33, 37]
    var ind1=0
    var ind2=0
    arr.map((text, index)=>{
      if (text==abs1){
          ind1=index          
      }
      if(text==abs2){
        ind2=index
      }
    })
    if(abs15!=='' && typeof(abs15)!='undefined' && abs14!=='' && typeof(abs14)!='undefined' && abs13!=='' && typeof(abs13)!='undefined' && abs12!=='' && typeof(abs12)!='undefined' && abs11!=='' && typeof(abs11)!='undefined' && abs10!=='' && typeof(abs10)!='undefined' && abs9!=='' && typeof(abs9)!='undefined' && abs8!=='' && typeof(abs8)!='undefined' && myabs2!=='' && typeof(myabs2)!='undefined' && myabs1!=='' && typeof(myabs1)!='undefined' && abs7!=='' && typeof(abs7)!='undefined' && abs6!=='' && typeof(abs6)!='undefined' && abs4!=='' && typeof(abs4)!='undefined' && abs5!=='' && typeof(abs5)!='undefined' && abs1!=='' && typeof(abs1)!='undefined' && abs2!=='' && typeof(abs2)!='undefined' && abs3!=='' && typeof(abs3)!='undefined'){
      var inde1='index1'
      var inde2='index1'
      var inde3='index1'  
      var inde4='index1' 
      var inc='++'
      var dec='--'   
      if(abs3=='firstNumPair'){
          inde1='index1'
        }
        else{
          inde1='index2'
        } 
        if(abs5=='firstNumPair'){
          inde2='index1'
        }
        else{
          inde2='index2'
        } 
        if(myabs1=='firstNumPair'){
          inde3='index1'
        }
        else{
          inde3='index2'
        } 
        if(myabs2=='firstNumPair'){
          inde4='index1'
        }
        else{
          inde4='index2'
        }
        if(abs10==='decrease'){
          inc='--'
        }
        if(abs13=='increase'){
          dec='++'
        }
      code=`arr=[12, 17, 24, 27, 33, 37];calculatedSum=0;Difference=0;maximum=0;minimum=999;n=${absNum};pairs='not found';k=0;found=false;index1=${ind1};index2=${ind2};while(arr[index1]!=arr[index2] && found==false && index1<6 && index1>-1 && index2>-1 && index2<6){k++;calculatedSum=arr[${inde1}]${abs4}arr[${inde2}];Difference=Math.abs(calculatedSum${abs14}${abs15});if(Difference${abs6}${abs7}){${abs7}=Difference;pairs=arr[${inde3}]+','+arr[${inde4}];}if(calculatedSum${abs8}${abs9}){index1${inc};}else if(calculatedSum${abs11}${abs12}){index2${dec};}if(k>30){found=true;}}; return pairs`
    }
    console.log(code)
    const F = new Function(code);  
    var out = F()
    return out
}

  const AlgoPairCalculate=()=>{
    var code='return 1'
    var arr=[12, 17, 24, 27, 33, 37]
    var ind1=0
    var ind2=0
    arr.map((text, index)=>{
      if (text==myalgo7){
          ind1=index          
      }
      if(text==myalgo9){
        ind2=index
      }
    })
    var err=''
    
    if(myalgo1===''){
      err='Please provide an input statement'
    }
    else if(myalgo2===''|| myalgo3==='' || myalgo4===''|| myalgo5==='' || algo18=='' || algo19==''){
      err='Please select a new define variable'
    }
    else if(myalgo6==='' || myalgo8===''){
      err='Define a set variable'
    }
    else if(myalgo7=='' || myalgo9==''){
      err='set variable to a value'
    }
    else if(algo1=='' || algo2=='' || algo3==''|| algo4=='' || algo20=='' || algo21=='' || algo22==''){
      err='Complete the for statement to calculate pairwise sum and difference'
    }
    else if(algo5=='' || algo6=='' || algo7==''|| algo8==''|| algo9=='' ){
      err='check if pairwise sum is equal to n and set pairs as first and second pair'
    }
    else if(algo===''){
      err='please define an output variable'
    }
    else{
    var incVar = false
      if(algo1==myalgo4||algo1==myalgo5||algo1==myalgo1||algo1==algo18||algo1==algo19){
        incVar=true
      }
      if(incVar===false){
          err='Setting variable to incorrect value. Please change set variable '+myalgo7+' to a variable declared previously'
      }
      
      incVar = false
      if(algo7==myalgo4 || algo7==myalgo5 || algo7==myalgo1 || algo7==algo18 || algo7==algo19){
           incVar=true
      }
      if(incVar===false){
             err='Setting variable to incorrect value. Please change set variable '+algo7+' to a variable declared previously'
      }
      
    var incVar2=false
    if(algo===myalgo4){
      incVar2=true
    }
    else if(algo===myalgo5){
      incVar2=true
    }
    else if(algo===myalgo1){
      incVar2=true
    }
    else if(algo===algo18){
      incVar2=true
    }
    else if(algo===algo19){
      incVar2=true
    }
    if(incVar2===false){
      err='Output variable incorrect. Please change the output variable and set it to previously declared variable'
    }
  }
  
      if(err==''){
        if(algo22!=='' && typeof(algo22)!='undefined' && algo21!=='' && typeof(algo21)!='undefined' && algo20!=='' && typeof(algo20)!='undefined' && algo19!=='' && typeof(algo19)!='undefined' && algo18!=='' && typeof(algo18)!='undefined' && algo9!=='' && typeof(algo9)!='undefined' && algo8!=='' && typeof(algo8)!='undefined' && algo7!=='' && typeof(algo7)!='undefined' && algo6!=='' && typeof(algo6)!='undefined' && algo5!=='' && typeof(algo5)!='undefined' && algo4!=='' && typeof(algo4)!='undefined' && algo3!=='' && typeof(algo3)!='undefined' && algo2!=='' && typeof(algo2)!='undefined' && algo1!=='' && typeof(algo1)!='undefined' && algo!=='' && typeof(algo)!='undefined' && myalgo9!=='' && typeof(myalgo9)!='undefined' && myalgo8!=='' && typeof(myalgo8)!='undefined' && myalgo7!=='' && typeof(myalgo7)!='undefined' && myalgo6!=='' && typeof(myalgo6)!='undefined' && myalgo5!=='' && typeof(myalgo5)!='undefined' && myalgo4!=='' && typeof(myalgo4)!='undefined' && myalgo3!=='' && typeof(myalgo3)!='undefined' && myalgo2!=='' && typeof(myalgo2)!='undefined' && myalgo1!=='' && typeof(myalgo1)!='undefined'){
          var inde1='index1'
          var inde2='index1'
          var inde3='index1'  
          var inde4='index1'    
          if(algo2=='firstNumPair'){
              inde1='index1'
            }
            else{
              inde1='index2'
            } 
            if(algo4=='firstNumPair'){
              inde2='index1'
            }
            else{
              inde2='index2'
            } 
            if(algo8=='firstNumPair'){
              inde3='index1'
            }
            else{
              inde3='index2'
            } 
            if(algo9=='firstNumPair'){
              inde4='index1'
            }
            else{
              inde4='index2'
            }
          code=`minimum=0;maximum=9999;arr=[12, 17, 24, 27, 33, 37];n=${absNum};${myalgo4}=0;${algo18}=9999;${algo19}=0;${myalgo5}='not found';calculatedSum='';pairs='not found';index1=0;index2=0;for(index1=${ind1};index1<6;index1++){for(index2=${ind2};index2<6;index2++){${algo1}=arr[${inde1}]${algo3}arr[${inde2}];${algo20}=Math.abs(${algo1}${algo21}${algo22});if(${algo20}${algo5}${algo6}){${algo6}=${algo20};${algo7}=arr[${inde3}]+','+arr[${inde4}];}}}; return ${algo}`
        }
      }
    seterror(err)
    console.log(code)
    const F = new Function(code);  
    var out = F()
    return out
}
      

const AlgoSpecificPairCalculate=()=>{
  var code='return 1'
  var arr=[12, 17, 24, 27, 33, 37]
  var ind1=0
  var ind2=0
  arr.map((text, index)=>{
    if (text==myalgo7){
        ind1=index          
    }
    if(text==myalgo9){
      ind2=index
    }
  })
  var err=''
  
  if(myalgo1===''){
    err='Please provide an input statement'
  }
  else if(myalgo2===''|| myalgo3==='' || myalgo4===''|| myalgo5==='' || algo18===''|| algo19===''){
    err='Please select a new define variable'
  }
  else if(myalgo6==='' || myalgo8===''){
    err='Define a set variable'
  }
  else if(myalgo7=='' || myalgo9==''){
    err='set variable to a value'
  }
  else if(algo1=='' || algo2=='' || algo3==''|| algo4==''|| algo20=='' || algo21=='' || algo22==''){
    err='Complete the for statement to calculate pairwise sum and difference'
  }
  else if(algo5=='' || algo6=='' || algo7==''|| algo8==''|| algo9=='' ){
    err='check if pairwise sum is equal to n and set pairs as first and second pair'
  }
  else if(algo10=='' || algo11=='' || algo12==''|| algo13==''){
    err='check if pairwise sum is less than n change first pair'
  }
  else if(algo14=='' || algo15=='' || algo16==''|| algo17==''){
    err='check if pairwise sum is greater than n change second pair'
  }
  else if(algo===''){
    err='please define an output variable'
  }
  else{
  var incVar = false
    if(algo1==myalgo4||algo1==myalgo5||algo1==myalgo1||algo1==algo18||algo1==algo19){
      incVar=true
    }
    if(incVar===false){
        err='Setting variable to incorrect value. Please change set variable '+algo1+' to a variable declared previously'
    }
    
    incVar = false
    if(algo7==myalgo4 || algo7==myalgo5 || algo7==myalgo1|| algo7==algo18 || algo7==algo19){
         incVar=true
    }
    if(incVar===false){
           err='Setting variable to incorrect value. Please change set variable '+algo7+' to a variable declared previously'
    }
    
  var incVar2=false
  if(algo===myalgo4){
    incVar2=true
  }
  else if(algo===myalgo5){
    incVar2=true
  }
  else if(algo===myalgo1){
    incVar2=true
  }
  else if(algo===algo18){
    incVar2=true
  }
  else if(algo===algo19){
    incVar2=true
  }
  if(incVar2===false){
    err='Output variable incorrect. Please change the output variable and set it to previously declared variable'
  }
  }

    if(err==''){
      if(algo22!=='' && typeof(algo22)!='undefined' && algo21!=='' && typeof(algo21)!='undefined' && algo20!=='' && typeof(algo20)!='undefined' && algo19!=='' && typeof(algo19)!='undefined' && algo18!=='' && typeof(algo18)!='undefined' && algo17!=='' && typeof(algo17)!='undefined' && algo16!=='' && typeof(algo16)!='undefined' && algo15!=='' && typeof(algo15)!='undefined' && algo14!=='' && typeof(algo14)!='undefined' && algo13!=='' && typeof(algo13)!='undefined' && algo12!=='' && typeof(algo12)!='undefined' && algo11!=='' && typeof(algo11)!='undefined' && algo10!=='' && typeof(algo10)!='undefined' && algo9!=='' && typeof(algo9)!='undefined' && algo8!=='' && typeof(algo8)!='undefined' && algo7!=='' && typeof(algo7)!='undefined' && algo6!=='' && typeof(algo6)!='undefined' && algo5!=='' && typeof(algo5)!='undefined' && algo4!=='' && typeof(algo4)!='undefined' && algo3!=='' && typeof(algo3)!='undefined' && algo2!=='' && typeof(algo2)!='undefined' && algo1!=='' && typeof(algo1)!='undefined' && algo!=='' && typeof(algo)!='undefined' && myalgo9!=='' && typeof(myalgo9)!='undefined' && myalgo8!=='' && typeof(myalgo8)!='undefined' && myalgo7!=='' && typeof(myalgo7)!='undefined' && myalgo6!=='' && typeof(myalgo6)!='undefined' && myalgo5!=='' && typeof(myalgo5)!='undefined' && myalgo4!=='' && typeof(myalgo4)!='undefined' && myalgo3!=='' && typeof(myalgo3)!='undefined' && myalgo2!=='' && typeof(myalgo2)!='undefined' && myalgo1!=='' && typeof(myalgo1)!='undefined'){
        var inde1='index1'
        var inde2='index1'
        var inde3='index1'  
        var inde4='index1'
        var inde5='index1'  
        var inde6='index1'
        var inc='++'
        var dec='--'    
        if(algo2=='firstNumPair'){
            inde1='index1'
          }
          else{
            inde1='index2'
          } 
          if(algo4=='firstNumPair'){
            inde2='index1'
          }
          else{
            inde2='index2'
          } 
          if(algo8=='firstNumPair'){
            inde3='index1'
          }
          else{
            inde3='index2'
          } 
          if(algo9=='firstNumPair'){
            inde4='index1'
          }
          else{
            inde4='index2'
          }
          if(algo13=='firstNumPair'){
            inde5='index1'
          }
          else{
            inde5='index2'
          } 
          if(algo17=='firstNumPair'){
            inde6='index1'
          }
          else{
            inde6='index2'
          }
          if(algo12==='decrease'){
            inc='--'
          }
          if(algo16=='increase'){
            dec='++'
          }
        code=`minimum=0;maximum=9999;arr=[12, 17, 24, 27, 33, 37];k=0;found=false;n=${absNum};${myalgo4}=0;${myalgo5}='not found';${algo18}=9999;${algo19}=0;calculatedSum='';pairs='not found';index1=0;index2=5;while(arr[index1]!=arr[index2] && found==false && index1<6 && index1>-1 && index2>-1 && index2<6){k++;${algo1}=arr[${inde1}]${algo3}arr[${inde2}];${algo20}=Math.abs(${algo1}${algo21}${algo22});if(${algo20}${algo5}${algo6}){${algo6}=${algo20};${algo7}=arr[${inde3}]+','+arr[${inde4}];} if(${algo1}${algo10}${algo11}){${inde5}${inc};}else if(${algo1}${algo14}${algo15}){${inde6}${dec};}if(k>30){found=true;}}; return ${algo}`
       
      }
    }
  seterror(err)
  console.log(code)
  const F = new Function(code);  
  var out = F()
  return out
}
      
      const FiboOutput=()=>{
          var code=''
        
          if( algo1!='==' && algo1!=''&& algo2!=''){
              if(algo5==''&& algo6==''){
                code = `function Fib(n) {if(n${algo1}${algo2}){return ${algo3};}else{return ${algo4};}};return Fib(${algo})`
              }
              else if(algo5!=''&& algo6==''){
                code = `function Fib(n) {if(n${algo1}${algo2}){return ${algo3};}else{return ${algo4};}};return Fib(${algo})`
              }
              else if(algo5==''&& algo6!=''){
                code = `function Fib(n) {if(n${algo1}${algo2}){return ${algo3};}else{return ${algo4};}};return Fib(${algo})`
              }
              else{
                code = `function Fib(n) {if(n${algo1}${algo2}){return ${algo3};}else{return ${algo4}${algo5}${algo6};}};return Fib(${algo})`
              }
          }
        const F = new Function(code);  
        
        var out = F()
        console.log(F())

        return out
      }

      const FiboSum = () =>{
          var err=''
          var code = ''
          
          if(myalgo===''){
            err='Please provide an input statement'
          }
          else if(myalgo2===''){
            err='Please select a new define variable'
          }
          else if(myalgo3===''){
            err='Define a set variable'
          }
          else if(algo1=='' || algo2=='' || algo3==''|| algo4=='' || algo5=='' || algo6=='' ){
            err='Complete the fibonacci function '
          }
          else if(myalgo4=='' ){
            err='set variable to a formula'
          }
          else if(myalgo9===''){
            err='please define an output variable'
          }
          var incVar = false
         // console.log(myalgo4+','+myalgo+','+myalgo1)
            if(myalgo3==myalgo2||algo3==myalgo){
              incVar=true
            }
            if(incVar===false){
                err='Setting variable to incorrect value. Please change set variable '+myalgo3+' to a variable declared previously'
            }
            
          var incVar2=false
          if(myalgo9===myalgo3){
            incVar2=true
          }
          else if(myalgo9===myalgo2){
            incVar2=true
          }
          else if(myalgo9===myalgo){
            incVar2=true
          }
          if(incVar2===false){
            err='Output variable incorrect. Please change the output variable and set it to previously declared variable'
          }

        
            if(err==''){
              if(myalgo4!=='' && myalgo5=='' && myalgo6=='' && myalgo7=='' && myalgo8==''){
                code = `${myalgo}=${myalgo1};${myalgo2}=0;function Fib(n) {if(n${algo1}${algo2}){return ${algo3};}else{return ${algo4}${algo5}${algo6};}};${myalgo3}=${myalgo4};return ${myalgo9}`
              }  
              else if(myalgo4!=='' && myalgo5=='' && myalgo6=='' && myalgo7=='' && myalgo8==''){
                    code = `${myalgo}=${myalgo1};${myalgo2}=0;function Fib(n) {if(n${algo1}${algo2}){return ${algo3};}else{return ${algo4}${algo5}${algo6};}};${myalgo3}=${myalgo4};return ${myalgo9}`
                }
                else if(myalgo4!=='' && myalgo5!=='' && myalgo6!==''&& myalgo7=='' && myalgo8==''){
                    code = `${myalgo}=${myalgo1};${myalgo2}=0;function Fib(n) {if(n${algo1}${algo2}){return ${algo3};}else{return ${algo4}${algo5}${algo6};}};${myalgo3}=${myalgo4}${myalgo5}${myalgo6};return ${myalgo9}`
                }
                else if(myalgo4!=='' && myalgo5!=='' && myalgo6!=='' && myalgo7!=='' && myalgo8!==''){
                    code = `${myalgo}=${myalgo1};${myalgo2}=0;function Fib(n) {if(n${algo1}${algo2}){return ${algo3};}else{return ${algo4}${algo5}${algo6};}};${myalgo3}=${myalgo4}${myalgo5}${myalgo6}${myalgo7}${myalgo8};return ${myalgo9}`
                }
              }
            
            seterror(err)
          
        const F = new Function(code);          
        var out = F()
  
          return out
      }

      const handleAlgoChange =( event )=> {
        setalgo(event.target.value)
      }
      const handleAlgoChange1 =( event )=> {
        setalgo1(event.target.value)
      }
      const handleAlgoChange2 =( event )=> {
        setalgo2(event.target.value)
      }
      const handleAlgoChange3 =( event )=> {
        setalgo3(event.target.value)
      }
      const handleAlgoChange4 =( event )=> {
        setalgo4(event.target.value)
      }
      const handleAlgoChange5 =( event )=> {
        setalgo5(event.target.value)
      }
      const handleAlgoChange6 =( event )=> {
        setalgo6(event.target.value)
      }
      const handleAlgoChange7 =( event )=> {
        setalgo7(event.target.value)
      }
      const handleAlgoChange8 =( event )=> {
        setalgo8(event.target.value)
      }
      const handleAlgoChange9 =( event )=> {
        setalgo9(event.target.value)
      }
      const handleAlgoChange10 =( event )=> {
        setalgo10(event.target.value)
      }
      const handleAlgoChange11 =( event )=> {
        setalgo11(event.target.value)
      }
      const handleAlgoChange12 =( event )=> {
        setalgo12(event.target.value)
      }
      const handleAlgoChange13 =( event )=> {
        setalgo13(event.target.value)
      }
      const handleAlgoChange14 =( event )=> {
        setalgo14(event.target.value)
      }
      const handleAlgoChange15 =( event )=> {
        setalgo15(event.target.value)
      }
      const handleAlgoChange16 =( event )=> {
        setalgo16(event.target.value)
      }
      const handleAlgoChange17 =( event )=> {
        setalgo17(event.target.value)
      }
      const handleAlgoChange18 =( event )=> {
        setalgo18(event.target.value)
      }
      const handleAlgoChange19 =( event )=> {
        setalgo19(event.target.value)
      }
      const handleAlgoChange20 =( event )=> {
        setalgo20(event.target.value)
      }
      const handleAlgoChange21 =( event )=> {
        setalgo21(event.target.value)
      }
      const handleAlgoChange22 =( event )=> {
        setalgo22(event.target.value)
      }
      const handleAlgoChange23 =( event )=> {
        setalgo23(event.target.value)
      }
      const handleAlgoChange24 =( event )=> {
        setalgo24(event.target.value)
      }
      const handleAlgoChange25 =( event )=> {
        setalgo25(event.target.value)
      }
      const handleAlgorithmChange =( event )=> {
        setmyalgo(event.target.value)
      }

      const handleAlgorithmChange1 =( event )=> {
        setmyalgo1(event.target.value)
      }

      const handleAlgorithmChange2 =( event )=> {
        setmyalgo2(event.target.value)
      }

      const handleAlgorithmChange3 =( event )=> {
        setmyalgo3(event.target.value)
      }
      
      const handleAlgorithmChange4 =( event )=> {
        setmyalgo4(event.target.value)
      }

      const handleAlgorithmChange5 =( event )=> {
        setmyalgo5(event.target.value)
      }
      const handleAlgorithmChange6 =( event )=> {
        setmyalgo6(event.target.value)
      }
      const handleAlgorithmChange7 =( event )=> {
        setmyalgo7(event.target.value)
      }
      const handleAlgorithmChange8 =( event )=> {
        setmyalgo8(event.target.value)
      }
      const handleAlgorithmChange9 =( event )=> {
        setmyalgo9(event.target.value)
      }
      const compareSolutionChange =( event )=> {
        setmycomsol(event.target.value)
      }
      const compareSolutionChange1 =( event )=> {
        setmycomsol1(event.target.value)
      }
      const compareSolutionChange2 =( event )=> {
        setmycomsol2(event.target.value)
      }
      const compareSolutionChange3 =( event )=> {
        setmycomsol3(event.target.value)
      }

      const handleSpaceChange =( event )=> {
        setmyspace(event.target.value)
      }

      const handleTimeChange =( event )=> {
        setmytime(event.target.value)
      }

      const custom_config = {
        extraPlugins: [ MyCustomUploadAdapterPlugin ],
        
        // toolbar: {
        //   items: [
        //     'heading',
        //     '|',
        //     'bold',
        //     'italic',
        //     'link',
        //     'bulletedList',
        //     'numberedList',
        //     '|',
        //     'blockQuote',
        //     'insertTable',
        //     '|',
        //     'imageUpload',
        //     'undo',
        //     'MathType',
        //     'SpecialCharacters',
        //     'SpecialCharactersMathematical',
        //     'redo',
        //     'Subscript', 
        //     'Superscript',            
        //   ]
        // }
        // ,
        // table: {
        //   contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
        // }
      }
      const buttonSelect = (len,k) =>{
        var mysol='solution'+len
        console.log(k)
        if(k=='1'){
          setmycomsol(mysol)
        }
        else if(k=='3'){
          setmycomsol2(mysol)
        }
      }

      const totalSolutionComparison =(deco,pattern,abs,algorithm,time,space,len,k,step)=>{

        const algoText = (txt) =>{
          var tex = txt.split(';')
          var ou = ''
          var out=''
          if(tex.length==4){
            ou = tex[3].split(',')
          }
          else if(tex.length>4){
            ou = tex[4].split(',')
          }
          out = ou[0]+','+ou[1]
          return (<div>
              {tex.length==4?
              <GridContainer>
                  <GridItem xs={12} sm={12} md={5}>
                      input statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7}>
                       {commaToText(tex[0])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      define variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                       {commaToText(tex[1])} 
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      set variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(tex[2])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      output statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(out)}
                  </GridItem>
              </GridContainer>:
              <GridContainer>
                  <GridItem xs={12} sm={12} md={5}>
                      input statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7}>
                      {commaToText(tex[0])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      define variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(tex[1])} {commaToText(tex[2])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      set variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(tex[3])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      output statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(out)}
                  </GridItem>
              </GridContainer>}
              </div>
          )
        }
          return (
            <>
            <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
              
                <Card hoverable onClick={() => buttonSelect(len,k)}  sx={k=='1'?{border: "1px solid grey",backgroundColor:mycomsol=='solution'+len?'#09ebe3':'white'}:{border: "1px solid blue",backgroundColor:mycomsol2=='solution'+len?'#09dfeb':'white'}}>
                      <b align="center"> Your Solution {len}</b>
                  <CardBody>
                    <b style={classes.ana}> Decomposition </b>
                    <p style={step=='decomposition'?{ ...classes.cardTitle }:null}>{commaToText(deco)}</p>
                    <b style={classes.ana}> Pattern </b>
                    <p style={step=='pattern'?{ ...classes.cardTitle }:null}>{commaToText(pattern)}</p>
                    <b style={classes.ana}> Abstraction </b>
                    <p style={step=='abstraction'?{ ...classes.cardTitle }:null}>{commaToText(abs)}</p>
                    <b style={classes.ana}> Algorithm </b>
                    <p style={step=='algorithm'?{ ...classes.cardTitle }:null}>{algoText(algorithm)}</p>
                    <b style={classes.ana}> Analysis</b>
                    <p style={classes.ana}>
                      
                      No. of operations={time},No. of variables={space}       </p>
                  </CardBody>
                </Card>
                </Link>
                {mycomsol!=='' && mycomsol=='solution'+len && k=='1'?
                <>
                    <h5>Answer 1. Why do you think it is?</h5>
                      <Field
                        component={TextField}
                        type="text"
                        variant="outlined"
                        label="Enter your answer "
                        value={mycomsol1}
                        onChange={compareSolutionChange1}
                        //validate={validateSimName}
                        fullWidth= {true} 
                        //style = {{width: 340}}
                      />                                    
                  </>
                :null}
                 {mycomsol2!=='' && mycomsol2=='solution'+len && k=='3'?
              <>
                <h5>Answer 2. Why do you think it is?</h5>
                  <Field
                    component={TextField}
                    type="text"
                    variant="outlined"
                    label="Enter your answer "
                    value={mycomsol3}
                    onChange={compareSolutionChange3}
                    //validate={validateSimName}
                    fullWidth= {true} 
                    //style = {{width: 340}}
                  />                                    
              </>
            :null}
              </>              
              );
            }



const solutionComparison =(algorithm,analysis,len,k)=>{

  const algoText = (txt) =>{
    var tex = txt.split(';')
          var ou = ''
          var out=''
          if(tex.length==4){
            ou = tex[3].split(',')
          }
          else if(tex.length>4){
            ou = tex[4].split(',')
          }
          out = ou[0]+','+ou[1]
    return (<div>
        {tex.length==4?
        <GridContainer>
            <GridItem xs={12} sm={12} md={5}>
                input statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7}>
                 {commaToText(tex[0])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                define variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                 {commaToText(tex[1])} 
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                set variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(tex[2])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                output statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(out)}
            </GridItem>
        </GridContainer>:
        <GridContainer>
            <GridItem xs={12} sm={12} md={5}>
                input statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7}>
                {commaToText(tex[0])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                define variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(tex[1])} {commaToText(tex[2])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                set variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(tex[3])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                output statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(out)}
            </GridItem>
        </GridContainer>}
        </div>
    )
  }
    return (
        <>
        <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
          <Card  onClick={() => buttonSelect(len,k)} hoverable sx={k=='1'?{border: "1px solid grey",backgroundColor:mycomsol=='solution'+len?'#09ebe3':'white'}:{border: "1px solid blue",backgroundColor:mycomsol2=='solution'+len?'#09dfeb':'white'}}>
                <b align="center">(other possible solutions) Solution {len}</b>
            <CardBody>
              <b style={classes.ana}> Algorithm </b>
              <p style={classes.cardTitle}>{algoText(algorithm)}</p>
              <b style={classes.ana}> Analysis </b>
              <p style={{color:'blue'}}>
                {analysis} 
              </p>
            </CardBody>
          </Card>
        </Link>
         
        {mycomsol!=='' && mycomsol=='solution'+len && k=='1'?
              <>
                <h5>Answer 1. Why do you think it is?</h5>
                  <Field
                    component={TextField}
                    type="text"
                    variant="outlined"
                    label="Enter your answer "
                    value={mycomsol1}
                    onChange={compareSolutionChange1}
                    //validate={validateSimName}
                    fullWidth= {true} 
                    //style = {{width: 340}}
                  />                                    
              </>
            :null}
            {mycomsol2!=='' && mycomsol2=='solution'+len && k=='3'?
              <>
                <h5>Answer 2. Why do you think it is?</h5>
                  <Field
                    component={TextField}
                    type="text"
                    variant="outlined"
                    label="Enter your answer "
                    value={mycomsol3}
                    onChange={compareSolutionChange3}
                    //validate={validateSimName}
                    fullWidth= {true} 
                    //style = {{width: 340}}
                  />                                    
              </>
            :null}
        </>            
        );
      }
    

const submitPatternForm = () =>{
  
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
        if(patnum=='find specific pair:'){
          mydata.pattern[0].userText=patnum+'observe that if first index of pair remains same and second index decreases then Pairwise sum,'+patnum8+', and observe that if second index of pair remains same and first index increases then Pairwise sum,'+patnum9+':start from,firstNumPair=,'+patnum1+',secNumPair=,'+patnum2+',for specific Pair:find,'+num9+', of ,'+patnum3+','+patnum4+','+patnum5+':pairs that closest to 55:'+patnum6+','+patnum7+',diff='+Math.abs(parseInt(patnum6)*1+parseInt(patnum7)-55)
        }
        else{
          mydata.pattern[0].userText=patnum+'start from,firstNumPair=,'+patnum1+',secNumPair=,'+patnum2+',for each Pair:find,'+num9+', of ,'+patnum3+','+patnum4+','+patnum5+':pairs closest to 55:'+patnum6+','+patnum7+',diff='+Math.abs(parseInt(patnum6)*1+parseInt(patnum7)-55)
        } 
      //mydata.pattern[0].userText1=mypattern1
      arrStore.map((val, index)=>{
        mydata.pattern[0].enteredSolution.push(val)
      })
      const data=
      {
        act:'activity4',
        pattern:mydata.pattern
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity4[0]
        setmydata(activity)
           settotaldata(response.data)
        setarrStore([])
    })
  
}


const submitAbstractionForm = () =>{
  
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      if(mydata.pattern[0].completed===false){          
        mydata.abstraction[0].userText='find all pair:select firstNumPair=,'+abs1+',secNumPair=,'+abs2+',from 12-17-24-27-33-37,for each pair:Pairwise sum=,'+abs3+','+abs4+','+abs5+',Difference=Pairwise sum,'+abs14+','+abs15+',check if Difference,'+abs6+','+abs7+',then Pairs=,'+myabs1+','+myabs2+','+abs7+'=Difference'
      }
      else{
        mydata.abstraction[0].userText='find specific pair:select firstNumPair=,'+abs1+',secNumPair=,'+abs2+',from 12-17-24-27-33-37,for each pair:Pairwise sum=,'+abs3+','+abs4+','+abs5+',Difference=Pairwise sum,'+abs14+','+abs15+',check if Difference,'+abs6+','+abs7+',then Pairs=,'+myabs1+','+myabs2+','+abs7+',=Difference,check if Pairwise sum,'+abs8+','+abs9+','+abs10+',firstNumPair'+',check if Pairwise sum,'+abs11+','+abs12+','+abs13+',secNumPair'
      }
      arrStore.map((val, index)=>{
        mydata.abstraction[0].enteredSolution.push(val)
      })
      const data=
      {
        act:'activity4',
        abstraction:mydata.abstraction
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity4[0]
        setmydata(activity)
           settotaldata(response.data)
        setarrStore([])
    })
  
}

const submitAlgorithmForm = () =>{
  var empty = true;
 
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      if(mydata.abstraction[0].completed===false){
          
        mydata.algorithm[0].userText='input,'+myalgo1+';define,'+myalgo2+','+myalgo3+','+algo18+','+myalgo4+','+algo19+','+myalgo5+';set,'+myalgo6+',to,'+myalgo7+',set,'+myalgo8+',to,'+myalgo9+',for each firstNumPair and secNumPair set,'+algo1+',to,'+algo2+','+algo3+','+algo4+',set,'+algo20+',to,'+algo1+','+algo21+','+algo22+',check if,'+algo20+','+algo5+','+algo6+',set,'+algo6+',to,'+algo20+',then set,'+algo7+',to,'+algo8+','+algo9+';output,'+algo
        mydata.algorithm[0].userText1='for each firstNumPair and secNumPair set PairwiseSum to '+algo2+','+algo3+','+algo4+',set Difference to PairwiseSum'+algo21+algo22+', check if Difference'+algo5+algo6+',then set Pairs to '+algo8+','+algo9
      }
      else{
        mydata.algorithm[0].userText='input,'+myalgo1+';define,'+myalgo2+','+myalgo3+','+algo18+','+myalgo4+','+algo19+','+myalgo5+';set,'+myalgo6+',to,'+myalgo7+',set,'+myalgo8+',to,'+myalgo9+',for each firstNumPair and secNumPair set,'+algo1+',to,'+algo2+','+algo3+','+algo4+',set,'+algo20+',to,'+algo1+','+algo21+','+algo22+',check if,'+algo20+','+algo5+','+algo6+',set,'+algo6+',to,'+algo20+',then set,'+algo7+',to,'+algo8+','+algo9+',check if,'+algo1+','+algo10+','+algo11+',then,'+algo12+','+algo13+',check if,'+algo1+','+algo14+','+algo15+',then,'+algo16+','+algo17+';output,'+algo
        mydata.algorithm[0].userText1='for each firstNumPair and secNumPair, set PairwiseSum to '+algo2+','+algo3+','+algo4+',set Difference to PairwiseSum'+algo21+algo22+',check if Difference'+algo5+algo6+',then set Pairs to '+algo8+','+algo9+',check if PairwiseSum'+algo10+algo11+',then set Pairs to '+algo12+','+algo13+',check if PairwiseSum'+algo14+algo15+',then set Pairs to '+algo16+','+algo17
      }
      arrStore.map((val, index)=>{
        mydata.algorithm[0].enteredSolution.push(val)
      })
      const data=
      {
        act:'activity4',
        algorithm:mydata.algorithm
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity4[0]
        setmydata(activity)
           settotaldata(response.data)
        setarrStore([])
    })
}

const submitAnalysisForm = () =>{
  const analysis = myanalysis;                     
  var empty = true;
  if(myspace !== '' && mytime !== ''){
    empty=false
  }
   if(empty===true){
     seterror('Please enter a number')
    }
    else{
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      mydata.analysis[0].spaceText=myspace
      mydata.analysis[0].timeText=mytime
      arrStore.map((val, index)=>{
        mydata.analysis[0].enteredSolution.push(val)
      })
      const data=
      {
        act:'activity4',
        analysis:mydata.analysis
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity4[0]
        setmydata(activity)
           settotaldata(response.data)
        setarrStore([])
    })
  }
}

const submitComparisonForm = () =>{
  var empty = true;
  if(mycomsol !== '' && mycomsol2 !== ''){
    empty=false
  }
   if(empty===true){
     seterror('Please enter text above')
    }
    else{
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
            mydata.comparison[0].userText='Which of the solution do you think is better'
            mydata.comparison[0].userText1=mycomsol
            mydata.comparison[0].userText2=mycomsol1
            mydata.comparison[0].userText3='Your system can perform only maximum 15 operations. If you want to implement one of the solutions, which one do you think is better?'
            mydata.comparison[0].userText4=mycomsol2
            mydata.comparison[0].userText5=mycomsol3
            arrStore.map((val, index)=>{
              mydata.comparison[0].enteredSolution.push(val)
          })
      const data=
      {
        act:'activity4',
        comparison:mydata.comparison
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        setarrStore([])
        const activity = response.data.activity4[0]
        setmydata(activity)
           settotaldata(response.data)
    })
  }
}

//////////////code to update student interaction 

const solutionEnter = (act,step,k) =>{

  var dat = {
    solution:k,
    altStep:mydata.altStep,
    created:Date.now(),
  }
  var newact = totaldata[act][0]
  var len = newact[step][0].enteredSolution.length
  var lastVal = newact[step][0].enteredSolution[len-1].solution

  var arrlen = arrStore.length

  if(arrStore.length>0){
    lastVal = arrStore[arrlen-1].solution
  }

  if(lastVal==k){

  }
  else{
     arrStore.push(dat)
     setarrStore(arrStore)
   
  }

}

const movedat = (sou,dest,typ) =>{

  var dat = {
    source:sou,
    destination:dest,
    altStep:mydata.altStep,
    type:typ,

  }
  const data=
  {
    act:'activity4',
    moveData:dat
  }                     
  console.log(data)

//   axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//   .then((response) => {
//     if(typ=='completed' && arrStore.length>0){
//       if(sou=='decomposition'){
//         arrStore.map((val, index)=>{
//           mydata.decomposition[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity4',
//           decomposition:mydata.decomposition
//         }
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity4[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         }) 
//       }
//       else if(sou=='pattern'){
//         arrStore.map((val, index)=>{
//           mydata.pattern[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity4',
//           pattern:mydata.pattern
//         }
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity4[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         }) 
//       }
//       else if(sou=='abstraction'){
//         arrStore.map((val, index)=>{
//           mydata.abstraction[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity4',
//           abstraction:mydata.abstraction
//         } 
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity4[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         })
//       }
//       else if(sou=='algorithm'){
//         arrStore.map((val, index)=>{
//           mydata.algorithm[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity4',
//           algorithm:mydata.algorithm
//         } 
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity4[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         })
//       }
//       else if(sou=='analysis'){
//         arrStore.map((val, index)=>{
//           mydata.analysis[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity4',
//           analysis:mydata.analysis
//         } 
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity4[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         })
//       }
//       else if(sou=='comparison'){
//         arrStore.map((val, index)=>{
//           mydata.comparison[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity4',
//           comparison:mydata.comparison
//         }
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity4[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         }) 
//       }        
//     }
//     else{
//       const activity = response.data.activity4[0]
//       setmydata(activity)
//            settotaldata(response.data)
//     }
// })
}

const history = useNavigate();


const handleBackActivity = () =>{
  movedat('activity4','activity3','completed')
  history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/activity3${totaldata.activity2[0].level}`)
}

const hintGenerate =()=>{
  return(
    <div>
                          {hintsActivity1.map((text, index)=>(
                              index===activeStep?
                              <Card sx={{border: "1px solid grey"}}>
                                  <CardHeader color="success" align="center">
                                    <Typography variant="subtitle2" align="center" sx={classes.cardTitleWhite}>Hints {hintsActivity1[index].step}</Typography>
                                  </CardHeader>
                                
                                  <List sx={classes.messageArea}>
                                    {index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Basic' || index==0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate' || index==0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced'? 
                                        <div>
                                        <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                          <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>Basic </Typography>
                                          </AccordionSummary>
                                          <AccordionDetails>
                                             {mydata.decomposition[0].hints[0].basic}
                                          </AccordionDetails>
                                        </Accordion> <Divider /> </div>:null}
                                      {index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced' || index==0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate'?
                                      <div>
                                      <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>Intermediate</Typography>
                                          
                                        </AccordionSummary>
                                        <AccordionDetails>
                                         {mydata.decomposition[0].hints[0].intermediate}
                                        </AccordionDetails>
                                      </Accordion><Divider /> </div>:null}
                                      {index===0 && mydata.decomposition[0].levelOfHints==='Advanced'?<div>
                                      <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>Advanced</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          {mydata.decomposition[0].hints[0].advanced}
                                        </AccordionDetails>
                                      </Accordion><Divider /> </div>:null}
                                    {index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.pattern[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                    {index===1 && mydata.pattern[0].levelOfHints==='Advanced' || index===1 && mydata.pattern[0].levelOfHints==='Intermediate'?
                                  < div>
                                    <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Intermediate</Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.pattern[0].hints[0].intermediate}
                                      </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index===1 && mydata.pattern[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.pattern[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Basic' || index===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Intermediate' || index===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.abstraction[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>: null}
                                  {index===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced' || index===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Intermediate'?
                                  <div>
                                  <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Intermediate</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.abstraction[0].hints[0].intermediate}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==2 && mydata.abstraction[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.abstraction[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Basic' || index==3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Intermediate' || index==3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.algorithm[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                  {index==3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Intermediate' || index==3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced'?
                                  <div>
                                  <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Intermediate</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.algorithm[0].hints[0].intermediate}
                                           
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==3 && mydata.algorithm[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.algorithm[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Basic' || index==4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Intermediate' || index===4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.analysis[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                  {index==4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Intermediate' || index===4 && mydata.analysis[0].levelOfHints==='Advanced'?
                                  <div>
                                  <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Intermediate</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.analysis[0].hints[0].intermediate}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>: null}
                                  {index==4 && mydata.analysis[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.analysis[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div> :null}

                                  {index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Basic' || index==0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Intermediate' || index==0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Advanced'? 
                                        <div>
                                        <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                          <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>General </Typography>
                                          </AccordionSummary>
                                          <AccordionDetails>
                                             {mydata.decomposition[0].hints[0].general}
                                          </AccordionDetails>
                                        </Accordion> <Divider /> </div>:null}
                                  
                                  {index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>General </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.pattern[0].hints[0].general}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}

                                  {index===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Basic' || index===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Intermediate' || index===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>General </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.abstraction[0].hints[0].general}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>: null}
                                  
                                  {index==3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Basic' || index==3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Intermediate' || index==3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>General </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.algorithm[0].hints[0].general}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}

                                  {index==4 && totaldata.type=='control' && mydata.analysis[0].levelOfHints==='Basic' || index==4 && totaldata.type=='control' && mydata.analysis[0].levelOfHints==='Intermediate' || index===4 && totaldata.type=='control' && mydata.analysis[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>General </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.analysis[0].hints[0].general}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                  </List>
                                  {mydata.altStep==""?'':<List sx={classes.messageArea}>
                                  {(index==1 && mydata.altStep=='decomposition' && mydata.pattern[0].noOfaltattempts>3)||(index==2 && mydata.altStep=='decomposition' && mydata.abstraction[0].noOfaltattempts>3)||(index==3 && mydata.altStep=='decomposition' && mydata.algorithm[0].noOfaltattempts>3)||(index==4 && mydata.altStep=='decomposition' && mydata.analysis[0].noOfaltattempts>3)?
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Alternate Hint </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.decomposition[0].hints[0].alternate}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                    {(index==2 && mydata.altStep=='pattern' && mydata.abstraction[0].noOfaltattempts>3)||(index==3 && mydata.altStep=='pattern' && mydata.algorithm[0].noOfaltattempts>3)||(index==4 && mydata.altStep=='pattern' && mydata.analysis[0].noOfaltattempts>3)?
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Alternate Hint </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.pattern[0].hints[0].alternate}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                    {(index==3 && mydata.altStep=='abstraction' && mydata.algorithm[0].noOfaltattempts>3)||(index==4 && mydata.altStep=='abstraction' && mydata.analysis[0].noOfaltattempts>3)?
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Alternate Hint </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.abstraction[0].hints[0].alternate}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                    {index==4 && mydata.altStep=='algorithm' && mydata.analysis[0].noOfaltattempts>3?
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Alternate Hint </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.algorithm[0].hints[0].alternate}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                   
                                  

                                  </List>}
                                 </Card>
                                :null))}                  
              
                              </div>
  )
}

//console.log(Num)
//console.log('Deco:'+mydeco)



    return(
    loading!==true?
      <div>
          <GridContainer>
            {/* {sim()} */}
          <GridItem xs={12} sm={12} md={12}>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
              <Link color="inherit" to="/student/dashboard">
                Dashboard
              </Link>
              <Link color="inherit" to={`/student/dashboard/viewsession/${clas._id}`}>
                <Typography color="textPrimary">{clas.title}</Typography>
              </Link>
                                         
              <Link color="inherit" to={`/student/dashboard/viewstudentclass/${clas._id}/session/${totaldata.sessionId}/profile/${sesId}/scenario`}>
                <Typography color="textPrimary"> Scenario </Typography>
              </Link>
                <Typography color="textPrimary">Activity 4</Typography>

            </Breadcrumbs>
            {/* {console.log({...sess}.title)} */}
          </GridItem>
            <GridItem xs={12} sm={12} md={12} >
              <Button
                  //disabled={activeStep === 0}
                  onClick={handleBackActivity}
                  sx={classes.backButton}
                  >
                      Previous Activity
              </Button>
              <Typography variant="h4" align="center" sx={classes.fontLato}>
                 Repair broken bridge 
              </Typography>
            </GridItem>

        <GridItem xs={12} sm={12} md={3} >
         
        </GridItem>
        </GridContainer>
           
            
            {myModal && (
            <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal1}
                    variants={modal} 
                    >
                    <GridContainer> 
                      <GridItem xs={12} sm={12} md={3}>
                        <img alt='Thinking Panda' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/pandaPic.jpg'} />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={9}>
                        <motion.div style={classes.modal1}>
                          <h5 style={classes.fontCursive}>Read the Instructions carefully.</h5>
                          <h5 style={classes.fontCursive}> Solve the problem to complete the activity and move forward in your mission.</h5>
                        </motion.div>
                      </GridItem>
                    </GridContainer>
                    <Button color="success" variant="contained" onClick={closeModal} 
                    title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                        OK
                    </Button>
                    
                  </motion.div>
                </motion.div>
            </AnimatePresence>)}

                                  
          <CustomTabs
            title="Activity:"
            headerColor="primary"
            tabs={[
              {
                tabName: "Introduction",
                tabIcon: AssignmentIcon,
                 tabContent: 
                (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}> 
                      <blockquote className="blockquote">
                            <p>
                                Your team arrived near the spilling area on the other side of the island. 
                                Now you have to walk to the spilling location on another side of the island.
                            </p>
                            <p>     
                                Following that, your team began your journey on the island amid dense forest and wild animals. 
                                You come across a broken, hanging bridge over a deep gorge. 
                            </p>
                            <p> 
                                The bridge needs to be repaired as most of the wooden logs along the bridge's path have decayed and must be replaced with new ones. 
                            </p>
                            <p> 
                                Fortunately, you brought wood cutting tools with you to cut logs from trees. 
                                A bridge survey is conducted to determine the number of logs to repair. 
                                For more information regarding the survey, read the problem statement 
                            </p>
                      </blockquote>                               
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}> 
                      <img alt='Bridge' className="card-img-top" src={baseUrl+'assets/images/bridge.jpg'} />      
                  </GridItem>
                </GridContainer> 
                )
              },
              {
                tabName: "Problem Statement",
                tabIcon: QuestionAnswerIcon,
                tabContent: (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <blockquote className="blockquote">
                      <p> You have surveyed the bridge and identified that 55 logs are needed in order to repair the bridge.</p> 
                      <p> You have identified 6 trees to collect logs for repairing the bridge.</p> 
                      <p> First tree yields 12 logs, second log yields 17 logs, third logs yields 24 logs. </p> 
                      <p> continuing this the set of numbers {'{'}12, 17, 24, 27, 33, 37 {'}'} represents the trees with extracted logs.</p> 
                      <p> You don't want to cut too many trees due to environment conservation and therefore you decided to cut only 2 trees which can yield logs sufficient enough to repair the bridge.</p> 
                      <p> Your task is to identify the pair of trees that gives logs closer to 55.You cannot calculate manually as it may take lot of time, so you decided to write an algorithm to find the trees that yield logs closer and sufficient to repair the bridge.</p> 
                      <p> Your objective is defined as follows:</p><p>Pair of trees with logs = sum of logs closer to 55 logs needed to repair the bridge</p>
                      </blockquote>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <img alt='Activity4sumLogslclosest' className="card-img-top"  src={baseUrl+'assets/images/act4-sumLogsClosest.PNG'} />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <blockquote className="blockquote">
                        <p><strong>Input: </strong>55</p><p><strong>Output: </strong>A pair of number having sum closest to 55 = 17,37 </p><p><strong>Objective: </strong> Given a set of logs that can be extracted from six trees {'{'}12, 17, 24, 27, 33, 37 {'}'} and a required log count of 55. Write an algorithm to select a pair of trees such that the total sum of logs are closest to 55 required logs. The sum may be more or less but should be closest to the  given number.</p>
                      </blockquote>
                    </GridItem>
                  </GridContainer>
                  
                )                
              },
              {
                tabName: "Example",
                tabIcon: MultilineChartIcon,
                tabContent: (
                <GridContainer>
                    <GridItem xs={12} sm={12} md={2}>
                    
                    </GridItem> 
                    <GridItem xs={12} sm={12} md={8}>
                    <blockquote className="blockquote">

                      <p><b> Example: </b> To find the maximum among a set of positive numbers {'{'}24, 05, 15, 20, 49, 32, 9, 62, 22, 17{'}'} </p>
                      <p><b>Input: </b>Array={'{'}24, 05, 15, 20, 49, 32, 9, 62, 22, 17{'}'}</p>
                      <p><b>Output: </b>Maximum=62</p>
                      <b>Objective: </b> Write an algorithm to find the maximum among a set of positive numbers {'{'}24, 05, 15, 20, 49, 32, 9, 62, 22, 17{'}'}. Follow the computational thinking steps to solve the problem. 
                      <p><b> Decomposition: </b> 
                      Find pairwise maximum of numbers from left and find next set/level of maximum numbers. 
                      Next set of numbers in Level1=24,20,49,62,22. In Level2=24,62,22; Level3=62,22; Level4=62.</p> 
                      <p><b> Pattern recognition: </b>
                      Observe that number in final level=maximum=62 and levelcount=4, count of numbers=10. Identify that 10{'<'}2^4 i.e., Next power of 2 to level count is more than count of numbers=10. </p> 
                      <p><b> Abstraction: </b>
                      Given an array of numbers: count no. of elements and find level count. For each level: find maximum of pairwise numbers, 
                      create a set of numbers and replace current array by new array. Maximum= final single element</p>  
                      <p><b> Algorithm design: </b></p>

                      {algoNewToText('input array;define variable count, newArray, levelCount; set count to length of array, find levelCount for which count<2^levelCount, for each level in levelCount: compare pairwise elements of array and store in newArray, set array to newArray, end for ; output, newarray')}
                        <b> Analysis of the algorithm: </b> 
                        <p> Number of comparisons: 11 </p> <p> Number of variables: 3</p>
                    </blockquote>
                       
                    </GridItem>
                </GridContainer>
                )
                
              },
              {
                tabName: "Helpful concepts",
                tabIcon: AssignmentReturnIcon,
                tabContent: (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <blockquote className="blockquote">
                      <h3 align="center"><b>Important concepts</b></h3>
                      <img alt='ifelseHelp' className="card-img-top"  src={baseUrl+'assets/images/ifelseHelp.PNG'} />
                      <img alt='funcHelp' className="card-img-top"  src={baseUrl+'assets/images/forHelp.PNG'} />
                      <img alt='funcHelp' className="card-img-top"  src={baseUrl+'assets/images/functionHelp.PNG'} />
                      <img alt='algoHelp' className="card-img-top"  src={baseUrl+'assets/images/algoHelp.PNG'} />
                      <img alt='analysisHelp' className="card-img-top"  src={baseUrl+'assets/images/analysisHelp.PNG'} />
                    </blockquote>
                  </GridItem>                      
                </GridContainer>
                )
                
              },
              {
                tabName: "Computational Thinking Steps",
                tabIcon: SettingsApplicationIcon,
                tabContent: (
          

                  <Formik
                    initialValues={{
                    hypothesis: '',
                    }}


                    onSubmit={(values, {setSubmitting}) => {
                     setTimeout(() => {
                        setSubmitting(false);
                   
                    alert(JSON.stringify('Saving...', null, 2));

                        var decompos=''
                        var sum1=parseInt(num1)+parseInt(num2)+'difference='+Math.abs(parseInt(num1)+parseInt(num2)-55);
                        var sum2=parseInt(num3)+parseInt(num4)+'difference='+Math.abs(parseInt(num3)+parseInt(num4)-55);
                        var sum3=parseInt(num5)+parseInt(num6)+'difference='+Math.abs(parseInt(num5)+parseInt(num6)-55);
                        var sum4=parseInt(num7)+parseInt(num8)+'difference='+Math.abs(parseInt(num7)+parseInt(num8)-55);
                        
                        decompos ='Pairs are-first,last:,(,'+num1+','+num2+',)='+sum1+',first,second last:,(,'+num3+','+num4+',)='+sum2+',second,last:,(,'+num5+','+num6+',)='+sum3+',second, second last:,(,'+num7+','+num8+',)='+sum4
                        seterror('')
                        mydata.decomposition[0].userText=decompos
                        arrStore.map((val, index)=>{
                          mydata.decomposition[0].enteredSolution.push(val)
                        })
                        const data=
                        {
                          act: 'activity4',
                          decomposition: mydata.decomposition
                        }                     
                        console.log(data)

                      axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
                      .then((response) => {
                          console.log(response.data)
                          const activity = response.data.activity4[0]
                          setmydata(activity)
           settotaldata(response.data)
                          setarrStore([])
                      })
                     }, 500);
                    }}
                >

          {({submitForm, isSubmitting, touched, errors}) => (
          <Form>
          {loading!==true?

            <GridContainer>
                          
{/**''''''''''''''''''''''''''''''''Code for Hints''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''*/}



{hintsActivity1.map((text, index)=>(
              index===activeStep?
              myModalTwo && (
              <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal1}
                    variants={modal} 
                    >
                     
                      <GridContainer>
                      <GridItem xs={12} sm={12} md={3}>
                         <img alt='Marine Life' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/pandaPic3.jpg'} />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={9}>
                        <GridContainer>
                        <motion.div style={classes.modal1}>
                          <h5 style={ansType.includes('Correct Answer')==true?{color:'green'}:{color:'red'}}> {ansType} </h5>
                          {altHint!=''?<subtitle1> AlternateHint: {altHint} </subtitle1>:null}
                          <h5 style={classes.fontMonaco}> Current Step: {hintsActivity1[index].step} 
                          {activeStep === 0?mydata.decomposition[0].proceed===true && mydata.decomposition[0].completed===false?' (Submitted)':'':
                          activeStep === 1?mydata.pattern[0].proceed===true && mydata.pattern[0].completed===false?' (Submitted)':'':
                          activeStep === 2?mydata.abstraction[0].proceed===true && mydata.abstraction[0].completed===false?' (Submitted)':'':
                          activeStep === 3?mydata.algorithm[0].proceed===true && mydata.algorithm[0].completed===false?' (Submitted)':'':
                          mydata.analysis[0].proceed===true && mydata.analysis[0].completed===false?' (Submitted)':''}

                          {activeStep === 0?mydata.decomposition[0].completed===true?' (Completed)':'':
                          activeStep === 1?mydata.pattern[0].completed===true?' (Completed)':'':
                          activeStep === 2?mydata.abstraction[0].completed===true?' (Completed)':'':
                          activeStep === 3?mydata.algorithm[0].completed===true?' (Completed)':'':
                          activeStep === 4?mydata.analysis[0].completed===true?' (Completed)':'':null} </h5>
                          {mydata.analysis[0].completed===false?<h5 style={classes.fontGaramond}> Your Task: {task[activeStep]}</h5>:null}
                          
                          {(mydata.altStep==='' && totaldata.type=='experiment' && mydata.decomposition[0].noOfattempts>1 && (index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced')) || (mydata.altStep==='decomposition' && mydata.decomposition[0].noOfattempts>1 && (index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced'))? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Basic Hint: </b> {mydata.decomposition[0].hints[0].basic}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && (index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced')) || (mydata.altStep==='decomposition' && (index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced'))? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Intermediate Hint: </b>  {mydata.decomposition[0].hints[0].intermediate}           
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && index===0 && mydata.decomposition[0].levelOfHints==='Advanced') || (mydata.altStep==='decomposition' && index===0 && mydata.decomposition[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Advanced Hint: </b>  {mydata.decomposition[0].hints[0].advanced}           
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && (mydata.pattern[0].noOfattempts>1 && index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Advanced'))|| (mydata.altStep==='pattern' && mydata.pattern[0].noOfattempts>1 && index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Basic Hint: </b>  {mydata.pattern[0].hints[0].basic}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && (index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Advanced'))|| (mydata.altStep==='pattern' && (index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Advanced'))? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Intermediate Hint: </b> {mydata.pattern[0].hints[0].intermediate}           
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && index===1 && mydata.pattern[0].levelOfHints==='Advanced') || (mydata.altStep==='pattern' && index===1 && mydata.pattern[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Advanced Hint: </b> {mydata.pattern[0].hints[0].advanced}           
                            </GridItem>
                          :null}

                          {(mydata.altStep==='' && totaldata.type=='experiment' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced')|| (mydata.altStep==='abstraction' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}>Basic Hint:</b> {mydata.abstraction[0].hints[0].basic}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && activeStep===2 && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced') || (mydata.altStep==='abstraction' && activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Intermediate Hint:</b>  {mydata.abstraction[0].hints[0].intermediate}           
                            </GridItem>
                          :null}
                          {(mydata.altStep===''  && activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')|| (mydata.altStep==='abstraction' && activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Advanced Hint: </b> {mydata.abstraction[0].hints[0].advanced}           
                            </GridItem>
                          :null}

                          {(mydata.altStep==='' && totaldata.type=='experiment' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Basic Hint: </b> {mydata.algorithm[0].hints[0].basic}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && activeStep===3 && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Intermediate Hint: </b> {mydata.algorithm[0].hints[0].intermediate}           
                            </GridItem>
                          :null}
                          {(mydata.altStep===''  && activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Advanced Hint: </b> {mydata.algorithm[0].hints[0].advanced}           
                            </GridItem>
                          :null}

                          {(mydata.altStep==='' && totaldata.type=='experiment' && mydata.analysis[0].noOfattempts>1 && activeStep===4 && mydata.analysis[0].levelOfHints==='Basic' || activeStep===4 && totaldata.type=='experiment' &&  mydata.analysis[0].levelOfHints==='Intermediate' || activeStep===4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Basic Hint: </b> {mydata.analysis[0].hints[0].basic}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && activeStep===4 && mydata.analysis[0].levelOfHints==='Intermediate' || activeStep===4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Intermediate Hint: </b> {mydata.analysis[0].hints[0].intermediate}           
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && activeStep===4 && mydata.analysis[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Advanced Hint: </b> {mydata.analysis[0].hints[0].advanced}           
                            </GridItem>
                          :null}
                          {/*//////////////////////////// belowfor control hint */}

                          {(mydata.altStep==='' && totaldata.type=='control' && mydata.decomposition[0].noOfattempts>1 && (index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Advanced')) || (mydata.altStep==='decomposition' && mydata.decomposition[0].noOfattempts>1 && (index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Advanced'))? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> General Hint: </b> {mydata.decomposition[0].hints[0].general}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='control' && (mydata.pattern[0].noOfattempts>1 && index===1 && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Advanced'))|| (mydata.altStep==='pattern' && mydata.pattern[0].noOfattempts>1 && index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> General Hint: </b>  {mydata.pattern[0].hints[0].general}          
                            </GridItem>
                          :null}

                          {(mydata.altStep==='' && totaldata.type=='control' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Advanced')|| (mydata.altStep==='abstraction' && totaldata.type=='control' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}>General Hint:</b> {mydata.abstraction[0].hints[0].general}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='control' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> General Hint: </b> {mydata.algorithm[0].hints[0].general}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='control' && mydata.analysis[0].noOfattempts>1 && activeStep===4 && mydata.analysis[0].levelOfHints==='Basic' || activeStep===4 && totaldata.type=='control' && mydata.analysis[0].levelOfHints==='Intermediate' || activeStep===4 && totaldata.type=='control' && mydata.analysis[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> General Hint: </b> {mydata.analysis[0].hints[0].general}          
                            </GridItem>
                          :null}

                          {/*///////////////////////////////// above for control hint */}
                          
                          {activeStep===5 && mydata.analysis[0].completed===false? 
                            <GridItem xs={12} sm={12} md={12}>
                              <b style={classes.fontGaramond}> Your solution takes {mydata.analysis[0].hints[0].basic}</b>            
                            </GridItem>
                          :null}
                          {activeStep===6 ? 
                            <GridItem xs={12} sm={12} md={12}>
                                  {['1'].map((text,index)=>{
                                    var len=0;
                                    if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                        len=mydata.decomposition[0].alternateSolution.length
                                      }
                                    if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                        len=len+mydata.pattern[0].alternateSolution.length
                                      }
                                    if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                        len=len+mydata.abstraction[0].alternateSolution.length
                                      }
                                    if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
                                        len=len+mydata.algorithm[0].alternateSolution.length
                                      }
                                      return(
                                        <>
                                        <b style={classes.fontGaramond}>So you have implemented {len+1} solution, but there are other {mydata.comparison[0].alternateSolution.length} possible solutions.</b>
                                          <b style={classes.fontGaramond}> Observe the solutions and compare them </b> 
                                        </>
                                      )
                                  })}           
                            </GridItem>
                          :null}
                          </motion.div>
                        </GridContainer>
                          
                      </GridItem>
                         
                    </GridContainer>
                          <Button color="success" variant="contained" onClick={closeModalTwo} 
                            title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                              OK
                          </Button>
                    </motion.div>
                     
                </motion.div>
              </AnimatePresence>)
              :null
            ))
            }

              {myModalThree && (
              <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal2}
                    variants={modal} 
                    >
                    <GridContainer>
                    {setisSubmit(true)}
                        <GridItem xs={12} sm={12} md={3}>
                          <img alt='Marine Life' width="40" height="100" className="card-img-top" src={baseUrl+'assets/images/pandaPic2.PNG'} />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={9}>
                          <motion.div style={classes.modal2}>
                            <h4 style={classes.fontGaramond}> Are you sure you want to submit </h4>
                            <Button color="success" variant="contained" onClick={closeModalYesThree} 
                              title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                                Yes
                            </Button>
                            <Button color="success" variant="contained" onClick={closeModalNoThree} 
                              title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                                No
                            </Button>
                          </motion.div>
                        </GridItem>
                      </GridContainer>
                    </motion.div>  
                </motion.div>
              </AnimatePresence>)}
    
          
            <GridItem xs={12} sm={12} md={12}>
                <GridContainer>

                  <GridItem xs={12} sm={12} md={12}>
                    <h5 style={{...classes.fontCourier, ...{color:'blue'}}}><b>Important Instructions:</b> Read question for each step. Select the text/number below to complete the statement/equation and then click on the submit button. For any help click support button to contact your teacher</h5>
                    <Stepper activeStep={activeStep} alternativeLabel sx={{backgroundColor:'#e0e2ff'}}>

                      {steps.map((step, index) => {
                
                    return (
                      <Step key={index}>
                        <StepLabel><h5 style={classes.fontLucida}>{step}</h5></StepLabel>
                      </Step>
                      );
                      })}
                    </Stepper>
                  </GridItem>
                
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                      {activeStep=='0' ?   //////Decomposition
                      <GridItem xs={12} sm={12} md={12}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={8}>
                            <Card>
                              <CardHeader color="success">
                                  <h5 style={classes.cardTitleWhite}> {task[0]} </h5>
                              </CardHeader>
                              <p><i>{ansType}</i></p>

                              <CardBody>
                              <GridContainer>
                                 
                                    <GridItem xs={12} sm={12} md={3}>
                                      <h5>Identify Pairwise sum of numbers using index, where number at first index=index1 is 12, last index=index6 is 37. Also identify the difference of pairwise sum with 55</h5>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={9}>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="pairs with first,last index="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'pairs with first,last index=',value:'pairs with first,last index='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="("
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'(',value:'('}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="1st num"
                                                value={num1}
                                                onChange={handleNum1Change}
                                                select
                                                variant="standard"
                                                helperText="first"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {pairList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              
                                              
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value=","
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:',',value:','}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={num2}
                                                onChange={handleNum2Change}
                                                select
                                                variant="standard"
                                                helperText="last"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {pairList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value=")"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:')',value:')'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'=',value:'='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={num1*1+num2*1}
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:num1*1+num2*1,value:num1*1+num2*1}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'=',value:'='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={Math.abs(num1*1+num2*1-55)}
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                helperText="difference with 55"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:Math.abs(num1*1+num2*1-55),value:Math.abs(num1*1+num2*1-55)}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <div>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="pairs with first,second last index="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'pairs with first,second last index=',value:'pairs with first,second last index='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="("
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'(',value:'('}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={num3}
                                                onChange={handleNum3Change}
                                                select
                                                variant="standard"
                                                helperText="first"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {pairList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                             

                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value=","
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:',',value:','}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                            
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={num4}
                                                onChange={handleNum4Change}
                                                select
                                                variant="standard"
                                                helperText="second last"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {pairList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value=")"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:')',value:')'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'=',value:'='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={num3*1+num4*1}
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:num3*1+num4*1,value:num3*1+num4*1}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'=',value:'='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={Math.abs(num3*1+num4*1-55)}
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                helperText="difference with 55"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:Math.abs(num3*1+num4*1-55),value:Math.abs(num3*1+num4*1-55)}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              </div>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="pairs with second, last index="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'pairs with second, last index=',value:'pairs with second, last index='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="("
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'(',value:'('}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={num5}
                                                onChange={handleNum5Change}
                                                select
                                                variant="standard"
                                                helperText="second"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {pairList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value=","
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:',',value:','}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                             
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={num6}
                                                onChange={handleNum6Change}
                                                select
                                                variant="standard"
                                                helperText="last"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {pairList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value=")"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:')',value:')'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'=',value:'='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={num5*1+num6*1}
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:num5*1+num6*1,value:num5*1+num6*1}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'=',value:'='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={Math.abs(num5*1+num6*1-55)}
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                helperText="difference with 55"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:Math.abs(num5*1+num6*1-55),value:Math.abs(num5*1+num6*1-55)}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <div>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="pairs with second, second last index="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'pairs with second, second last index=',value:'pairs with second, second last index='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="("
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'(',value:'('}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={num7}
                                                onChange={handleNum7Change}
                                                select
                                                variant="standard"
                                                helperText="second"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {pairList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value=","
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:',',value:','}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={num8}
                                                onChange={handleNum8Change}
                                                select
                                                variant="standard"
                                                helperText="second last"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {pairList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value=")"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:')',value:')'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'=',value:'='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={num7*1+num8*1}
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:num7*1+num8*1,value:num7*1+num8*1}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>  
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'=',value:'='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={Math.abs(num7*1+num8*1-55)}
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                helperText="difference with 55"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:Math.abs(num7*1+num8*1-55),value:Math.abs(num7*1+num8*1-55)}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              </div>
                                        </GridItem>
                    
                              </GridContainer>
                              </CardBody>
                            </Card>
                              {isSubmitting && <LinearProgress />}
                              <GridItem xs={12} sm={12} md={6}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  disabled={isSubmitting}
                                  onClick={submitForm}
                                >
                                  Save
                                </Button>
                              </GridItem> 
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                              <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                  <Card sx={{border: "1px solid black"}}>
                                    <CardHeader color="primary">
                                      <h5 style={classes.cardTitleWhite}> Entered solution </h5>
                                    </CardHeader>
                                    <CardBody>
                                      Pair with first,last index:({num1},{num2})
                                      <div>Pair with first,second last index: ({num3},{num4})</div>
                                      Pair with second,last index: ({num5},{num6})
                                      <div>Pair with second,second last index: ({num7},{num8})</div>
                                    </CardBody>
                                  </Card>
                                </GridItem>
                                
                                {(mydata.decomposition[0].noOfattempts>1 && mydata.decomposition[0].proceed===false)||(mydata.altStep!="" && mydata.decomposition[0].proceed===false)?
                                   <GridItem xs={12} sm={12} md={12}>
                                   <Fab  variant="extended" color="secondary" aria-label="add" size="small" component="span" 
                                         onClick={ToggleHint}>    
                                         <AssistantIcon sx={{ mr: 1 }} />
                                         Hints
                                   </Fab>
                                   {loadhint === true?loading !== true?
                                     hintGenerate()
                                   :null:null}
                                 </GridItem>
                                :null}
                                
                              </GridContainer>
                            </GridItem>
                        </GridContainer>
                      </GridItem>
                          :activeStep=='1' ?    ///Pattern Recognition
                                        
                      <GridItem xs={12} sm={12} md={12}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={12}>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={8} sx={classes.paper}>
                                  
                                      <p id="simple-modal-description" align='center' style={classes.ana}> Decomposition ({task[0]}) </p>                                    
                                      
                                       <div id="simple-modal-description" align='center'><b>Answer:</b>{mydata.decomposition[0].userText}</div>       
                                </GridItem>
                                    
                                <GridItem xs={12} sm={12} md={8}>
                                  <Card>
                                    <CardHeader color="success">
                                      <h5 style={classes.cardTitleWhite}>{task[1]} </h5>
                                    </CardHeader>
                                    <p><i>{ansType}</i></p>

                                    <CardBody>
                                      <GridContainer>
                                        <GridItem xs={12} sm={12} md={2}>
                                          <h5>Find a way to calculate pairs: </h5>
                                        </GridItem> 
                                        <GridItem xs={12} sm={12} md={10}>
                                          {loading!==true?<p>
     
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={patnum}
                                                //disabled={true}
                                                onChange={handlePatnumChange}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 100}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'find all pair:',value:'find all pair:'},{label:'find specific pair:',value:'find specific pair:'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                            {patnum==='find all pair:'?
                                            <div>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="start from firstNumPair="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'start from firstNumPair=',value:'start from firstNumPair='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={patnum1}
                                                onChange={handlePatnum1Change}
                                                select
                                                variant="standard"
                                                helperText="first index"
                                                //style = {{width: 80}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                              {pairList.map((option) => (
                                                  <MenuItem key={option.value} value={option.value}>
                                                  {option.label}
                                                  </MenuItem>
                                              ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value=",secNumPair="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:',secNumPair=',value:',secNumPair='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={patnum2}
                                                onChange={handlePatnum2Change}
                                                select
                                                variant="standard"
                                                helperText="second index"
                                                //style = {{width: 80}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                              {pairList.map((option) => (
                                                  <MenuItem key={option.value} value={option.value}>
                                                  {option.label}
                                                  </MenuItem>
                                              ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value=",for each Pair:find"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:',for each Pair:find',value:',for each Pair:find'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={num9}
                                                onChange={handleNum9Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 80}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                              {[{label:'minimum',value:'minimum'},{label:'maximum',value:'maximum'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                  <MenuItem key={option.value} value={option.value}>
                                                  {option.label}
                                                  </MenuItem>
                                              ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="of"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'of',value:'of'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={patnum3}
                                                onChange={handlePatnum3Change}
                                                select
                                                variant="standard"
                                                helperText="pairsum"
                                                //style = {{width: 80}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                              {[{label:'pairSum',value:'pairSum'},{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                  <MenuItem key={option.value} value={option.value}>
                                                  {option.label}
                                                  </MenuItem>
                                              ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={patnum4}
                                                onChange={handlePatnum4Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 80}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                              {operatorList.map((option) => (
                                                  <MenuItem key={option.value} value={option.value}>
                                                  {option.label}
                                                  </MenuItem>
                                              ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={patnum5}
                                                onChange={handlePatnum5Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 80}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                              {numberList.map((option) => (
                                                  <MenuItem key={option.value} value={option.value}>
                                                  {option.label}
                                                  </MenuItem>
                                              ))}
                                              </Field>
                                             
                                          </div>
                                            :null}
                                            {patnum==='find specific pair:'?
                                            <div>
                                              <GridItem xs={12} sm={12} md={12}>
                                                  <div>
                                                    <b><p>From previous pairs observe that If first index of pair is same and second index decreases from last to second last: then Pairwise sum  
                                                    
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      value={patnum8}
                                                      onChange={handlePatnum8Change}
                                                      select
                                                      variant="standard"
                                                      helperText="Please select"
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {standard.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    </p></b>
                                                  </div>
                                                  <div>
                                                    
                                                    <b><p>From previous pairs observe that If second index of pair is same and first index increases from first to second: then Pairwise sum  
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      value={patnum9}
                                                      onChange={handlePatnum9Change}
                                                      select
                                                      variant="standard"
                                                      helperText="Please select"
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {standard.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    </p></b>
                                                  </div>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="start from firstNumPair="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'start from firstNumPair=',value:'start from firstNumPair='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={patnum1}
                                                onChange={handlePatnum1Change}
                                                select
                                                variant="standard"
                                                helperText="first index"
                                                //style = {{width: 80}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                              {pairList.map((option) => (
                                                  <MenuItem key={option.value} value={option.value}>
                                                  {option.label}
                                                  </MenuItem>
                                              ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value=",secNumPair="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:',secNumPair=',value:',secNumPair='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={patnum2}
                                                onChange={handlePatnum2Change}
                                                select
                                                variant="standard"
                                                helperText="last index"
                                                //style = {{width: 80}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                              {pairList.map((option) => (
                                                  <MenuItem key={option.value} value={option.value}>
                                                  {option.label}
                                                  </MenuItem>
                                              ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="for specific Pair:find"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'for specific Pair:find',value:'for specific Pair:find'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={num9}
                                                onChange={handleNum9Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 80}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                              {[{label:'minimum',value:'minimum'},{label:'maximum',value:'maximum'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                  <MenuItem key={option.value} value={option.value}>
                                                  {option.label}
                                                  </MenuItem>
                                              ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="of"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'of',value:'of'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={patnum3}
                                                onChange={handlePatnum3Change}
                                                select
                                                variant="standard"
                                                helperText="pairsum"
                                                //style = {{width: 80}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                              {[{label:'pairSum',value:'pairSum'},{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                  <MenuItem key={option.value} value={option.value}>
                                                  {option.label}
                                                  </MenuItem>
                                              ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={patnum4}
                                                onChange={handlePatnum4Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 80}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                              {operatorList.map((option) => (
                                                  <MenuItem key={option.value} value={option.value}>
                                                  {option.label}
                                                  </MenuItem>
                                              ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={patnum5}
                                                onChange={handlePatnum5Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 80}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                              {numberList.map((option) => (
                                                  <MenuItem key={option.value} value={option.value}>
                                                  {option.label}
                                                  </MenuItem>
                                              ))}
                                              </Field>
                                                  
                                                </GridItem>
                                        
                                            </div>
                                             :null}
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="pairs closest to 55"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'pairs closest to 55',value:'pairs closest to 55'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="("
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'(',value:'('}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={patnum6}
                                                onChange={handlePatnum6Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {pairList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value=","
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:',',value:','}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={patnum7}
                                                onChange={handlePatnum7Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {pairList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value=")"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:')',value:')'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'=',value:'='}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={patnum7*1+patnum6*1}
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:patnum7*1+patnum6*1,value:patnum7*1+patnum6*1}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={'diff='+Math.abs(patnum7*1+patnum6*1-55)}
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'diff='+Math.abs(patnum7*1+patnum6*1-55),value:'diff='+Math.abs(patnum7*1+patnum6*1-55)}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                                </p>:null}
                                          {error}
                                        </GridItem>
                                      </GridContainer>
                                    </CardBody>
                                  </Card> 
                                    <GridItem xs={12} sm={12} md={6}>
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={isSubmit}
                                            onClick={submitPatternForm}
                                          >
                                            Save
                                          </Button>
                                    </GridItem> 
                                </GridItem>
                                <GridItem xs={12} sm={12} md={4}>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                      <Card sx={{border: "1px solid black"}}>
                                        <CardHeader color="primary">
                                          <h5 style={classes.cardTitleWhite}> Entered solution </h5>
                                        </CardHeader>
                                        <CardBody>
                                          <b>Find a way to calculate pairs:</b>
                                          <div>{patnum}</div>
                                          
                                          {patnum==='find all pair:'?'start from,firstNumPair=,'+patnum1+',secNumPair=,'+patnum2+',for each Pair:find,'+num9+', of ,'+patnum3+','+patnum4+','+patnum5+':pairs closest to 55:'+patnum6+','+patnum7+',diff='+Math.abs(parseInt(patnum6)*1+parseInt(patnum7)-55): null}
                                          <b>{patnum==='find specific pair:'?'From previous pairs observe that If first index of pair is same and second index decreases from last to second last: then Pairwise sum '+patnum8:null}</b>
                                          <div><b>{patnum==='find specific pair:'?'From previous pairs observe that If second index of pair is same and first index increases from first to second: then Pairwise sum '+patnum9:null}</b></div>
                                          <div>{patnum==='find specific pair:'?'start from firstNumPair= '+patnum1+' secNumPair= '+patnum2:null}</div>
                                          <div>{patnum==='find specific pair:'?'for specific Pair:find '+num9+' of  '+patnum3+' '+patnum4+' '+patnum5:null}</div>
                                          pairs closest to 55 ({patnum6}, {patnum7})
                                        </CardBody>
                                      </Card>
                                    </GridItem>
                                    
                                    {(mydata.pattern[0].noOfattempts>1 && mydata.pattern[0].proceed===false)||(mydata.altStep!="" && mydata.pattern[0].proceed===false)?
                                    <GridItem xs={12} sm={12} md={12}>
                                    <Fab  variant="extended" color="secondary" aria-label="add" size="small" component="span" 
                                          onClick={ToggleHint}>    
                                          <AssistantIcon sx={{ mr: 1 }} />
                                          Hints
                                    </Fab>
                                        {loadhint === true?loading !== true?
                                          hintGenerate()
                                      :null:null}
                                    </GridItem>:null}
                                  </GridContainer>
                                </GridItem>
                              </GridContainer>
                            </GridItem>
                            
                        </GridContainer>
                      </GridItem>

                          :activeStep=='2' ? 

                          
                            <GridItem xs={12} sm={12} md={12}>
                              <GridContainer>
                              <GridItem xs={12} sm={12} md={8} sx={classes.paper}>
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={12}>
                                   <p id="simple-modal-description" align='center' style={classes.ana}> Decomposition ({task[0]}) </p>
                                    
                                    <div id="simple-modal-description" align='center'><b>Answer:</b>{mydata.decomposition[0].userText}</div>
                                  </GridItem>
                                  
                                  
                                  <GridItem xs={12} sm={12} md={12}>
                                   <p id="simple-modal-description" align="center"style={classes.ana}> Pattern Recognition ({task[1]}) </p>
                                    
                                    <div id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.pattern[0].userText)}</div>
                                  </GridItem>
                                  
                                </GridContainer>
                              </GridItem>
                                    
                              <GridItem xs={12} sm={12} md={8}>

                              <Card>
                                <CardHeader color="success">
                                    <h4 style={classes.cardTitleWhite}> {task[2]}</h4>
                                </CardHeader>
                                <p><i>{ansType}</i></p>

                                <CardBody>
                                <GridContainer>
                                 
                                  <GridItem xs={12} sm={12} md={3}>
                                    <h5>Find pair of number among Numbers= 12, 17, 24, 27, 33, 37 having sum closest to n=55</h5>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={9}>  
                                    
                                    {activeStep===2 && mydata.pattern[0].completed===false?
                                        <div>
                                            {mydata.pattern[0].userText.includes('find all pair')===true?
                                            <div>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value='select firstNumPair='
                                                    //onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    disabled={true}
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'select firstNumPair=',value:'select firstNumPair='}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={abs1}
                                                    onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {pairList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value='secNumPair='
                                                    //onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    disabled={true}
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'secNumPair=',value:'secNumPair='}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={abs2}
                                                    onChange={handleAbsChange2}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {pairList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value='from 12, 17, 24, 27, 33, 37'
                                                    //onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    disabled={true}
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'from 12, 17, 24, 27, 33, 37',value:'from 12, 17, 24, 27, 33, 37'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value='for each pair in 12, 17, 24, 27, 33, 37:Pairwise sum='
                                                    //onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    disabled={true}
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'for each pair in 12, 17, 24, 27, 33, 37:Pairwise sum=',value:'for each pair in 12, 17, 24, 27, 33, 37:Pairwise sum='}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={abs3}
                                                    onChange={handleAbsChange3}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={abs4}
                                                    onChange={handleAbsChange4}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {operatorList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={abs5}
                                                    onChange={handleAbsChange5}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <div>
                                                  <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value='Difference=Pairwise sum'
                                                        //onChange={handleAbsChange1}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        disabled={true}
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'Difference=Pairwise sum',value:'Difference=Pairwise sum'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={abs14}
                                                        onChange={handleAbsChange14}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {operatorList.map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={abs15}
                                                        onChange={handleAbsChange15}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'n',value:'n'},{label:'n-1',value:'n-1'},{label:'n+1',value:'n+1'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                  </div>
                                                <div>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value='check if Difference'
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'check if Difference',value:'check if Difference'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={abs6}
                                                      onChange={handleAbsChange6}
                                                      select
                                                      variant="standard"
                                                      helperText="is LessThan"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {compareList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={abs7}
                                                      onChange={handleAbsChange7}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'minimum',value:'minimum'},{label:'maximum',value:'maximum'},{label:'n+1',value:'n+1'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value=',then Pairs=('
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:',then Pairs=(',value:',then Pairs=('}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={myabs1}
                                                      onChange={handleMyAbsChange1}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={myabs2}
                                                      onChange={handleMyAbsChange2}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value=')'
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:')',value:')'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={abs7}
                                                      onChange={handleAbsChange7}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'minimum',value:'minimum'},{label:'maximum',value:'maximum'},{label:'n+1',value:'n+1'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value='='
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'=',value:'='}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value='Difference'
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'Difference',value:'Difference'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                </div>
                                                 
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value='end for'
                                                        //onChange={handleAbsChange1}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        disabled={true}
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'end for',value:'end for'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value='n='
                                                        //onChange={handleAbsChange1}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        disabled={true}
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'n=',value:'n='}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={absNum}
                                                      onChange={handleAbsChangeNum}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {numberList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value='Pairs='
                                                      onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'Pairs=',value:'Pairs='}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      variant="outlined"
                                                      //label="Your sum"
                                                      disabled={true}
                                                      value={PairCalculate()}
                                                      //onChange={compareSolutionChange3}
                                                      //fullWidth= {true} 
                                                      //style = {{width: 340}}
                                                    />
                                                    

                                                    
                                                </div>
                                            :null}
                              
                                        </div>
                                      :null}
                                {activeStep===2 && mydata.pattern[0].completed===true?  
                                              <div>
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value='select firstNumPair='
                                                  //onChange={handleAbsChange1}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  disabled={true}
                                                  //style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'select firstNumPair=',value:'select firstNumPair='}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                              </Field>
                                              
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value={abs1}
                                                  onChange={handleAbsChange1}
                                                  select
                                                  variant="standard"
                                                  helperText="first index"
                                                  //style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {pairList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                              </Field>
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value='secNumPair='
                                                  //onChange={handleAbsChange1}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  disabled={true}
                                                  //style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'secNumPair=',value:'secNumPair='}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                              </Field>
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value={abs2}
                                                  onChange={handleAbsChange2}
                                                  select
                                                  variant="standard"
                                                  helperText="last index"
                                                  //style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {pairList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                              </Field>
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value='from 12, 17, 24, 27, 33, 37'
                                                  //onChange={handleAbsChange1}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  disabled={true}
                                                  //style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'from 12, 17, 24, 27, 33, 37',value:'from 12, 17, 24, 27, 33, 37'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                              </Field>
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value='for each pair in 12, 17, 24, 27, 33, 37:Pairwise sum='
                                                  //onChange={handleAbsChange1}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  disabled={true}
                                                  //style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'for each pair in 12, 17, 24, 27, 33, 37:Pairwise sum=',value:'for each pair in 12, 17, 24, 27, 33, 37:Pairwise sum='}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                              </Field>
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value={abs3}
                                                  onChange={handleAbsChange3}
                                                  select
                                                  variant="standard"
                                                  helperText="first"
                                                  //style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                              </Field>
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value={abs4}
                                                  onChange={handleAbsChange4}
                                                  select
                                                  variant="standard"
                                                  helperText="select"
                                                  //style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {operatorList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                              </Field>
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value={abs5}
                                                  onChange={handleAbsChange5}
                                                  select
                                                  variant="standard"
                                                  helperText="second"
                                                  //style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                              </Field>
                                                  <div>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value='Difference=Pairwise sum'
                                                        //onChange={handleAbsChange1}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        disabled={true}
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'Difference=Pairwise sum',value:'Difference=Pairwise sum'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={abs14}
                                                        onChange={handleAbsChange14}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {operatorList.map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={abs15}
                                                        onChange={handleAbsChange15}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'n',value:'n'},{label:'n-1',value:'n-1'},{label:'n+1',value:'n+1'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                  </div>
                                                <div>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value='check if Difference'
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'check if Difference',value:'check if Difference'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>                                                
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={abs6}
                                                    onChange={handleAbsChange6}
                                                    select
                                                    variant="standard"
                                                    helperText="is LessThan"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {compareList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={abs7}
                                                    onChange={handleAbsChange7}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'minimum',value:'minimum'},{label:'maximum',value:'maximum'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value=',then Pairs=('
                                                    //onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    disabled={true}
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:',then Pairs=(',value:',then Pairs=('}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myabs1}
                                                    onChange={handleMyAbsChange1}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myabs2}
                                                    onChange={handleMyAbsChange2}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value=')'
                                                    //onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    disabled={true}
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:')',value:')'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={abs7}
                                                      onChange={handleAbsChange7}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'minimum',value:'minimum'},{label:'maximum',value:'maximum'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value='='
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'=',value:'='}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value='Difference'
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'Difference',value:'Difference'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                              </div>
                                              <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value='check if Pairwise sum'
                                                    //onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    disabled={true}
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'check if Pairwise sum',value:'check if Pairwise sum'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={abs8}
                                                    onChange={handleAbsChange8}
                                                    select
                                                    variant="standard"
                                                    helperText="less than"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {compareList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={abs9}
                                                    onChange={handleAbsChange9}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'n',value:'n'},{label:'n-1',value:'n-1'},{label:'n+1',value:'n+1'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={abs10}
                                                    onChange={handleAbsChange10}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'increase',value:'increase'},{label:'decrease',value:'decrease'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value='firstNumPair'
                                                    //onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    disabled={true}
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'firstNumPair',value:'firstNumPair'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <div>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value='check if Pairwise sum'
                                                    //onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    disabled={true}
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'check if Pairwise sum',value:'check if Pairwise sum'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={abs11}
                                                    onChange={handleAbsChange11}
                                                    select
                                                    variant="standard"
                                                    helperText="greater"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {compareList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={abs12}
                                                    onChange={handleAbsChange12}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'n',value:'n'},{label:'n-1',value:'n-1'},{label:'n+1',value:'n+1'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={abs13}
                                                    onChange={handleAbsChange13}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'increase',value:'increase'},{label:'decrease',value:'decrease'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value='secNumPair'
                                                    //onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    disabled={true}
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                </div>
                                                
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value='end for'
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'end for',value:'end for'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value='n='
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'n=',value:'n='}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={absNum}
                                                    onChange={handleAbsChangeNum}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {numberList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value='Pairs='
                                                    onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    disabled={true}
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'Pairs=',value:'Pairs='}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    variant="outlined"
                                                    //label="Your sum"
                                                    disabled={true}
                                                    value={PairSpecificCalculate()}
                                                    //onChange={compareSolutionChange3}
                                                    //fullWidth= {true} 
                                                    //style = {{width: 340}}
                                                  /> 
                                                 
                                                  
                                              </div>:null}
                                             
                                        </GridItem>
                                        <p>{error}</p>
                                  
                                </GridContainer>
                                </CardBody>
                                {/* {isSubmitting && <LinearProgress />} */}
                              </Card>
                              <GridItem xs={12} sm={12} md={6}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={isSubmit}
                                    onClick={submitAbstractionForm}
                                  >
                                    Save
                                  </Button>
                                </GridItem> 
                              </GridItem>
                              <GridItem xs={12} sm={12} md={4}>
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={12}>
                                        <Card sx={{border: "1px solid black"}}>
                                          <CardHeader color="primary">
                                            <h5 style={classes.cardTitleWhite}> Entered solution </h5>
                                          </CardHeader>
                                          <CardBody>
                                            {mydata.pattern[0].completed==true?'select firstNumPair= '+abs1+' secNumPair= '+abs2+', from 12,17,24,27,33,37':null}
                                            <div>{mydata.pattern[0].completed==true?'for each pair in 12,17,24,27,33,37:':null}</div>
                                            {mydata.pattern[0].completed==true?'Pairwise sum= '+abs3+abs4+abs5:null}
                                            <div>{mydata.pattern[0].completed==true?'Difference=Pairwise sum'+abs14+''+abs15:null}</div>
                                            <div>{mydata.pattern[0].completed==true?'check if (Difference'+abs6+''+abs7+'), then Pairs= '+myabs1+' ,'+myabs2+' and '+abs7+'=Difference':null}</div>
                                            {mydata.pattern[0].completed==true?'check if (Pairwise sum'+abs8+abs9+') '+abs10+' firstNumPair':null}
                                            <div>{mydata.pattern[0].completed==true?'check if (Pairwise sum'+abs11+abs12+') '+abs13+' secNumPair':null}</div>
      
                                            <div>{mydata.pattern[0].completed==false?'select firstNumPair= '+abs1+' secNumPair= '+abs2+', from 12,17,24,27,33,37,for each pair:Pairwise sum= '+abs3+abs4+abs5:null}</div>                                          
                                            {mydata.pattern[0].completed==false?'Difference=Pairwise sum'+abs14+''+abs15:null}                                          
                                            <div>{mydata.pattern[0].completed==false?'check if Difference '+abs6+''+abs7+', then Pairs=,'+myabs1+','+myabs2:null}</div>                                          
                                            <div>{mydata.pattern[0].completed==false?abs7+'=Difference':null}</div>
                                            {mydata.pattern[0].completed==false?'end for':null}                                          
                                          </CardBody>
                                        </Card>
                                  </GridItem>
                                  
                                  {(mydata.abstraction[0].noOfattempts>1 && mydata.abstraction[0].proceed===false)||(mydata.altStep!="" && mydata.abstraction[0].proceed===false)?
                                  <GridItem xs={12} sm={12} md={12}>
                                  <Fab  variant="extended" color="secondary" aria-label="add" size="small" component="span" 
                                        onClick={ToggleHint}>    
                                        <AssistantIcon sx={{ mr: 1 }} />
                                        Hints
                                  </Fab>
                                        {loadhint === true?loading !== true?
                                          hintGenerate()
                                      :null:null}
                                  </GridItem>:null}
                                </GridContainer>
                              </GridItem> 
                                
                                </GridContainer>
                              </GridItem>                           
                           

                          :activeStep=='3' ?  ///Algorithm design

                           
                              <GridItem xs={12} sm={12} md={12}>
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={8} sx={classes.paper}>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={12}>
                                       <p id="simple-modal-description" align='center' style={classes.ana}> Decomposition ({task[0]}) </p>
                                        
                                        <div id="simple-modal-description" align='center'><b>Answer:</b>{mydata.decomposition[0].userText}</div>
                                      </GridItem>
                                      
                                      
                                      <GridItem xs={12} sm={12} md={12}>
                                       <p id="simple-modal-description" align="center"style={classes.ana}> Pattern Recognition ({task[1]}) </p>
                                        
                                        <div id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.pattern[0].userText)}</div>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>
                                        <p id="simple-modal-description" align="center"style={classes.ana}> Abstraction ({task[2]}) </p>
                                        
                                        <p id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.abstraction[0].userText)}</p>
                                      </GridItem>
                                      
                                    </GridContainer>
                                  </GridItem>
                                    
                                  
                                    <GridItem xs={12} sm={12} md={8}>
                                      <Card>
                                        <CardHeader color="success">
                                          <h4 style={classes.cardTitleWhite}>{task[3]}</h4>
                                        </CardHeader>
                                        <p><i>{ansType}</i></p>
                                          {error}
                                        <CardBody>
                                        <GridContainer>
                                        {loading!==true?
                                          <GridItem xs={12} sm={12} md={12}>
                                            {mydata.abstraction[0].completed===false?
                                            mydata.abstraction[0].userText.includes('find specific pair')==true?
                                            <GridContainer>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                              <h5>Input Statement:</h5> 
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="input"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {textAlgoList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={myalgo}
                                                      onChange={handleAlgorithmChange}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'n',value:'n'},{label:'none',value:''}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="="
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'=',value:'='}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}

                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo1}
                                                    onChange={handleAlgorithmChange1}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    style = {{width: 45}}
                                                    margin="normal"
                                                    //disabled={true}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {numberList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field> 
                                                  
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                              <h5>Define variable/function: </h5> 
                                                  <GridContainer>
                                                    <GridItem xs={12} sm={12} md={3}>
                                                        <Field
                                                            component={TextField}
                                                            type="text"
                                                            name="std"
                                                            //label="Number"
                                                            value="define"
                                                            disabled={true}
                                                            //onChange={handlePatternChange}
                                                            select
                                                            variant="standard"
                                                            //helperText="select"
                                                            //style = {{width: 30}}
                                                            margin="normal"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            >
                                                            {textAlgoList.map((option) => (
                                                                <MenuItem key={option.value} value={option.value}>
                                                                {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Field>
                                                        <Field
                                                            component={TextField}
                                                            type="text"
                                                            name="std"
                                                            //label="Number"
                                                            value={myalgo2}
                                                            onChange={handleAlgorithmChange2}
                                                            select
                                                            variant="standard"
                                                            helperText="select sum var"
                                                            style = {{width: 60}}
                                                            margin="normal"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            >
                                                            {VarList.map((option) => (
                                                                <MenuItem key={option.value} value={option.value}>
                                                                {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Field>
                                                  </GridItem>
                                                  {/* <GridItem xs={12} sm={12} md={2}>
                                                    Fibo({algo})={FiboOutput()}
                                                  </GridItem> */}
                                                  <GridItem xs={12} sm={12} md={9}>
                                                  <GridContainer>
                                                    <b align="Center">Calculate fibonacci number function</b>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <Field
                                                            component={TextField}
                                                            type="text"
                                                            name="std"
                                                            //label="Number"
                                                            value={'define Fib(n):'}
                                                            ///onChange={handleAlgorithmChange1}
                                                            disabled={true}
                                                            select
                                                            variant="standard"
                                                            //helperText="select"
                                                            //style = {{width: 200}}
                                                            margin="normal"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            >
                                                            {[{label:'define Fib(n):',value:'define Fib(n):'}].map((option) => (
                                                                <MenuItem key={option.value} value={option.value}>
                                                                {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Field>
                                                         
                                                        <Field
                                                            component={TextField}
                                                            type="text"
                                                            name="std"
                                                            label="Enter n"
                                                            value={algo}
                                                            onChange={handleAlgoChange}
                                                            select
                                                            variant="standard"
                                                            helperText="select"
                                                            style = {{width: 60}}
                                                            margin="normal"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            >
                                                            {numberList.map((option) => (
                                                                <MenuItem key={option.value} value={option.value}>
                                                                {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Field>

                                                    </GridItem>
                                                    If n is less than 3 the fibonacci number is 1
                                                    <GridItem xs={12} sm={12} md={12}>
                                                       
                                                        <Field
                                                            component={TextField}
                                                            type="text"
                                                            name="std"
                                                            //label="Number"
                                                            value={'if n'}
                                                            ///onChange={handleAlgorithmChange1}
                                                            //disabled={true}
                                                            select
                                                            variant="standard"
                                                            //helperText="select"
                                                            //style = {{width: 200}}
                                                            margin="normal"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            >
                                                            {[{label:'if n',value:'if n'},{label:'else if n',value:'else if n'},{label:'else ',value:'else '}].map((option) => (
                                                                <MenuItem key={option.value} value={option.value}>
                                                                {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Field>
                                                        <Field
                                                            component={TextField}
                                                            type="text"
                                                            name="std"
                                                            //label=""
                                                            value={algo1}
                                                            //disabled={true}
                                                            onChange={handleAlgoChange1}
                                                            select
                                                            variant="standard"
                                                            helperText="select"
                                                            style = {{width: 40}}
                                                            margin="normal"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            >
                                                            {compareList.map((option) => (
                                                                <MenuItem key={option.value} value={option.value}>
                                                                {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Field>
                                                        <Field
                                                            component={TextField}
                                                            type="text"
                                                            name="std"
                                                            //label=""
                                                            value={algo2}
                                                            //disabled={true}
                                                            onChange={handleAlgoChange2}
                                                            select
                                                            variant="standard"
                                                            helperText="select"
                                                            style = {{width: 30}}
                                                            margin="normal"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            >
                                                            {numberList.map((option) => (
                                                                <MenuItem key={option.value} value={option.value}>
                                                                {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Field>
                                                        <Field
                                                           component={TextField}
                                                           type="text"
                                                           name="std"
                                                           //label="Number"
                                                           value={'return'}
                                                           ///onChange={handleAlgorithmChange1}
                                                           //disabled={true}
                                                           select
                                                           variant="standard"
                                                           //helperText="select"
                                                           //style = {{width: 200}}
                                                           margin="normal"
                                                           InputLabelProps={{
                                                               shrink: true,
                                                           }}
                                                           >
                                                           {[{label:'return',value:'return'}].map((option) => (
                                                               <MenuItem key={option.value} value={option.value}>
                                                               {option.label}
                                                               </MenuItem>
                                                           ))}
                                                        </Field>
                                                        <Field
                                                            component={TextField}
                                                            type="text"
                                                            name="std"
                                                            //label=""
                                                            value={algo3}
                                                            //disabled={true}
                                                            onChange={handleAlgoChange3}
                                                            select
                                                            variant="standard"
                                                            helperText="select"
                                                            style = {{width: 30}}
                                                            margin="normal"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            >
                                                            {numberList.map((option) => (
                                                                <MenuItem key={option.value} value={option.value}>
                                                                {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Field>
                                                    </GridItem>
                                                    Or the fibonacci number is equal to last two values i.e., n-1th and n-2th number
                                                    <GridItem xs={12} sm={12} md={12}>
                                                       
                                                        <Field
                                                           component={TextField}
                                                           type="text"
                                                           name="std"
                                                           //label="Number"
                                                           value={'else '}
                                                           ///onChange={handleAlgorithmChange1}
                                                           //disabled={true}
                                                           select
                                                           variant="standard"
                                                           //helperText="select"
                                                           //style = {{width: 200}}
                                                           margin="normal"
                                                           InputLabelProps={{
                                                               shrink: true,
                                                           }}
                                                           >
                                                           {[{label:'if n',value:'if n'},{label:'else if n',value:'else if n'},{label:'else ',value:'else '}].map((option) => (
                                                               <MenuItem key={option.value} value={option.value}>
                                                               {option.label}
                                                               </MenuItem>
                                                           ))}
                                                        </Field>
                                                        <Field
                                                           component={TextField}
                                                           type="text"
                                                           name="std"
                                                           //label="Number"
                                                           value={'return'}
                                                           ///onChange={handleAlgorithmChange1}
                                                           //disabled={true}
                                                           select
                                                           variant="standard"
                                                           //helperText="select"
                                                           //style = {{width: 200}}
                                                           margin="normal"
                                                           InputLabelProps={{
                                                               shrink: true,
                                                           }}
                                                           >
                                                           {[{label:'return',value:'return'}].map((option) => (
                                                               <MenuItem key={option.value} value={option.value}>
                                                               {option.label}
                                                               </MenuItem>
                                                           ))}
                                                        </Field>
                                                        <Field
                                                            component={TextField}
                                                            type="text"
                                                            name="std"
                                                            //label="Number"
                                                            value={algo4}
                                                            onChange={handleAlgoChange4}
                                                            select
                                                            variant="standard"
                                                            helperText="select"
                                                            //style = {{width: 200}}
                                                            margin="normal"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            >
                                                            {fibNewList.map((option) => (
                                                                <MenuItem key={option.value} value={option.value}>
                                                                {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Field>
                                                        <Field
                                                            component={TextField}
                                                            type="text"
                                                            name="std"
                                                            //label=""
                                                            value={algo5}
                                                            //disabled={true}
                                                            onChange={handleAlgoChange5}
                                                            select
                                                            variant="standard"
                                                            helperText="select"
                                                            style = {{width: 30}}
                                                            margin="normal"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            >
                                                            {operatorList.map((option) => (
                                                                <MenuItem key={option.value} value={option.value}>
                                                                {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Field>
                                                        <Field
                                                            component={TextField}
                                                            type="text"
                                                            name="std"
                                                            //label="Number"
                                                            value={algo6}
                                                            onChange={handleAlgoChange6}
                                                            select
                                                            variant="standard"
                                                            helperText="select"
                                                            //style = {{width: 200}}
                                                            margin="normal"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            >
                                                            {fibNewList.map((option) => (
                                                                <MenuItem key={option.value} value={option.value}>
                                                                {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Field>

                                                   </GridItem>
                                                        <Field
                                                            component={TextField}
                                                            type="text"
                                                            name="std"
                                                            //label="Number"
                                                            value={'end function'}
                                                            ///onChange={handleAlgorithmChange1}
                                                            disabled={true}
                                                            select
                                                            variant="standard"
                                                            //helperText="select"
                                                            //style = {{width: 200}}
                                                            margin="normal"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            >
                                                            {[{label:'end function',value:'end function'}].map((option) => (
                                                                <MenuItem key={option.value} value={option.value}>
                                                                {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Field>
                                                        Fibo({algo})={FiboOutput()}

                                                  </GridContainer>
                                                  </GridItem>
                                                </GridContainer>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                              <h5>Set variable: </h5> 
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="set"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo3}
                                                    onChange={handleAlgorithmChange3}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {VarList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="to"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo4}
                                                    onChange={handleAlgorithmChange4}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {fibSumList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label=""
                                                    value={myalgo5}
                                                    //disabled={true}
                                                    onChange={handleAlgorithmChange5}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {operatorList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo6}
                                                    onChange={handleAlgorithmChange6}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {fibSumList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label=""
                                                    value={myalgo7}
                                                    //disabled={true}
                                                    onChange={handleAlgorithmChange7}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {operatorList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo8}
                                                    onChange={handleAlgorithmChange8}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {fibSumList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                                  <h5>Output: </h5>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="output"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {textAlgoList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={myalgo9}
                                                      onChange={handleAlgorithmChange9}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {VarList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  Sum({myalgo1})={FiboSum()}
                                              </GridItem>
                                                {error}
                                            </GridContainer>:///find all pair
                                            <GridContainer>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                                  <h5>Input Statement:</h5> 
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="input"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {textAlgoList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={myalgo1}
                                                      onChange={handleAlgorithmChange1}
                                                      select
                                                      disabled={true}
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'n',value:'n'},{label:'none',value:''}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="="
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'=',value:'='}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}

                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={absNum}
                                                    onChange={handleAbsChangeNum}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 45}}
                                                    margin="normal"
                                                    //disabled={true}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {numberList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="Numbers=12, 17, 24, 27, 33, 37"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'Numbers=12, 17, 24, 27, 33, 37',value:'Numbers=12, 17, 24, 27, 33, 37'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}

                                                  </Field> 
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                              <h5>Define variable: </h5> 
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="define"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo2}
                                                    onChange={handleAlgorithmChange2}
                                                    select
                                                    variant="standard"
                                                    helperText="first num"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'firstNumPair',value:'firstNumPair'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo3}
                                                    onChange={handleAlgorithmChange3}
                                                    select
                                                    variant="standard"
                                                    helperText="second num"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={algo18}
                                                    onChange={handleAlgoChange18}
                                                    select
                                                    variant="standard"
                                                    helperText="min var"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'minimum',value:'minimum'},{label:'maximum',value:'maximum'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo4}
                                                    onChange={handleAlgorithmChange4}
                                                    select
                                                    variant="standard"
                                                    helperText="pairsum var"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {VarList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={algo19}
                                                    onChange={handleAlgoChange19}
                                                    select
                                                    variant="standard"
                                                    helperText="difference var"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {VarList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo5}
                                                    onChange={handleAlgorithmChange5}
                                                    select
                                                    variant="standard"
                                                    helperText="pairs var"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {VarList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                                  <h5>Set variable: </h5> 
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="set"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo6}
                                                    onChange={handleAlgorithmChange6}
                                                    select
                                                    variant="standard"
                                                    helperText="first pair"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'firstNumPair',value:'firstNumPair'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="to"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo7}
                                                    onChange={handleAlgorithmChange7}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {pairList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="set"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo8}
                                                    onChange={handleAlgorithmChange8}
                                                    select
                                                    variant="standard"
                                                    helperText="second pair"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="to"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo9}
                                                    onChange={handleAlgorithmChange9}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {pairList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <div>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="for each firstNumPair and secNumPair:set"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'for each firstNumPair and secNumPair:set',value:'for each firstNumPair and secNumPair:set'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}

                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="pairsum"
                                                      value={algo1}
                                                      onChange={handleAlgoChange1}
                                                      select
                                                      variant="standard"
                                                      helperText="pairsum"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {VarList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="to"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'to',value:'to'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}

                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo2}
                                                      onChange={handleAlgoChange2}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo3}
                                                      onChange={handleAlgoChange3}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {operatorList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo4}
                                                      onChange={handleAlgoChange4}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="set"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'set',value:'set'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}

                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo20}
                                                      onChange={handleAlgoChange20}
                                                      select
                                                      variant="standard"
                                                      helperText="difference"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {VarList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="to"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'to',value:'to'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}

                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo1}
                                                      onChange={handleAlgoChange1}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {VarList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo21}
                                                      onChange={handleAlgoChange21}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {operatorList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo22}
                                                      onChange={handleAlgoChange22}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'n',value:'n'},{label:'n-1',value:'n-1'},{label:'n+1',value:'n+1'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  </div>
                                                  <div>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value='check if'
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'check if',value:'check if'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo20}
                                                      onChange={handleAlgoChange20}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {VarList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo5}
                                                      onChange={handleAlgoChange5}
                                                      select
                                                      variant="standard"
                                                      helperText="is equal to"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {compareList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo6}
                                                      onChange={handleAlgoChange6}
                                                      select
                                                      variant="standard"
                                                      helperText="minimum"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'minimum',value:'minimum'},{label:'maximum',value:'maximum'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value=',set'
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:',set',value:',set'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="pairs"
                                                      value={algo6}
                                                      onChange={handleAlgoChange6}
                                                      select
                                                      variant="standard"
                                                      helperText="pairs"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'minimum',value:'minimum'},{label:'maximum',value:'maximum'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value='to'
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'to',value:'to'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo20}
                                                      onChange={handleAlgoChange20}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {VarList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value=',set'
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:',set',value:',set'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="pairs"
                                                      value={algo7}
                                                      onChange={handleAlgoChange7}
                                                      select
                                                      variant="standard"
                                                      helperText="pairs"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {VarList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value='to ('
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'to (',value:'to ('}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo8}
                                                      onChange={handleAlgoChange8}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo9}
                                                      onChange={handleAlgoChange9}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value=')'
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:')',value:')'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                </div>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                                  <h5>Output: </h5>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="output"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {textAlgoList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="pairs"
                                                      value={algo}
                                                      onChange={handleAlgoChange}
                                                      select
                                                      variant="standard"
                                                      helperText="pairs"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {VarList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value='Pairs='
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'Pairs=',value:'Pairs='}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      variant="outlined"
                                                      //label="Your sum"
                                                      disabled={true}
                                                      value={AlgoPairCalculate()}
                                                      //onChange={compareSolutionChange3}
                                                      //fullWidth= {true} 
                                                      //style = {{width: 340}}
                                                    /> 
                                                    
                                              </GridItem>
                                                {error}
                                            </GridContainer>:  /////if abstraction completed write algorithm
                                            <GridContainer>
                                            <GridItem xs={12} sm={12} md={2}>
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={10}>
                                              <h5>Input Statement:</h5>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="input"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {textAlgoList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={myalgo1}
                                                      onChange={handleAlgorithmChange1}
                                                      select
                                                      disabled={true}
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {VarList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="="
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'=',value:'='}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}

                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={absNum}
                                                    onChange={handleAbsChangeNum}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 45}}
                                                    margin="normal"
                                                    //disabled={true}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {numberList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="Numbers=12, 17, 24, 27, 33, 37"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'Numbers=12, 17, 24, 27, 33, 37',value:'Numbers=12, 17, 24, 27, 33, 37'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}

                                                  </Field> 
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                              <h5>Define variable: </h5> 
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="define"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo2}
                                                    onChange={handleAlgorithmChange2}
                                                    select
                                                    variant="standard"
                                                    helperText="first num"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'firstNumPair',value:'firstNumPair'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo3}
                                                    onChange={handleAlgorithmChange3}
                                                    select
                                                    variant="standard"
                                                    helperText="second num"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={algo18}
                                                    onChange={handleAlgoChange18}
                                                    select
                                                    variant="standard"
                                                    helperText="min var"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'minimum',value:'minimum'},{label:'maximum',value:'maximum'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo4}
                                                    onChange={handleAlgorithmChange4}
                                                    select
                                                    variant="standard"
                                                    helperText="pairsum var"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {VarList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={algo19}
                                                    onChange={handleAlgoChange19}
                                                    select
                                                    variant="standard"
                                                    helperText="difference var"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {VarList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo5}
                                                    onChange={handleAlgorithmChange5}
                                                    select
                                                    variant="standard"
                                                    helperText="pairs var"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {VarList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                              <h5>Set variable: </h5> 
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="set"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo6}
                                                    onChange={handleAlgorithmChange6}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'firstNumPair',value:'firstNumPair'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="to"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo7}
                                                    onChange={handleAlgorithmChange7}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {pairList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="set"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo8}
                                                    onChange={handleAlgorithmChange8}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="to"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo9}
                                                    onChange={handleAlgorithmChange9}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {pairList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <div>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="for specific firstNumPair and secNumPair:set"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'for specific firstNumPair and secNumPair:set',value:'for specific firstNumPair and secNumPair:set'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}

                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo1}
                                                      onChange={handleAlgoChange1}
                                                      select
                                                      variant="standard"
                                                      helperText="pair sum"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {VarList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="to"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'to',value:'to'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}

                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo2}
                                                      onChange={handleAlgoChange2}
                                                      select
                                                      variant="standard"
                                                      helperText="first pair"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo3}
                                                      onChange={handleAlgoChange3}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {operatorList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo4}
                                                      onChange={handleAlgoChange4}
                                                      select
                                                      variant="standard"
                                                      helperText="sec pair"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <div>
                                                      <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value="set"
                                                        disabled={true}
                                                        //onChange={handlePatternChange}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        //style = {{width: 30}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'set',value:'set'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}

                                                      </Field>
                                                      <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo20}
                                                        onChange={handleAlgoChange20}
                                                        select
                                                        variant="standard"
                                                        helperText="difference"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {VarList.map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                      </Field>
                                                      <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value="to"
                                                        disabled={true}
                                                        //onChange={handlePatternChange}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        style = {{width: 30}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'to',value:'to'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}

                                                      </Field>
                                                      <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo1}
                                                        onChange={handleAlgoChange1}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {VarList.map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                      </Field>
                                                      <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo21}
                                                        onChange={handleAlgoChange21}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {operatorList.map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                      </Field>
                                                      <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo22}
                                                        onChange={handleAlgoChange22}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'n',value:'n'},{label:'n-1',value:'n-1'},{label:'n+1',value:'n+1'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    </div>
                                                  </div>
                                                    <div>
                                                      <Field
                                                          component={TextField}
                                                          type="text"
                                                          name="std"
                                                          //label="Number"
                                                          value='check if'
                                                          //onChange={handleAbsChange1}
                                                          select
                                                          variant="standard"
                                                          //helperText="select"
                                                          disabled={true}
                                                          //style = {{width: 200}}
                                                          margin="normal"
                                                          InputLabelProps={{
                                                              shrink: true,
                                                          }}
                                                          >
                                                          {[{label:'check if',value:'check if'}].map((option) => (
                                                              <MenuItem key={option.value} value={option.value}>
                                                              {option.label}
                                                              </MenuItem>
                                                          ))}
                                                      </Field>
                                                      <Field
                                                          component={TextField}
                                                          type="text"
                                                          name="std"
                                                          //label="Number"
                                                          value={algo20}
                                                          onChange={handleAlgoChange20}
                                                          select
                                                          variant="standard"
                                                          helperText="select"
                                                          //style = {{width: 200}}
                                                          margin="normal"
                                                          InputLabelProps={{
                                                              shrink: true,
                                                          }}
                                                          >
                                                          {VarList.map((option) => (
                                                              <MenuItem key={option.value} value={option.value}>
                                                              {option.label}
                                                              </MenuItem>
                                                          ))}
                                                      </Field>
                                                      <Field
                                                          component={TextField}
                                                          type="text"
                                                          name="std"
                                                          //label="Number"
                                                          value={algo5}
                                                          onChange={handleAlgoChange5}
                                                          select
                                                          variant="standard"
                                                          helperText="less Than"
                                                          //style = {{width: 200}}
                                                          margin="normal"
                                                          InputLabelProps={{
                                                              shrink: true,
                                                          }}
                                                          >
                                                          {compareList.map((option) => (
                                                              <MenuItem key={option.value} value={option.value}>
                                                              {option.label}
                                                              </MenuItem>
                                                          ))}
                                                      </Field>
                                                      <Field
                                                          component={TextField}
                                                          type="text"
                                                          name="std"
                                                          //label="Number"
                                                          value={algo6}
                                                          onChange={handleAlgoChange6}
                                                          select
                                                          variant="standard"
                                                          helperText="select"
                                                          //style = {{width: 200}}
                                                          margin="normal"
                                                          InputLabelProps={{
                                                              shrink: true,
                                                          }}
                                                          >
                                                          {[{label:'minimum',value:'minimum'},{label:'maximum',value:'maximum'}].map((option) => (
                                                              <MenuItem key={option.value} value={option.value}>
                                                              {option.label}
                                                              </MenuItem>
                                                          ))}
                                                      </Field>
                                                    <div>
                                                      <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value='set'
                                                        //onChange={handleAbsChange1}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        disabled={true}
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'set',value:'set'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="pairs"
                                                        value={algo6}
                                                        onChange={handleAlgoChange6}
                                                        select
                                                        variant="standard"
                                                        helperText="pairs"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'minimum',value:'minimum'},{label:'maximum',value:'maximum'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value='to'
                                                        //onChange={handleAbsChange1}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        disabled={true}
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'to',value:'to'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo20}
                                                        onChange={handleAlgoChange20}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {VarList.map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                  </div>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value='set'
                                                        //onChange={handleAbsChange1}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        disabled={true}
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'set',value:'set'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo7}
                                                        onChange={handleAlgoChange7}
                                                        select
                                                        variant="standard"
                                                        helperText="pairs"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {VarList.map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value='to ('
                                                        //onChange={handleAbsChange1}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        disabled={true}
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'to (',value:'to ('}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo8}
                                                        onChange={handleAlgoChange8}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo9}
                                                        onChange={handleAlgoChange9}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value=')'
                                                        //onChange={handleAbsChange1}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        disabled={true}
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:')',value:')'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                  </div>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value='else check if'
                                                        //onChange={handleAbsChange1}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        disabled={true}
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'else check if',value:'else check if'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo1}
                                                        onChange={handleAlgoChange1}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {VarList.map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo10}
                                                        onChange={handleAlgoChange10}
                                                        select
                                                        variant="standard"
                                                        helperText="less than"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {compareList.map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo11}
                                                        onChange={handleAlgoChange11}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'n',value:'n'},{label:'n-1',value:'n-1'},{label:'n+1',value:'n+1'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value='then'
                                                        //onChange={handleAbsChange1}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        disabled={true}
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'then',value:'then'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo12}
                                                        onChange={handleAlgoChange12}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'increase',value:'increase'},{label:'decrease',value:'decrease'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                   
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo13}
                                                        onChange={handleAlgoChange13}
                                                        select
                                                        variant="standard"
                                                        helperText="first num"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                  <div>
                                                  <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value='else check if'
                                                        //onChange={handleAbsChange1}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        disabled={true}
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'else check if',value:'else check if'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo1}
                                                        onChange={handleAlgoChange1}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {VarList.map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo14}
                                                        onChange={handleAlgoChange14}
                                                        select
                                                        variant="standard"
                                                        helperText="greater than"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {compareList.map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo15}
                                                        onChange={handleAlgoChange15}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'n',value:'n'},{label:'n-1',value:'n-1'},{label:'n+1',value:'n+1'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value='then'
                                                        //onChange={handleAbsChange1}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        disabled={true}
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'then',value:'then'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo16}
                                                        onChange={handleAlgoChange16}
                                                        select
                                                        variant="standard"
                                                        helperText="select"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'increase',value:'increase'},{label:'decrease',value:'decrease'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                   
                                                    <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value={algo17}
                                                        onChange={handleAlgoChange17}
                                                        select
                                                        variant="standard"
                                                        helperText="second num"
                                                        //style = {{width: 200}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {[{label:'firstNumPair',value:'firstNumPair'},{label:'secNumPair',value:'secNumPair'}].map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                  </div>

                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                                  <h5>Output: </h5>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="output"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {textAlgoList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo}
                                                      onChange={handleAlgoChange}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {VarList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value='Pairs='
                                                      //onChange={handleAbsChange1}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      disabled={true}
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'Pairs=',value:'Pairs='}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      variant="outlined"
                                                      //label="Your sum"
                                                      disabled={true}
                                                      value={AlgoSpecificPairCalculate()}
                                                      //onChange={compareSolutionChange3}
                                                      //fullWidth= {true} 
                                                      //style = {{width: 340}}
                                                    /> 
                                                    
                                              </GridItem>
                                              {error}
                                          </GridContainer>}
                                          </GridItem>:null}
                                        </GridContainer>
                                        </CardBody>
                                        <GridItem xs={12} sm={12} md={6}>
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={isSubmit}
                                            onClick={submitAlgorithmForm}
                                          >
                                            Save
                                          </Button>
                                        </GridItem>
                                      </Card>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={4}>
                                      <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                          <Card sx={{border: "1px solid black"}}>
                                            <CardHeader color="primary">
                                              <h5 style={classes.cardTitleWhite}> Entered solution </h5>
                                            </CardHeader>
                                            <CardBody>
                                            {mydata.abstraction[0].userText.includes('find specific pair')==true?
                                              algoNewToText('input,'+myalgo1+'Numbers=12,17,24,27,33,37;define,'+myalgo2+','+myalgo3+','+algo18+','+myalgo4+','+algo19+','+myalgo5+';set,'+myalgo6+',to,'+myalgo7+',set,'+myalgo8+',to,'+myalgo9+',for each firstNumPair and secNumPair set,'+algo1+',to,'+algo2+','+algo3+','+algo4+',set,'+algo20+',to,'+algo1+','+algo21+','+algo22+',check if,'+algo20+','+algo5+','+algo6+',set,'+algo6+',to,'+algo20+',then set,'+algo7+',to,'+algo8+','+algo9+',check if,'+algo1+','+algo10+','+algo11+',then,'+algo12+','+algo13+',check if,'+algo1+','+algo14+','+algo15+',then,'+algo16+','+algo17+';output,'+algo)
                                              :algoNewToText('input,'+myalgo1+'=55, Numbers=12,17,24,27,33,37;define,'+myalgo2+','+myalgo3+','+algo18+','+myalgo4+','+algo19+','+myalgo5+';set,'+myalgo6+',to,'+myalgo7+',set,'+myalgo8+',to,'+myalgo9+',for each firstNumPair and secNumPair set,'+algo1+',to,'+algo2+','+algo3+','+algo4+',set,'+algo20+',to,'+algo1+','+algo21+','+algo22+',check if,'+algo20+','+algo5+','+algo6+',set,'+algo6+',to,'+algo20+',then set,'+algo7+',to,'+algo8+','+algo9+';output,'+algo)}                
                                                                                                                         
                                            </CardBody>
											{mydata.abstraction[0].userText.includes('find specific pair')==true?
                                              solutionEnter('activity4', 'algorithm','input,'+myalgo1+'Numbers=12,17,24,27,33,37;define,'+myalgo2+','+myalgo3+','+algo18+','+myalgo4+','+algo19+','+myalgo5+';set,'+myalgo6+',to,'+myalgo7+',set,'+myalgo8+',to,'+myalgo9+',for each firstNumPair and secNumPair set,'+algo1+',to,'+algo2+','+algo3+','+algo4+',set,'+algo20+',to,'+algo1+','+algo21+','+algo22+',check if,'+algo20+','+algo5+','+algo6+',set,'+algo6+',to,'+algo20+',then set,'+algo7+',to,'+algo8+','+algo9+',check if,'+algo1+','+algo10+','+algo11+',then,'+algo12+','+algo13+',check if,'+algo1+','+algo14+','+algo15+',then,'+algo16+','+algo17+';output,'+algo)
                                              :solutionEnter('activity4', 'algorithm','input,'+myalgo1+'=55, Numbers=12,17,24,27,33,37;define,'+myalgo2+','+myalgo3+','+algo18+','+myalgo4+','+algo19+','+myalgo5+';set,'+myalgo6+',to,'+myalgo7+',set,'+myalgo8+',to,'+myalgo9+',for each firstNumPair and secNumPair set,'+algo1+',to,'+algo2+','+algo3+','+algo4+',set,'+algo20+',to,'+algo1+','+algo21+','+algo22+',check if,'+algo20+','+algo5+','+algo6+',set,'+algo6+',to,'+algo20+',then set,'+algo7+',to,'+algo8+','+algo9+';output,'+algo)}                
                                                
                                          </Card>
                                        </GridItem>
                                        
                                        {(mydata.algorithm[0].noOfattempts>1 && mydata.algorithm[0].proceed===false)||(mydata.altStep!="" && mydata.algorithm[0].proceed===false)?
                                        <GridItem xs={12} sm={12} md={12}>
                                        <Fab  variant="extended" color="secondary" aria-label="add" size="small" component="span" 
                                              onClick={ToggleHint}>    
                                              <AssistantIcon sx={{ mr: 1 }} />
                                              Hints
                                        </Fab>
                                            {loadhint === true?loading !== true?
                                              hintGenerate()
                                          :null:null}
                                        </GridItem>:null}
                                      </GridContainer>
                                  </GridItem>
                                  
                                </GridContainer>
                              </GridItem>
                            

                          :activeStep=='4' ?    ////Analysis of algorithm
                           
                              <GridItem xs={12} sm={12} md={12}>
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={9} sx={classes.paper}>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={12}>
                                       <p id="simple-modal-description" align="center" style={classes.ana}> Decomposition ({task[0]}) </p>
                                        
                                        <div id="simple-modal-description" align="center"><b>Answer:</b>{mydata.decomposition[0].userText}</div>
                                      </GridItem>
                                      
                                      
                                      <GridItem xs={12} sm={12} md={12}>
                                       <p id="simple-modal-description" align="center" style={classes.ana}> Pattern Recognition ({task[1]}) </p>
                                        
                                        <div id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.pattern[0].userText)}</div>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>
                                        <p id="simple-modal-description" align="center" style={classes.ana}> Abstraction ({task[2]}) </p>
                                        
                                        <p id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.abstraction[0].userText)}</p>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>
                                          <p id="simple-modal-description" align="center" style={classes.ana}> Algorithm ({task[3]}) </p>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={2}>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={8}>
                                            {algoNewToText(mydata.algorithm[0].userText)}
                                        </GridItem>
                                    </GridContainer>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={8}>
                                    <Card>
                                      <CardHeader color="success">
                                        <h4 style={classes.cardTitleWhite}>{task[4]} </h4>

                                      </CardHeader>
                                      <p><i>{ansType}</i></p>
                                      <CardBody>
                                        <GridContainer>
                                          <GridItem xs={12} sm={12} md={12}>
                                            <GridContainer>
                                              <GridItem xs={12} sm={12} md={5}>
                                                <h5>Enter the total number of operations: </h5>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={7}>
                                                {loading!==true?
                                                <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                label="No. of operations"
                                                value={mytime}
                                                onChange={handleTimeChange}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 200}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                                  :null}
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={5}>
                                                <h5>Enter the total number of defined variables: </h5>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={7}>
                                                {loading!==true?
                          
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  label="No. of variables"
                                                  value={myspace}
                                                  onChange={handleSpaceChange}
                                                  select
                                                  variant="standard"
                                                  helperText="select"
                                                  style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {numberList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                                  :null}
                                              </GridItem>
                                              {error}
                                            </GridContainer>
                                          </GridItem>
                                        </GridContainer>
                                      </CardBody>
                                    </Card>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          disabled={isSubmit}
                                          onClick={submitAnalysisForm}
                                        >
                                          Save
                                        </Button>
                                    </GridItem>
                                  </GridItem>
                                  {solutionEnter('activity4', 'analysis','No. of operations '+mytime+';No. of variables '+myspace)}
                                  <GridItem xs={12} sm={12} md={4}>
                                      <GridContainer>
                                        
                                        {(mydata.analysis[0].noOfattempts>1 && mydata.analysis[0].proceed===false)||(mydata.altStep!="" && mydata.analysis[0].proceed===false)?
                                        <GridItem xs={12} sm={12} md={12}>
                                        <Fab  variant="extended" color="secondary" aria-label="add" size="small" component="span" 
                                              onClick={ToggleHint}>    
                                              <AssistantIcon sx={{ mr: 1 }} />
                                              Hints
                                        </Fab>
                                            {loadhint === true?loading !== true?
                                              hintGenerate()
                                          :null:null}
                                        </GridItem>:null}
                                      </GridContainer>
                                  </GridItem>
                                  
                                </GridContainer>
                              </GridItem>
                            

                          :activeStep=='5' ? 

                          <GridItem xs={12} sm={12} md={12}>
                            <GridContainer>
                              <Card>
                                <CardHeader color="success">
                                  <h4 style={classes.cardTitleWhite}> Your Solution </h4>
                                </CardHeader>
                                <p><i>{ansType}</i></p>
                                <CardBody>
                                <GridContainer>
                                  {loading!==true?
                                  <GridItem xs={12} sm={12} md={12} sx={classes.paper}>
                                    
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={12}>
                                         <p id="simple-modal-description" align="center" style={classes.ana}> Decomposition ({task[0]}) </p>
                                          
                                          <div id="simple-modal-description" align='center'><b>Answer:</b>{mydata.decomposition[0].userText}</div>
                                        </GridItem>
                                        
                                        
                                        <GridItem xs={12} sm={12} md={12}>
                                         <p id="simple-modal-description" align="center" style={classes.ana}> Pattern Recognition ({task[1]}) </p>
                                          
                                          <div id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.pattern[0].userText)}</div>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                          <p id="simple-modal-description" align="center" style={classes.ana}> Abstraction ({task[2]}) </p>
                                          
                                          <p id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.abstraction[0].userText)}</p>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <p id="simple-modal-description" align="center" style={classes.ana}> Algorithm ({task[3]}) </p>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                            {algoNewToText(mydata.algorithm[0].userText)}
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                        </GridItem>
                                        
                                        <GridItem xs={12} sm={12} md={12}>
                                            <p id="simple-modal-description" align="center" style={classes.ana}> Analysis of the algorithm </p>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                            <p id="simple-modal-description"> No. of operations : {mydata.analysis[0].timeText}</p>
                                        </GridItem>
                                        
                                        <GridItem xs={12} sm={12} md={6}>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                            <p id="simple-modal-description"> No. of variables : {mydata.analysis[0].spaceText}</p>
                                        </GridItem>
                                        
                                      
                                  </GridContainer>

                                                                     
                                  </GridItem>:null}
                                </GridContainer>
                                </CardBody>
                                {/* {isSubmitting && <LinearProgress />} */}
                              </Card>
                                
                            </GridContainer>
                          </GridItem>
                          :activeStep=='6'?
                          <GridItem xs={12} sm={12} md={12}>
                            <GridContainer>
                              <Card>
                                <CardHeader color="success">
                                <h4 style={classes.cardTitleWhite}> {task[6]} </h4>

                                </CardHeader>
                                <CardBody>
                                  {error}
                                <Accordion expanded={expanded1 === 'panel12'} onChange={handleAccordionChange1('panel12')}>
                                  <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2bh-content"
                                    id="panel2bh-header"
                                  >
                                    <Typography sx={classes.heading}>Question 1</Typography>
                                    <Typography sx={classes.secondaryHeading}>
                                    Which of the solutions do you think is better?
                                    </Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    <GridContainer spacing={3}>
                                      {mydata.decomposition[0].alternateSolution.map((text, index)=>{
                                      if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                        if(text.algorithm.includes('nitesh')==true){
                                          var newalgo=text.algorithm.split('nitesh')
                                        }
                                        var arr = text.analysis.split(',')
                                        var newarr1=arr[0].split('=')
                                        var newarr2=arr[1].split('=')
                                        var tim = newarr1[1]
                                        var spc = newarr2[1]
                                          return (
                                            text.algoCompleted==true?
                                            
                                            <GridItem xs={12} sm={6} md={6} key={index}>
                                                {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1,'1','decomposition')}
                                            </GridItem> 
                                            :null
                                          )}})}
                                        {mydata.pattern[0].alternateSolution.map((text, index)=>{
                                          if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                          var len=0;
                                          if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                            len=mydata.decomposition[0].alternateSolution.length
                                          }
                                          if(text.algorithm.includes('nitesh')==true){
                                            var newalgo=text.algorithm.split('nitesh')
                                          }
                                          var arr = text.analysis.split(',')
                                          var newarr1=arr[0].split('=')
                                          var newarr2=arr[1].split('=')
                                          var tim = newarr1[1]
                                          var spc = newarr2[1]
                                          return (
                                          text.algoCompleted==true?
                                          <GridItem xs={12} sm={6} md={6} key={index}>
                                              {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'1','pattern')}
                                          </GridItem> 
                                          :null
                                        )}})}
                                        {mydata.abstraction[0].alternateSolution.map((text, index)=>{
                                          if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                        var len=0;
                                        if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                          len=mydata.decomposition[0].alternateSolution.length
                                        }
                                        if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                          len=len+mydata.pattern[0].alternateSolution.length
                                        }
                                        if(text.algorithm.includes('nitesh')==true){
                                          var newalgo=text.algorithm.split('nitesh')
                                        }
                                        var arr = text.analysis.split(',')
                                        var newarr1=arr[0].split('=')
                                        var newarr2=arr[1].split('=')
                                        var tim = newarr1[1]
                                        var spc = newarr2[1]
                                        return (
                                        text.algoCompleted==true?
                                          <GridItem xs={12} sm={6} md={6} key={index}>
                                            {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'1','abstraction')}
                                          </GridItem>  
                                        :null
                                        )}})}
                                        {mydata.algorithm[0].alternateSolution.map((text, index)=>{
                                          if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                          var len=0;
                                          if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                            len=mydata.decomposition[0].alternateSolution.length
                                          }
                                          if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                            len=len+mydata.pattern[0].alternateSolution.length
                                          }
                                          if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                            len=len+mydata.abstraction[0].alternateSolution.length
                                          }
                                          if(text.algorithm.includes('nitesh')==true){
                                            var newalgo=text.algorithm.split('nitesh')
                                          }
                                          var arr = text.analysis.split(',')
                                          var newarr1=arr[0].split('=')
                                          var newarr2=arr[1].split('=')
                                          var tim = newarr1[1]
                                          var spc = newarr2[1]
                                          return (
                                          text.algoCompleted==true?
                                          <GridItem xs={12} sm={6} md={6} key={index}>
                                              {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'1','algorithm')}
                                          </GridItem> 
                                            :null
                                          )}})}
                                          {mydata.analysis[0].completed===true?
                                                <GridItem xs={12} sm={6} md={6}>                                          
                                                    {totalSolutionComparison(mydata.decomposition[0].userText,mydata.pattern[0].userText,mydata.abstraction[0].userText,mydata.algorithm[0].userText,mydata.analysis[0].timeText,mydata.analysis[0].spaceText,solutionIndex()+1,'1','correct')}
                                                </GridItem>             
                                          :null}

                                          {mydata.analysis[0].completed===true?
                                              
                                                  <>
                                                  {mydata.comparison[0].alternateSolution.map((text, index)=>{
                                                    var len=0;
                                                    if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                                      len=mydata.decomposition[0].alternateSolution.length
                                                    }
                                                    if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                                      len=len+mydata.pattern[0].alternateSolution.length
                                                    }
                                                    if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                                      len=len+mydata.abstraction[0].alternateSolution.length
                                                    }
                                                    if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
                                                      len=len+mydata.algorithm[0].alternateSolution.length
                                                    }
                                                    return(
                                                      <GridItem xs={12} sm={6} md={6} key={index}>
                                                        {solutionComparison(text.algorithm,text.analysis,len+index+2,'1')}
                                                      </GridItem>
                                                    )})}
                                                    </>
                                              
                                              :null}
                                      </GridContainer>
                                    </AccordionDetails>
                                </Accordion>
                            <Accordion expanded={expanded1 === 'panel13'} onChange={handleAccordionChange1('panel13')}>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2bh-content"
                                id="panel2bh-header"
                                >
                                  <Typography sx={classes.heading}>Question 2</Typography>
                                  <Typography sx={classes.secondaryHeading}>
                                  Your system can perform only maximum 15 operations. If you want to implement one of the solutions, which one do you think is better?
                                  </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <GridContainer spacing={3}>
                                {mydata.decomposition[0].alternateSolution.map((text, index)=>{
                                  if(text.algorithm.includes('nitesh')==true){
                                    var newalgo=text.algorithm.split('nitesh')
                                  }
                                  var arr = text.analysis.split(',')
                                  var newarr1=arr[0].split('=')
                                  var newarr2=arr[1].split('=')
                                  var tim = newarr1[1]
                                  var spc = newarr2[1]
                                    return (
                                      text.algoCompleted==true?
                                      
                                      <GridItem xs={12} sm={6} md={6} key={index}>
                                          {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1,'3','decomposition')}
                                      </GridItem> 
                                      :null
                                    )})}
                                  {mydata.pattern[0].alternateSolution.map((text, index)=>{
                                    var len=0;
                                    if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                      len=mydata.decomposition[0].alternateSolution.length
                                    }
                                    if(text.algorithm.includes('nitesh')==true){
                                      var newalgo=text.algorithm.split('nitesh')
                                    }
                                    var arr = text.analysis.split(',')
                                    var newarr1=arr[0].split('=')
                                    var newarr2=arr[1].split('=')
                                    var tim = newarr1[1]
                                    var spc = newarr2[1]
                                    return (
                                    text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={6} key={index}>
                                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'3','pattern')}
                                    </GridItem> 
                                     :null
                                  )})}
                                  {mydata.abstraction[0].alternateSolution.map((text, index)=>{
                                  var len=0;
                                  if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                    len=mydata.decomposition[0].alternateSolution.length
                                  }
                                  if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                    len=len+mydata.pattern[0].alternateSolution.length
                                  }
                                  if(text.algorithm.includes('nitesh')==true){
                                    var newalgo=text.algorithm.split('nitesh')
                                  }
                                  var arr = text.analysis.split(',')
                                  var newarr1=arr[0].split('=')
                                  var newarr2=arr[1].split('=')
                                  var tim = newarr1[1]
                                  var spc = newarr2[1]
                                  return (
                                  text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={6} key={index}>
                                      {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'3','abstraction')}
                                    </GridItem>  
                                  :null
                                  )})}
                                  {mydata.algorithm[0].alternateSolution.map((text, index)=>{
                                    var len=0;
                                    if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                      len=mydata.decomposition[0].alternateSolution.length
                                    }
                                    if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                      len=len+mydata.pattern[0].alternateSolution.length
                                    }
                                    if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                      len=len+mydata.abstraction[0].alternateSolution.length
                                    }
                                    if(text.algorithm.includes('nitesh')==true){
                                      var newalgo=text.algorithm.split('nitesh')
                                    }
                                    var arr = text.analysis.split(',')
                                    var newarr1=arr[0].split('=')
                                    var newarr2=arr[1].split('=')
                                    var tim = newarr1[1]
                                    var spc = newarr2[1]
                                    return (
                                    text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={6} key={index}>
                                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'3','algorithm')}
                                    </GridItem> 
                                      :null
                                    )})}
                                    {mydata.analysis[0].completed===true?
                                          <GridItem xs={12} sm={6} md={6}>                                          
                                              {totalSolutionComparison(mydata.decomposition[0].userText,mydata.pattern[0].userText,mydata.abstraction[0].userText,mydata.algorithm[0].userText,mydata.analysis[0].timeText,mydata.analysis[0].spaceText,solutionIndex()+1,'3','correct')}
                                          </GridItem>             
                                    :null}

                                    {mydata.analysis[0].completed===true?
                                        
                                            <>
                                            {mydata.comparison[0].alternateSolution.map((text, index)=>{
                                              var len=0;
                                              if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                                len=mydata.decomposition[0].alternateSolution.length
                                              }
                                              if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                                len=len+mydata.pattern[0].alternateSolution.length
                                              }
                                              if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                                len=len+mydata.abstraction[0].alternateSolution.length
                                              }
                                              if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
                                                len=len+mydata.algorithm[0].alternateSolution.length
                                              }
                                              return(
                                                <GridItem xs={12} sm={6} md={6} key={index}>
                                                  {solutionComparison(text.algorithm,text.analysis,len+index+2,'3')}
                                                </GridItem>
                                              )})}
                                              </>
                                        
                                        :null}
                                    </GridContainer>
                                  </AccordionDetails>
                                </Accordion>
                                  {error}
                                </CardBody>
                              </Card>
                              <GridItem xs={12} sm={12} md={6}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  disabled={isSubmit}
                                  onClick={submitComparisonForm}
                                >
                                  Save
                                </Button>
                              </GridItem>
                            </GridContainer>
                            {solutionEnter('activity4', 'comparison','1. Better solution: '+mycomsol+',1. Reason: '+mycomsol1+'; 2. Efficient solution: '+mycomsol2+', 2. Reason: '+mycomsol3)}
                          </GridItem>
                          :null}
                      </GridContainer>
                      {loading!==true?
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={9}>
                              </GridItem>
                              <GridItem xs={12} sm={12} md={3}>
                                  <div style={classes.styleChatbutton}>
                                   <Tooltip
                                    arrow
                                    title="Click for Support"
                                    placement="bottom">
                                    <Fab  color="secondary" aria-label="add" size="medium" component="span" onClick={Togglesupport}>    
                                      <ContactSupportIcon /> {Notification('activity4')==true?'1':null}
                                    </Fab>
                                    </Tooltip>
                                    <p>Support</p>
                                  </div>
                                  
                                  {loadsupport === true?loading !== true?
                                  <>
                                    <div style={classes.chatClose}>
                                      <Fab color="warning" aria-label="add" size="small" component="span" onClick={Togglesupport}>    
                                        <CloseIcon  onClick={Togglesupport}/>
                                        
                                      </Fab>
                                    </div>
                                    <div style={classes.chatContainer}>                                      
                                        <Support user = {sesId} act = 'activity4' classid = {classId}/>
                                    </div>
                                  </>
                                  :null:null} 
                                  
                              </GridItem>
                            <GridItem xs={12} sm={12} md={9}>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                            {isSubmit && <LinearProgress />}
                              <div>
                                {activeStep === steps.length-2 ? (
                                  <div>
                                    <Typography sx={classes.instructions}> Preview steps </Typography>
                                    {/* <Button onClick={handleReset}>Reset</Button> */}
                                    <Button
                                        onClick={handleBack}
                                        sx={classes.backButton}
                                      >
                                        Back
                                      </Button>
                                      
                                      
                                    {mydata.analysis[0].completed!==true?
                                      <Button
                                        onClick={handleAltSolution}
                                        disabled={isSubmit}
                                        variant="contained"
                                        color="primary"
                                      >
                                        Go to {mydata.altStep}
                                      </Button>
                                      :null
                                      // <Button onClick={handleClosePreview}> Preview </Button>
                                      }
                                    {mydata.analysis[0].completed==true?
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleNext}
                                        disabled={isSubmit}
                                      >
                                        Compare solutions 
                                      </Button>:null}
                                  </div>
                                ) : activeStep === steps.length-1 ?(
                                <div>
                                    <Button
                                        onClick={handleBack}
                                        sx={classes.backButton}
                                      >
                                        Back
                                    </Button>
                                  {mydata.analysis[0].completed==true?
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      onClick={handleNext}
                                      disabled={isSubmit}
                                    >
                                      Submit Answer 
                                    </Button>:null}
                                </div>):
                                (
                                  <div>
                                    {/* <Typography sx={classes.instructions}>{getStepContent(activeStep)}</Typography> */}
                                    <div>
                                      <Button
                                        disabled={activeStep === 0}
                                        onClick={handleBack}
                                        sx={classes.backButton}
                                      >
                                        Back
                                      </Button>
                                      
                                      <Button variant="contained" color="primary"
                                      disabled={isSubmit} 
                                      onClick={handleNext}>
                                        {activeStep === steps.length - 3 ? 'Finish' : 'Submit and Go to Next Step'}
                                      </Button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </GridItem>
                      </GridContainer>:null}
                  </GridItem>

                </GridContainer>
              </GridItem>
            </GridContainer>:null}
                                                                      

          </Form>
          )}
          </Formik>
           )
                      
          },
          {
            tabName: "Previous Attempts",
            tabIcon: DeveloperBoardIcon,
            tabContent: (
              <GridItem xs={12} sm={12} md={12}>
              {mydata.analysis[0].completed===true||mydata.decomposition[0].alternateSolution.length>0||mydata.pattern[0].alternateSolution.length>0 || mydata.abstraction[0].alternateSolution.length>0?
                 
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                        {mydata.decomposition[0].alternateSolution.map((text, index)=>{
                           if(text.algorithm.includes('nitesh')==true){
                            var newalgo=text.algorithm.split('nitesh')
                          }
                            return (
                              text.algoCompleted==true?
                               
                              <div>
                                <h5 id="simple-modal-description" align='center'> Solution {index+1}  </h5>
                                <p><i> <b>Decomposition:</b> {text.decomposition}</i></p>
                                <p><b> Pattern:</b> {text.pattern}</p>
                                <p><b>Abstraction:</b> {text.abstraction}</p>

                                <p><b>Algorithm:</b>{algoNewToText(newalgo[1])}</p>
                                <p><b>Analysis:</b> {text.analysis}</p>
                              </div> :<p>Wait until you complete the current solution</p>
                            )})}
                            {mydata.pattern[0].alternateSolution.map((text, index)=>{
                              var len=0;
                              if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                len=mydata.decomposition[0].alternateSolution.length
                              }
                              if(text.algorithm.includes('nitesh')==true){
                                var newalgo=text.algorithm.split('nitesh')
                              }
                            return (
                              text.algoCompleted==true?
                               
                              <div>
                                <h5 id="simple-modal-description" align='center'> Solution {index+len+1}  </h5>
                                <p><b>Decomposition:</b> {text.decomposition}</p>
                                <p><i> <b> Pattern:</b> {text.pattern}</i></p>
                                <p><b>Abstraction:</b> {text.abstraction}</p>
                                <p><b>Algorithm:</b>{algoNewToText(newalgo[1])}</p>
                                <p><b>Analysis:</b>{text.analysis}</p>
                              </div> :<p>Wait until you complete the current solution</p>
                            )})}
                            {mydata.abstraction[0].alternateSolution.map((text, index)=>{
                            var len=0;
                            if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                              len=mydata.decomposition[0].alternateSolution.length
                            }
                            if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                              len=len+mydata.pattern[0].alternateSolution.length
                            }
                            if(text.algorithm.includes('nitesh')==true){
                              var newalgo=text.algorithm.split('nitesh')
                            }
                            return (
                              text.algoCompleted==true?
                               
                              <div>
                                <h5 id="simple-modal-description" align='center'> Solution {index+len+1}  </h5>
                                <p><b>Decomposition:</b> {text.decomposition}</p>
                                <p><b> Pattern:</b> {text.pattern}</p>
                                <p><i><b>Abstraction:</b>{text.abstraction}</i></p>
                                <p><b>Algorithm:</b>{algoNewToText(newalgo[1])}</p>
                                <p><b>Analysis:</b>{text.analysis}</p>
                              </div> :<p>Wait until you complete the current solution</p>
                            )})}
                            {mydata.algorithm[0].alternateSolution.map((text, index)=>{
                              var len=0;
                              if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                len=mydata.decomposition[0].alternateSolution.length
                              }
                              if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                len=len+mydata.pattern[0].alternateSolution.length
                              }
                              if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                len=len+mydata.abstraction[0].alternateSolution.length
                              }
                              if(text.algorithm.includes('nitesh')==true){
                                var newalgo=text.algorithm.split('nitesh')
                              }
                              return (
                                text.algoCompleted==true?
                                
                                <div>
                                  <h5 id="simple-modal-description" align='center'> Solution {index+len+1}  </h5>
                                  <p><b>Decomposition:</b> {text.decomposition}</p>
                                  <p><b> Pattern:</b> {commaToText(text.pattern)}</p>
                                  <p><b>Abstraction:</b>{commaToText(text.abstraction)}</p>
                                  <p><i><b>Algorithm:</b>{algoNewToText(newalgo[1])}</i></p>
                                  <p><b>Analysis:</b>{text.analysis}</p>
                                </div> :<p>Wait until you complete the current solution</p>
                              )})}
                           {mydata.analysis[0].completed===true?
                            <div>
                              <h5 id="simple-modal-description" align='center'> Solution {solutionIndex()+1} </h5>
                              <div><b>Decomposition</b></div> {commaToText(mydata.decomposition[0].userText)}
                              <div><b>Pattern</b></div>{commaToText(mydata.pattern[0].userText)}
                              <div> <b>Abstraction</b> </div>{commaToText(mydata.abstraction[0].userText)}
                              <div><b>Algorithm</b></div> 
                              {algoNewToText(mydata.algorithm[0].userText)} 
                              <div><b>Analysis</b></div>
                              No. of operations:{mydata.analysis[0].timeText}, No. of variables:{mydata.analysis[0].spaceText} 
                            </div> :null}
                            {mydata.analysis[0].completed===true?
                            <div>
                              <h5 id="simple-modal-description" align='center'>Other possible solutions</h5>
                              
                              {mydata.comparison[0].alternateSolution.map((text, index)=>{
                                var len=0;
                                if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                  len=mydata.decomposition[0].alternateSolution.length
                                }
                                if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                  len=len+mydata.pattern[0].alternateSolution.length
                                }
                                if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                  len=len+mydata.abstraction[0].alternateSolution.length
                                }
                                if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
                                  len=len+mydata.algorithm[0].alternateSolution.length
                                }
                                return(
                                  <div>
                                    <h5 id="simple-modal-description" align='center'> Solution {index+len+2} </h5>
                                    <p><b>Algorithm:</b>{algoNewToText(text.algorithm)}</p>
                                    <p><b>Analysis:</b>{text.analysis}</p>
                                  </div> 
                                )})}
                            </div>
                            :null}
                  </GridItem>
                </GridContainer>
             :<p>You have not attempted any problem</p>}
              </GridItem>
            )
            
          }

        ]}
      />
                
    
    

    </div>:<GridContainer spacing={2}>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Box sx={{ width: 640, marginRight: 2, my: 5, padding: 2 }}>
            <Skeleton animation="wave" variant="rect" width={640} height={400} />    
          </Box>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
          <Box sx={{ width: 640, marginRight: 2, my: 5 }}>
            <Skeleton animation="wave" variant="rect" width={640} height={400} />    
          </Box> 
          </GridItem>
        <GridItem xs={12} sm={12} md={12}>         
          <Skeleton variant="text" />
        </GridItem>
      </GridContainer>
    );
}

